(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wwtelescope/engine"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@wwtelescope/engine", ], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("@wwtelescope/engine"), require("vue"));
	else
		root["index"] = factory(root["wwtlib"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__380__, __WEBPACK_EXTERNAL_MODULE__274__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 197:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(274), __webpack_require__(380));
	else {}
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__274__, __WEBPACK_EXTERNAL_MODULE__380__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 890:
/***/ ((__unused_webpack_module, exports) => {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.A = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 380:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__380__;

/***/ }),

/***/ 274:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__274__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_1513__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_1513__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_1513__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_1513__.o(definition, key) && !__nested_webpack_require_1513__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__nested_webpack_require_1513__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_1513__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_1513__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_1513__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};
// ESM COMPAT FLAG
__nested_webpack_require_1513__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_1513__.d(__nested_webpack_exports__, {
  ImageSetLayerState: () => (/* reexport */ ImageSetLayerState),
  ImagesetInfo: () => (/* reexport */ ImagesetInfo),
  SpreadSheetLayerInfo: () => (/* reexport */ SpreadSheetLayerInfo),
  WWTAwareComponent: () => (/* reexport */ WWTAwareComponent),
  WWTComponent: () => (/* reexport */ Component),
  engineStore: () => (/* reexport */ engineStore),
  wwtPinia: () => (/* reexport */ wwtPinia)
});

;// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_1513__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function tslib_es6_values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ const tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values: tslib_es6_values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __nested_webpack_require_1513__(274);
;// CONCATENATED MODULE: ../node_modules/vue-demi/lib/index.mjs


var lib_isVue2 = false
var isVue3 = true
var Vue2 = (/* unused pure expression or super */ null && (0))

function install() {}

function lib_set(target, key, val) {
  if (Array.isArray(target)) {
    target.length = Math.max(target.length, key)
    target.splice(key, 1, val)
    return val
  }
  target[key] = val
  return val
}

function del(target, key) {
  if (Array.isArray(target)) {
    target.splice(key, 1)
    return
  }
  delete target[key]
}




;// CONCATENATED MODULE: ../node_modules/@vue/devtools-api/lib/esm/env.js
function getDevtoolsGlobalHook() {
    return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
    // @ts-ignore
    return (typeof navigator !== 'undefined' && typeof window !== 'undefined')
        ? window
        : typeof __nested_webpack_require_1513__.g !== 'undefined'
            ? __nested_webpack_require_1513__.g
            : {};
}
const isProxyAvailable = typeof Proxy === 'function';

;// CONCATENATED MODULE: ../node_modules/@vue/devtools-api/lib/esm/const.js
const HOOK_SETUP = 'devtools-plugin:setup';
const HOOK_PLUGIN_SETTINGS_SET = 'plugin:settings:set';

;// CONCATENATED MODULE: ../node_modules/@vue/devtools-api/lib/esm/time.js
let supported;
let perf;
function isPerformanceSupported() {
    var _a;
    if (supported !== undefined) {
        return supported;
    }
    if (typeof window !== 'undefined' && window.performance) {
        supported = true;
        perf = window.performance;
    }
    else if (typeof __nested_webpack_require_1513__.g !== 'undefined' && ((_a = __nested_webpack_require_1513__.g.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        supported = true;
        perf = __nested_webpack_require_1513__.g.perf_hooks.performance;
    }
    else {
        supported = false;
    }
    return supported;
}
function now() {
    return isPerformanceSupported() ? perf.now() : Date.now();
}

;// CONCATENATED MODULE: ../node_modules/@vue/devtools-api/lib/esm/proxy.js


class ApiProxy {
    constructor(plugin, hook) {
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) {
            for (const id in plugin.settings) {
                const item = plugin.settings[id];
                defaultSettings[id] = item.defaultValue;
            }
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        }
        catch (e) {
            // noop
        }
        this.fallbacks = {
            getSettings() {
                return currentSettings;
            },
            setSettings(value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                }
                catch (e) {
                    // noop
                }
                currentSettings = value;
            },
            now() {
                return now();
            },
        };
        if (hook) {
            hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
                if (pluginId === this.plugin.id) {
                    this.fallbacks.setSettings(value);
                }
            });
        }
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop) => {
                if (this.target) {
                    return this.target.on[prop];
                }
                else {
                    return (...args) => {
                        this.onQueue.push({
                            method: prop,
                            args,
                        });
                    };
                }
            },
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop) => {
                if (this.target) {
                    return this.target[prop];
                }
                else if (prop === 'on') {
                    return this.proxiedOn;
                }
                else if (Object.keys(this.fallbacks).includes(prop)) {
                    return (...args) => {
                        this.targetQueue.push({
                            method: prop,
                            args,
                            resolve: () => { },
                        });
                        return this.fallbacks[prop](...args);
                    };
                }
                else {
                    return (...args) => {
                        return new Promise(resolve => {
                            this.targetQueue.push({
                                method: prop,
                                args,
                                resolve,
                            });
                        });
                    };
                }
            },
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue) {
            this.target.on[item.method](...item.args);
        }
        for (const item of this.targetQueue) {
            item.resolve(await this.target[item.method](...item.args));
        }
    }
}

;// CONCATENATED MODULE: ../node_modules/@vue/devtools-api/lib/esm/index.js






function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = getTarget();
    const hook = getDevtoolsGlobalHook();
    const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) {
        hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
    }
    else {
        const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn,
            proxy,
        });
        if (proxy)
            setupFn(proxy.proxiedTarget);
    }
}

;// CONCATENATED MODULE: ../node_modules/pinia/dist/pinia.mjs
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */



/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */
let activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */
// @ts-expect-error: cannot constrain the type of the return
const setActivePinia = (pinia) => (activePinia = pinia);
/**
 * Get the currently active pinia if there is any.
 */
const getActivePinia = () => (hasInjectionContext() && inject(piniaSymbol)) || activePinia;
const piniaSymbol = ((  false) ? 0 : /* istanbul ignore next */ Symbol());

function isPlainObject(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return (o &&
        typeof o === 'object' &&
        Object.prototype.toString.call(o) === '[object Object]' &&
        typeof o.toJSON !== 'function');
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */
var MutationType;
(function (MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */
    MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */
    MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */
    MutationType["patchFunction"] = "patch function";
    // maybe reset? for $state = {} and $reset
})(MutationType || (MutationType = {}));

const IS_CLIENT = typeof window !== 'undefined';
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */
const USE_DEVTOOLS =   false && 0;

/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */
// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const _global = /*#__PURE__*/ (() => typeof window === 'object' && window.window === window
    ? window
    : typeof self === 'object' && self.self === self
        ? self
        : typeof __webpack_require__.g === 'object' && __webpack_require__.g.global === __webpack_require__.g
            ? __webpack_require__.g
            : typeof globalThis === 'object'
                ? globalThis
                : { HTMLElement: null })();
function bom(blob, { autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom &&
        /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xfeff), blob], { type: blob.type });
    }
    return blob;
}
function download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function () {
        saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function () {
        console.error('could not download file');
    };
    xhr.send();
}
function corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    }
    catch (e) { }
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    }
    catch (e) {
        const evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const _navigator = 
 typeof navigator === 'object' ? navigator : { userAgent: '' };
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const isMacOSWebView = /*#__PURE__*/ (() => /Macintosh/.test(_navigator.userAgent) &&
    /AppleWebKit/.test(_navigator.userAgent) &&
    !/Safari/.test(_navigator.userAgent))();
const saveAs = !IS_CLIENT
    ? () => { } // noop
    : // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
        typeof HTMLAnchorElement !== 'undefined' &&
            'download' in HTMLAnchorElement.prototype &&
            !isMacOSWebView
            ? downloadSaveAs
            : // Use msSaveOrOpenBlob as a second approach
                'msSaveOrOpenBlob' in _navigator
                    ? msSaveAs
                    : // Fallback to using FileReader and a popup
                        fileSaverSaveAs;
function downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if (corsEnabled(a.href)) {
                download(blob, name, opts);
            }
            else {
                a.target = '_blank';
                click(a);
            }
        }
        else {
            click(a);
        }
    }
    else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function () {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function () {
            click(a);
        }, 0);
    }
}
function msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if (corsEnabled(blob)) {
            download(blob, name, opts);
        }
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function () {
                click(a);
            });
        }
    }
    else {
        // @ts-ignore: works on windows
        navigator.msSaveOrOpenBlob(bom(blob, opts), name);
    }
}
function fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) {
        popup.document.title = popup.document.body.innerText = 'downloading...';
    }
    if (typeof blob === 'string')
        return download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String(_global.HTMLElement)) || 'safari' in _global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || (force && isSafari) || isMacOSWebView) &&
        typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function () {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS
                ? url
                : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) {
                popup.location.href = url;
            }
            else {
                location.assign(url);
            }
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    }
    else {
        const url = URL.createObjectURL(blob);
        if (popup)
            popup.location.assign(url);
        else
            location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function () {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}

/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */
function toastMessage(message, type) {
    const piniaMessage = '🍍 ' + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') {
        // No longer available :(
        __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    }
    else if (type === 'error') {
        console.error(piniaMessage);
    }
    else if (type === 'warn') {
        console.warn(piniaMessage);
    }
    else {
        console.log(piniaMessage);
    }
}
function isPinia(o) {
    return '_a' in o && 'install' in o;
}

/**
 * This file contain devtools actions, they are not Pinia actions.
 */
// ---
function checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function checkNotFocusedError(error) {
    if (error instanceof Error &&
        error.message.toLowerCase().includes('document is not focused')) {
        toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function actionGlobalCopyState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        toastMessage('Global state copied to clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalPasteState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        toastMessage('Global state pasted from clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalSaveState(pinia) {
    try {
        saveAs(new Blob([JSON.stringify(pinia.state.value)], {
            type: 'text/plain;charset=utf-8',
        }), 'pinia-state.json');
    }
    catch (error) {
        toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let fileInput;
function getFileOpener() {
    if (!fileInput) {
        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject) => {
            fileInput.onchange = async () => {
                const files = fileInput.files;
                if (!files)
                    return resolve(null);
                const file = files.item(0);
                if (!file)
                    return resolve(null);
                return resolve({ text: await file.text(), file });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            fileInput.oncancel = () => resolve(null);
            fileInput.onerror = reject;
            fileInput.click();
        });
    }
    return openFile;
}
async function actionGlobalOpenStateFile(pinia) {
    try {
        const open = getFileOpener();
        const result = await open();
        if (!result)
            return;
        const { text, file } = result;
        loadStoresState(pinia, JSON.parse(text));
        toastMessage(`Global state imported from "${file.name}".`);
    }
    catch (error) {
        toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function loadStoresState(pinia, state) {
    for (const key in state) {
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) {
            Object.assign(storeState, state[key]);
        }
        else {
            // store is not instantiated, set the initial state
            pinia.state.value[key] = state[key];
        }
    }
}

function formatDisplay(display) {
    return {
        _custom: {
            display,
        },
    };
}
const PINIA_ROOT_LABEL = '🍍 Pinia (root)';
const PINIA_ROOT_ID = '_root';
function formatStoreForInspectorTree(store) {
    return isPinia(store)
        ? {
            id: PINIA_ROOT_ID,
            label: PINIA_ROOT_LABEL,
        }
        : {
            id: store.$id,
            label: store.$id,
        };
}
function formatStoreForInspectorState(store) {
    if (isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId) => ({
                editable: true,
                key: storeId,
                value: store.state.value[storeId],
            })),
            getters: storeNames
                .filter((id) => storeMap.get(id)._getters)
                .map((id) => {
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key) => {
                        getters[key] = store[key];
                        return getters;
                    }, {}),
                };
            }),
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key) => ({
            editable: true,
            key,
            value: store.$state[key],
        })),
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) {
        state.getters = store._getters.map((getterName) => ({
            editable: false,
            key: getterName,
            value: store[getterName],
        }));
    }
    if (store._customProperties.size) {
        state.customProperties = Array.from(store._customProperties).map((key) => ({
            editable: true,
            key,
            value: store[key],
        }));
    }
    return state;
}
function formatEventData(events) {
    if (!events)
        return {};
    if (Array.isArray(events)) {
        // TODO: handle add and delete for arrays and objects
        return events.reduce((data, event) => {
            data.keys.push(event.key);
            data.operations.push(event.type);
            data.oldValue[event.key] = event.oldValue;
            data.newValue[event.key] = event.newValue;
            return data;
        }, {
            oldValue: {},
            keys: [],
            operations: [],
            newValue: {},
        });
    }
    else {
        return {
            operation: formatDisplay(events.type),
            key: formatDisplay(events.key),
            oldValue: events.oldValue,
            newValue: events.newValue,
        };
    }
}
function formatMutationType(type) {
    switch (type) {
        case MutationType.direct:
            return 'mutation';
        case MutationType.patchFunction:
            return '$patch';
        case MutationType.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}

// timeline can be paused when directly changing the state
let isTimelineActive = true;
const componentStateTypes = [];
const MUTATIONS_LAYER_ID = 'pinia:mutations';
const INSPECTOR_ID = 'pinia';
const { assign: assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */
const getStoreType = (id) => '🍍 ' + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */
function registerPiniaDevtools(app, pinia) {
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
    }, (api) => {
        if (typeof api.now !== 'function') {
            toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        }
        api.addTimelineLayer({
            id: MUTATIONS_LAYER_ID,
            label: `Pinia 🍍`,
            color: 0xe5df88,
        });
        api.addInspector({
            id: INSPECTOR_ID,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: () => {
                        actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state',
                },
                {
                    icon: 'content_paste',
                    action: async () => {
                        await actionGlobalPasteState(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard',
                },
                {
                    icon: 'save',
                    action: () => {
                        actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file',
                },
                {
                    icon: 'folder_open',
                    action: async () => {
                        await actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file',
                },
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId) => {
                        const store = pinia._s.get(nodeId);
                        if (!store) {
                            toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        }
                        else if (typeof store.$reset !== 'function') {
                            toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        }
                        else {
                            store.$reset();
                            toastMessage(`Store "${nodeId}" reset.`);
                        }
                    },
                },
            ],
        });
        api.on.inspectComponent((payload, ctx) => {
            const proxy = (payload.componentInstance &&
                payload.componentInstance.proxy);
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store) => {
                    payload.instanceData.state.push({
                        type: getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI
                            ? {
                                _custom: {
                                    value: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRaw)(store.$state),
                                    actions: [
                                        {
                                            icon: 'restore',
                                            tooltip: 'Reset the state of this store',
                                            action: () => store.$reset(),
                                        },
                                    ],
                                },
                            }
                            : // NOTE: workaround to unwrap transferred refs
                                Object.keys(store.$state).reduce((state, key) => {
                                    state[key] = store.$state[key];
                                    return state;
                                }, {}),
                    });
                    if (store._getters && store._getters.length) {
                        payload.instanceData.state.push({
                            type: getStoreType(store.$id),
                            key: 'getters',
                            editable: false,
                            value: store._getters.reduce((getters, key) => {
                                try {
                                    getters[key] = store[key];
                                }
                                catch (error) {
                                    // @ts-expect-error: we just want to show it in devtools
                                    getters[key] = error;
                                }
                                return getters;
                            }, {}),
                        });
                    }
                });
            }
        });
        api.on.getInspectorTree((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                let stores = [pinia];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter
                    ? stores.filter((store) => '$id' in store
                        ? store.$id
                            .toLowerCase()
                            .includes(payload.filter.toLowerCase())
                        : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase()))
                    : stores).map(formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    // this could be the selected store restored for a different project
                    // so it's better not to say anything here
                    return;
                }
                if (inspectedStore) {
                    payload.state = formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload, ctx) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    return toastMessage(`store "${payload.nodeId}" not found`, 'error');
                }
                const { path } = payload;
                if (!isPinia(inspectedStore)) {
                    // access only the state
                    if (path.length !== 1 ||
                        !inspectedStore._customProperties.has(path[0]) ||
                        path[0] in inspectedStore.$state) {
                        path.unshift('$state');
                    }
                }
                else {
                    // Root access, we can omit the `.value` because the devtools API does it for us
                    path.unshift('state');
                }
                isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload) => {
            if (payload.type.startsWith('🍍')) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) {
                    return toastMessage(`store "${storeId}" not found`, 'error');
                }
                const { path } = payload;
                if (path[0] !== 'state') {
                    return toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                }
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                isTimelineActive = true;
            }
        });
    });
}
function addStoreToDevtools(app, store) {
    if (!componentStateTypes.includes(getStoreType(store.$id))) {
        componentStateTypes.push(getStoreType(store.$id));
    }
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true,
            },
            // useEmojis: {
            //   label: 'Use emojis in messages ⚡️',
            //   type: 'boolean',
            //   defaultValue: true,
            // },
        },
    }, (api) => {
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after, onError, name, args }) => {
            const groupId = runningActionId++;
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🛫 ' + name,
                    subtitle: 'start',
                    data: {
                        store: formatDisplay(store.$id),
                        action: formatDisplay(name),
                        args,
                    },
                    groupId,
                },
            });
            after((result) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: '🛬 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            result,
                        },
                        groupId,
                    },
                });
            });
            onError((error) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: '💥 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            error,
                        },
                        groupId,
                    },
                });
            });
        }, true);
        store._customProperties.forEach((name) => {
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(store[name]), (newValue, oldValue) => {
                api.notifyComponentUpdate();
                api.sendInspectorState(INSPECTOR_ID);
                if (isTimelineActive) {
                    api.addTimelineEvent({
                        layerId: MUTATIONS_LAYER_ID,
                        event: {
                            time: now(),
                            title: 'Change',
                            subtitle: name,
                            data: {
                                newValue,
                                oldValue,
                            },
                            groupId: activeAction,
                        },
                    });
                }
            }, { deep: true });
        });
        store.$subscribe(({ events, type }, state) => {
            api.notifyComponentUpdate();
            api.sendInspectorState(INSPECTOR_ID);
            if (!isTimelineActive)
                return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: formatMutationType(type),
                data: assign$1({ store: formatDisplay(store.$id) }, formatEventData(events)),
                groupId: activeAction,
            };
            if (type === MutationType.patchFunction) {
                eventData.subtitle = '⤵️';
            }
            else if (type === MutationType.patchObject) {
                eventData.subtitle = '🧩';
            }
            else if (events && !Array.isArray(events)) {
                eventData.subtitle = events.type;
            }
            if (events) {
                eventData.data['rawEvent(s)'] = {
                    _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: events,
                    },
                };
            }
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: eventData,
            });
        }, { detached: true, flush: 'sync' });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)((newStore) => {
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🔥 ' + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: formatDisplay(store.$id),
                        info: formatDisplay(`HMR update`),
                    },
                },
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
        });
        const { $dispose } = store;
        store.$dispose = () => {
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
            api.getSettings().logStoreChanges &&
                toastMessage(`Disposed "${store.$id}" store 🗑`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree(INSPECTOR_ID);
        api.sendInspectorState(INSPECTOR_ID);
        api.getSettings().logStoreChanges &&
            toastMessage(`"${store.$id}" store installed 🆕`);
    });
}
let runningActionId = 0;
let activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */
function patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName) => {
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for (const actionName in actions) {
        store[actionName] = function () {
            // the running action id is incremented in a before action hook
            const _actionId = runningActionId;
            const trackedStore = wrapWithProxy
                ? new Proxy(store, {
                    get(...args) {
                        activeAction = _actionId;
                        return Reflect.get(...args);
                    },
                    set(...args) {
                        activeAction = _actionId;
                        return Reflect.set(...args);
                    },
                })
                : store;
            // For Setup Stores we need https://github.com/tc39/proposal-async-context
            activeAction = _actionId;
            const retValue = actions[actionName].apply(trackedStore, arguments);
            // this is safer as async actions in Setup Stores would associate mutations done outside of the action
            activeAction = undefined;
            return retValue;
        };
    }
}
/**
 * pinia.use(devtoolsPlugin)
 */
function devtoolsPlugin({ app, store, options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) {
        return;
    }
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
    // Upgrade the HMR to also update the new actions
    const originalHotUpdate = store._hotUpdate;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRaw)(store)._hotUpdate = function (newStore) {
        originalHotUpdate.apply(this, arguments);
        patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
    };
    addStoreToDevtools(app, 
    // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}

/**
 * Creates a Pinia instance to be used by the application
 */
function createPinia() {
    const scope = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(() => (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)({
        install(app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            setActivePinia(pinia);
            if (!lib_isVue2) {
                pinia._a = app;
                app.provide(piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(app, pinia);
                }
                toBeInstalled.forEach((plugin) => _p.push(plugin));
                toBeInstalled = [];
            }
        },
        use(plugin) {
            if (!this._a && !lib_isVue2) {
                toBeInstalled.push(plugin);
            }
            else {
                _p.push(plugin);
            }
            return this;
        },
        _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state,
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (USE_DEVTOOLS && typeof Proxy !== 'undefined') {
        pinia.use(devtoolsPlugin);
    }
    return pinia;
}

/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */
const isUseStore = (fn) => {
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */
function patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in oldState) {
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) {
            continue;
        }
        const targetValue = newState[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            !isRef(subPatch) &&
            !isReactive(subPatch)) {
            newState[key] = patchObject(targetValue, subPatch);
        }
        else {
            // objects are either a bit more complex (e.g. refs) or primitives, so we
            // just set the whole thing
            if (isVue2) {
                set(newState, key, subPatch);
            }
            else {
                newState[key] = subPatch;
            }
        }
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */
function acceptHMRUpdate(initialUseStore, hot) {
    // strip as much as possible from iife.prod
    if (true) {
        return () => { };
    }
    return (newModule) => {
        const pinia = hot.data.pinia || initialUseStore._pinia;
        if (!pinia) {
            // this store is still not used
            return;
        }
        // preserve the pinia instance across loads
        hot.data.pinia = pinia;
        // console.log('got data', newStore)
        for (const exportName in newModule) {
            const useStore = newModule[exportName];
            // console.log('checking for', exportName)
            if (isUseStore(useStore) && pinia._s.has(useStore.$id)) {
                // console.log('Accepting update for', useStore.$id)
                const id = useStore.$id;
                if (id !== initialUseStore.$id) {
                    console.warn(`The id of the store changed from "${initialUseStore.$id}" to "${id}". Reloading.`);
                    // return import.meta.hot.invalidate()
                    return hot.invalidate();
                }
                const existingStore = pinia._s.get(id);
                if (!existingStore) {
                    console.log(`[Pinia]: skipping hmr because store doesn't exist yet`);
                    return;
                }
                useStore(pinia, existingStore);
            }
        }
    };
}

const noop = () => { };
function addSubscription(subscriptions, callback, detached, onCleanup = noop) {
    subscriptions.push(callback);
    const removeSubscription = () => {
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0,external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentScope)()) {
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onScopeDispose)(removeSubscription);
    }
    return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback) => {
        callback(...args);
    });
}

const fallbackRunWithContext = (fn) => fn();
function mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) {
        patchToApply.forEach((value, key) => target.set(key, value));
    }
    // Handle Set instances
    if (target instanceof Set && patchToApply instanceof Set) {
        patchToApply.forEach(target.add, target);
    }
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in patchToApply) {
        if (!patchToApply.hasOwnProperty(key))
            continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            target.hasOwnProperty(key) &&
            !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(subPatch) &&
            !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.isReactive)(subPatch)) {
            // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
            // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
            // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
            target[key] = mergeReactiveObjects(targetValue, subPatch);
        }
        else {
            // @ts-expect-error: subPatch is a valid value
            target[key] = subPatch;
        }
    }
    return target;
}
const skipHydrateSymbol = (  false)
    ? 0
    : /* istanbul ignore next */ Symbol();
const skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */
function skipHydrate(obj) {
    return isVue2
        ? // in @vue/composition-api, the refs are sealed so defineProperty doesn't work...
            /* istanbul ignore next */ skipHydrateMap.set(obj, 1) && obj
        : Object.defineProperty(obj, skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */
function shouldHydrate(obj) {
    return lib_isVue2
        ? /* istanbul ignore next */ !skipHydrateMap.has(obj)
        : !isPlainObject(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
const { assign: pinia_assign } = Object;
function isComputed(o) {
    return !!((0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
    const { state, actions, getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && (  true || 0)) {
            /* istanbul ignore if */
            if (lib_isVue2) {
                lib_set(pinia.state.value, id, state ? state() : {});
            }
            else {
                pinia.state.value[id] = state ? state() : {};
            }
        }
        // avoid creating a state in pinia.state.value
        const localState =   false
            ? // use ref() to unwrap refs inside state TODO: check if this is still necessary
                0
            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRefs)(pinia.state.value[id]);
        return pinia_assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
            if (false) {}
            computedGetters[name] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
                setActivePinia(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */
                if (lib_isVue2 && !store._r)
                    return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = pinia_assign({ actions: {} }, options);
    /* istanbul ignore if */
    if (false) {}
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true,
        // flush: 'post',
    };
    /* istanbul ignore else */
    if (false) {}
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && (  true || 0)) {
        /* istanbul ignore if */
        if (lib_isVue2) {
            lib_set(pinia.state.value, $id, {});
        }
        else {
            pinia.state.value[$id] = {};
        }
    }
    const hotState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        // reset the debugger events since patches are sync
        /* istanbul ignore else */
        if ((false)) {}
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: MutationType.patchFunction,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        else {
            mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: MutationType.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        const myListenerId = (activeListener = Symbol());
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)().then(() => {
            if (activeListener === myListenerId) {
                isListening = true;
            }
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore
        ? function $reset() {
            const { state } = options;
            const newState = state ? state() : {};
            // we use a patch to group all changes into one single subscription
            this.$patch(($state) => {
                pinia_assign($state, newState);
            });
        }
        : /* istanbul ignore next */
            (  false)
                ? 0
                : noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */
    function wrapAction(name, action) {
        return function () {
            setActivePinia(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            triggerSubscriptions(actionSubscriptions, {
                args,
                name,
                store,
                after,
                onError,
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
                // handle sync errors
            }
            catch (error) {
                triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) {
                return ret
                    .then((value) => {
                    triggerSubscriptions(afterCallbackList, value);
                    return value;
                })
                    .catch((error) => {
                    triggerSubscriptions(onErrorCallbackList, error);
                    return Promise.reject(error);
                });
            }
            // trigger after callbacks
            triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState,
    });
    const partialStore = {
        _p: pinia,
        // _s: scope,
        $id,
        $onAction: addSubscription.bind(null, actionSubscriptions),
        $patch,
        $reset,
        $subscribe(callback, options = {}) {
            const removeSubscription = addSubscription(subscriptions, callback, options.detached, () => stopWatcher());
            const stopWatcher = scope.run(() => (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => pinia.state.value[$id], (state) => {
                if (options.flush === 'sync' ? isSyncListening : isListening) {
                    callback({
                        storeId: $id,
                        type: MutationType.direct,
                        events: debuggerEvents,
                    }, state);
                }
            }, pinia_assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose,
    };
    /* istanbul ignore if */
    if (lib_isVue2) {
        // start as non ready
        partialStore._r = false;
    }
    const store = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)((  false) || USE_DEVTOOLS
        ? pinia_assign({
            _hmrPayload,
            _customProperties: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)(new Set()), // devtools custom properties
        }, partialStore
        // must be added later
        // setupStore
        )
        : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = (pinia._a && pinia._a.runWithContext) || fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(() => pinia._e.run(() => (scope = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.effectScope)()).run(setup)));
    // overwrite existing actions to support $onAction
    for (const key in setupStore) {
        const prop = setupStore[key];
        if (((0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(prop) && !isComputed(prop)) || (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isReactive)(prop)) {
            // mark it as a piece of state to be serialized
            if (false) {}
            else if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && shouldHydrate(prop)) {
                    if ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(prop)) {
                        prop.value = initialState[key];
                    }
                    else {
                        // probably a reactive object, lets recursively assign
                        // @ts-expect-error: prop is unknown
                        mergeReactiveObjects(prop, initialState[key]);
                    }
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */
                if (lib_isVue2) {
                    lib_set(pinia.state.value[$id], key, prop);
                }
                else {
                    pinia.state.value[$id][key] = prop;
                }
            }
            /* istanbul ignore else */
            if ((false)) {}
            // action
        }
        else if (typeof prop === 'function') {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue =   false ? 0 : wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */
            if (lib_isVue2) {
                lib_set(setupStore, key, actionValue);
            }
            else {
                // @ts-expect-error
                setupStore[key] = actionValue;
            }
            /* istanbul ignore else */
            if ((false)) {}
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
        else if ((false)) {}
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */
    if (lib_isVue2) {
        Object.keys(setupStore).forEach((key) => {
            lib_set(store, key, setupStore[key]);
        });
    }
    else {
        pinia_assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        pinia_assign((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRaw)(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: () => (  false ? 0 : pinia.state.value[$id]),
        set: (state) => {
            /* istanbul ignore if */
            if (false) {}
            $patch(($state) => {
                pinia_assign($state, state);
            });
        },
    });
    // add the hotUpdate before plugins to allow them to override it
    /* istanbul ignore else */
    if ((false)) {}
    if (USE_DEVTOOLS) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false,
        };
        ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((p) => {
            Object.defineProperty(store, p, pinia_assign({ value: store[p] }, nonEnumerable));
        });
    }
    /* istanbul ignore if */
    if (lib_isVue2) {
        // mark the store as ready before plugins
        store._r = true;
    }
    // apply all plugins
    pinia._p.forEach((extender) => {
        /* istanbul ignore else */
        if (USE_DEVTOOLS) {
            const extensions = scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            }));
            Object.keys(extensions || {}).forEach((key) => store._customProperties.add(key));
            pinia_assign(store, extensions);
        }
        else {
            pinia_assign(store, scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            })));
        }
    });
    if (false) {}
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState &&
        isOptionsStore &&
        options.hydrate) {
        options.hydrate(store.$state, initialState);
    }
    isListening = true;
    isSyncListening = true;
    return store;
}
function defineStore(
// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === 'function';
    if (typeof idOrOptions === 'string') {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    }
    else {
        options = idOrOptions;
        id = idOrOptions.id;
        if (false) {}
    }
    function useStore(pinia, hot) {
        const hasContext = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.hasInjectionContext)();
        pinia =
            // in test mode, ignore the argument provided as we can always retrieve a
            // pinia instance with getActivePinia()
            (  false ? 0 : pinia) ||
                (hasContext ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(piniaSymbol, null) : null);
        if (pinia)
            setActivePinia(pinia);
        if (false) {}
        pinia = activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) {
                createSetupStore(id, setup, options, pinia);
            }
            else {
                createOptionsStore(id, options, pinia);
            }
            /* istanbul ignore else */
            if ((false)) {}
        }
        const store = pinia._s.get(id);
        if (false) {}
        if (false) {}
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}

let mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */
function setMapStoreSuffix(suffix // could be 'Store' but that would be annoying for JS
) {
    mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */
function mapStores(...stores) {
    if (false) {}
    return stores.reduce((reduced, useStore) => {
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + mapStoreSuffix] = function () {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            reduced[key] = function () {
                return useStore(this.$pinia)[key];
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function () {
                const store = useStore(this.$pinia);
                const storeKey = keysOrMapper[key];
                // for some reason TS is unable to infer the type of storeKey to be a
                // function
                return typeof storeKey === 'function'
                    ? storeKey.call(this, store)
                    : store[storeKey];
            };
            return reduced;
        }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */
const mapGetters = (/* unused pure expression or super */ null && (0));
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapActions(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[key](...args);
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[keysOrMapper[key]](...args);
            };
            return reduced;
        }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapWritableState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[key];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[key] = value);
                },
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[keysOrMapper[key]];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[keysOrMapper[key]] = value);
                },
            };
            return reduced;
        }, {});
}

/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */
function storeToRefs(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (isVue2) {
        // @ts-expect-error: toRefs include methods and others
        return toRefs(store);
    }
    else {
        store = toRaw(store);
        const refs = {};
        for (const key in store) {
            const value = store[key];
            if (isRef(value) || isReactive(value)) {
                // @ts-expect-error: the key is state or getter
                refs[key] =
                    // ---
                    toRef(store, key);
            }
        }
        return refs;
    }
}

/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */
const PiniaVuePlugin = function (_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate() {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */
                if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, '_provided', {
                        get: () => provideCache,
                        set: (v) => Object.assign(provideCache, v),
                    });
                }
                this._provided[piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */
                if (!this.$pinia) {
                    this.$pinia = pinia;
                }
                pinia._a = this;
                if (IS_CLIENT) {
                    // this allows calling useStore() outside of a component setup after
                    // installing pinia's plugin
                    setActivePinia(pinia);
                }
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(pinia._a, pinia);
                }
            }
            else if (!this.$pinia && options.parent && options.parent.$pinia) {
                this.$pinia = options.parent.$pinia;
            }
        },
        destroyed() {
            delete this._pStores;
        },
    });
};



;// CONCATENATED MODULE: ../astro/dist/src/index.js
// Copyright 2020 the .NET Foundation
// Licensed under the MIT License
/** The mathematical constant pi, around 3.14. */
var PI = 3.14159265358979;
/** Two times the mathematical constan pi, around 6.28. */
var TWOPI = 2 * PI;
/** Radians-to-degrees conversion factor.
 *
 * ```
 * let degrees = radians * R2D;
 * ```
 */
var R2D = 180 / PI;
/** Degrees-to-radians conversion factor.
 *
 * ```
 * let radians = degrees * D2R;
 * ```
 */
var D2R = PI / 180;
/** Radians-to-hours conversion factor.
 *
 * ```
 * let hours = radians * R2H;
 * ```
 */
var R2H = 12 / PI;
/** Hours-to-radians conversion factor.
 *
 * ```
 * let radians = hours * H2R;
 * ```
 */
var H2R = PI / 12;
/** Degrees-to-hours conversion factor.
 *
 * ```
 * let hours = degrees * D2H;
 * ```
 */
var D2H = 12. / 180;
/** Hours-to-degrees conversion factor.
 *
 * ```
 * let degrees = hours * H2D;
 * ```
 */
var H2D = 15;
/** Normalize an angle in radians to lie between 0 and 2pi.
 *
 * @param angleRad The input angle, in radians.
 * @returns An equivalent angle, also in radians.
 */
function angnorm(angleRad) {
    while (angleRad < 0)
        angleRad += TWOPI;
    while (angleRad >= TWOPI)
        angleRad -= TWOPI;
    return angleRad;
}
/**
 * Find the great-circle distance between two points
 *
 * This implementation uses a special case of the Vincenty formula
 * See the last formula in https://en.wikipedia.org/wiki/Great-circle_distance#Computational_formulas
 *
 * @param ra1 The right ascension of the first point, in radians
 * @param dec1 The declination of the first point, in radians
 * @param ra2 The right ascension of the second point, in radians
 * @param dec2 The declination of the second point, in radians
 * @returns The great-circle distance
 */
function distance(ra1, dec1, ra2, dec2) {
    var dAbsRA = Math.abs(ra1 - ra2);
    var nt1 = Math.pow((Math.cos(dec2) * Math.sin(dAbsRA)), 2);
    var nt2 = Math.pow((Math.cos(dec1) * Math.sin(dec2) - Math.sin(dec1) * Math.cos(dec2) * Math.cos(dAbsRA)), 2);
    var num = Math.sqrt(nt1 + nt2);
    var den = Math.sin(dec1) * Math.sin(dec2) + Math.cos(dec1) * Math.cos(dec2) * Math.cos(dAbsRA);
    return Math.atan2(num, den);
}
function formatSexagesimal(options) {
    var _a;
    var prefix = "";
    var value = options.value;
    if (value < 0) {
        value = -value;
        prefix = "-";
    }
    else if (options.showPlus) {
        prefix = "+";
    }
    var whole = Math.floor(value);
    value = (value - whole) * 60;
    var minutes = Math.floor(value);
    value = (value - minutes) * 60;
    var seconds = Math.floor(value);
    var remainder = value - seconds;
    var wText = String(whole).padStart(options.padWhole, '0');
    var mText = String(minutes).padStart(2, '0');
    var sText = String(seconds).padStart(2, '0');
    var rText = remainder.toFixed(options.precision).slice(1); // drop the leading "0"
    var suffix = (_a = options.suffix) !== null && _a !== void 0 ? _a : "";
    var sep1 = options.firstSeparator;
    var sep2 = options.secondSeparator;
    return "".concat(prefix).concat(wText).concat(sep1).concat(mText).concat(sep2).concat(sText).concat(rText).concat(suffix);
}
/** Format an angle, measured in radians, as sexagesimal hours.
 *
 * Before formatting, the angle is normalized to lie within 0-2pi.
 *
 * @param angleRad The angle in radians.
 * @param sep1 The text to put between the hours and the minutes. Defaults to
 * `":"`.
 * @param sep2 The text to put between the minutes and the seconds. Defaults to
 * `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtHours(angleRad, sep1, sep2, precision, suffix) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    if (suffix === void 0) { suffix = ""; }
    return formatSexagesimal({
        value: angnorm(angleRad) * R2H,
        showPlus: false,
        padWhole: 2,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
        suffix: suffix,
    });
}
/** Format a latitudinal angle, measured in radians, as sexagesimal degrees.
 *
 * If the number is not in the range [-pi, pi], `" ??${sep1}??${sep2}??"` is
 * returned.
 *
 * @param angleRad The latitude in radians.
 * @param sep1 The text to put between the degrees and the arcminutes. Defaults
 * to `":"`.
 * @param sep2 The text to put between the arcminutes and the arcseconds.
 * Defaults to `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtDegLat(angleRad, sep1, sep2, precision) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    if (angleRad < -PI || angleRad > PI)
        return " ??".concat(sep1, "??").concat(sep2, "??");
    return formatSexagesimal({
        value: angleRad * R2D,
        showPlus: true,
        padWhole: 2,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
    });
}
/** Format a longitudinal angle, measured in radians, as sexagesimal degrees.
 *
 * Before formatting, the angle is normalized to lie within 0-2pi. The output
 * will be zero-padded to three digits, e.g. `"000:01:30"` or `"359:59:59.123"`.
 *
 * @param angleRad The longitude in radians.
 * @param sep1 The text to put between the degrees and the arcminutes. Defaults
 * to `":"`.
 * @param sep2 The text to put between the arcminutes and the arcseconds.
 * Defaults to `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtDegLon(angleRad, sep1, sep2, precision) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    return formatSexagesimal({
        value: angnorm(angleRad) * R2D,
        showPlus: false,
        padWhole: 3,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
    });
}
function formatDecimalHours(dayFraction, sep) {
    if (sep === void 0) { sep = ":"; }
    // Looks like a timezone correction?
    var ts = new Date(new Date().toUTCString()).valueOf() - new Date().valueOf();
    var hr = ts / (1000 * 60 * 60);
    var day = (dayFraction - hr);
    while (day > 24) {
        day -= 24;
    }
    while (day < 0) {
        day += 24;
    }
    var hours = Math.floor(day);
    var minutes = ((day * 60) - (hours * 60)).toFixed(0);
    return [hours, minutes].map(function (n) { return n.toString().padStart(2, '0'); }).join(sep);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../engine-types/dist/src/index.js
/* eslint-disable no-unused-vars */

// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License
//
// Based types used in the WWT WebGL engine.
//
// Try to keep everything alphabetized.
var AltTypes;
(function (AltTypes) {
    AltTypes[AltTypes["depth"] = 0] = "depth";
    AltTypes[AltTypes["altitude"] = 1] = "altitude";
    AltTypes[AltTypes["distance"] = 2] = "distance";
    AltTypes[AltTypes["seaLevel"] = 3] = "seaLevel";
    AltTypes[AltTypes["terrain"] = 4] = "terrain";
})(AltTypes || (AltTypes = {}));
var AltUnits;
(function (AltUnits) {
    AltUnits[AltUnits["meters"] = 1] = "meters";
    AltUnits[AltUnits["feet"] = 2] = "feet";
    AltUnits[AltUnits["inches"] = 3] = "inches";
    AltUnits[AltUnits["miles"] = 4] = "miles";
    AltUnits[AltUnits["kilometers"] = 5] = "kilometers";
    AltUnits[AltUnits["astronomicalUnits"] = 6] = "astronomicalUnits";
    AltUnits[AltUnits["lightYears"] = 7] = "lightYears";
    AltUnits[AltUnits["parsecs"] = 8] = "parsecs";
    AltUnits[AltUnits["megaParsecs"] = 9] = "megaParsecs";
    AltUnits[AltUnits["custom"] = 10] = "custom";
})(AltUnits || (AltUnits = {}));
var BandPass;
(function (BandPass) {
    BandPass[BandPass["gamma"] = 0] = "gamma";
    BandPass[BandPass["xRay"] = 1] = "xRay";
    BandPass[BandPass["ultraviolet"] = 2] = "ultraviolet";
    BandPass[BandPass["visible"] = 3] = "visible";
    BandPass[BandPass["hydrogenAlpha"] = 4] = "hydrogenAlpha";
    BandPass[BandPass["IR"] = 4] = "IR";
    BandPass[BandPass["microwave"] = 5] = "microwave";
    BandPass[BandPass["radio"] = 6] = "radio";
    BandPass[BandPass["visibleNight"] = 6] = "visibleNight";
})(BandPass || (BandPass = {}));
var Classification;
(function (Classification) {
    Classification[Classification["star"] = 1] = "star";
    Classification[Classification["supernova"] = 2] = "supernova";
    Classification[Classification["blackHole"] = 4] = "blackHole";
    Classification[Classification["neutronStar"] = 8] = "neutronStar";
    Classification[Classification["doubleStar"] = 16] = "doubleStar";
    Classification[Classification["multipleStars"] = 32] = "multipleStars";
    Classification[Classification["asterism"] = 64] = "asterism";
    Classification[Classification["constellation"] = 128] = "constellation";
    Classification[Classification["openCluster"] = 256] = "openCluster";
    Classification[Classification["globularCluster"] = 512] = "globularCluster";
    Classification[Classification["nebulousCluster"] = 1024] = "nebulousCluster";
    Classification[Classification["nebula"] = 2048] = "nebula";
    Classification[Classification["emissionNebula"] = 4096] = "emissionNebula";
    Classification[Classification["planetaryNebula"] = 8192] = "planetaryNebula";
    Classification[Classification["reflectionNebula"] = 16384] = "reflectionNebula";
    Classification[Classification["darkNebula"] = 32768] = "darkNebula";
    Classification[Classification["giantMolecularCloud"] = 65536] = "giantMolecularCloud";
    Classification[Classification["supernovaRemnant"] = 131072] = "supernovaRemnant";
    Classification[Classification["interstellarDust"] = 262144] = "interstellarDust";
    Classification[Classification["quasar"] = 524288] = "quasar";
    Classification[Classification["galaxy"] = 1048576] = "galaxy";
    Classification[Classification["spiralGalaxy"] = 2097152] = "spiralGalaxy";
    Classification[Classification["irregularGalaxy"] = 4194304] = "irregularGalaxy";
    Classification[Classification["ellipticalGalaxy"] = 8388608] = "ellipticalGalaxy";
    Classification[Classification["knot"] = 16777216] = "knot";
    Classification[Classification["plateDefect"] = 33554432] = "plateDefect";
    Classification[Classification["clusterOfGalaxies"] = 67108864] = "clusterOfGalaxies";
    Classification[Classification["otherNGC"] = 134217728] = "otherNGC";
    Classification[Classification["unidentified"] = 268435456] = "unidentified";
    Classification[Classification["solarSystem"] = 536870912] = "solarSystem";
    Classification[Classification["unfiltered"] = 1073741823] = "unfiltered";
    Classification[Classification["stellar"] = 63] = "stellar";
    Classification[Classification["stellarGroupings"] = 2032] = "stellarGroupings";
    Classification[Classification["nebulae"] = 523264] = "nebulae";
    Classification[Classification["galactic"] = 133693440] = "galactic";
    Classification[Classification["other"] = 436207616] = "other";
})(Classification || (Classification = {}));
var CoordinatesType;
(function (CoordinatesType) {
    CoordinatesType[CoordinatesType["spherical"] = 0] = "spherical";
    CoordinatesType[CoordinatesType["rectangular"] = 1] = "rectangular";
    CoordinatesType[CoordinatesType["orbital"] = 2] = "orbital";
})(CoordinatesType || (CoordinatesType = {}));
var DataTypes;
(function (DataTypes) {
    DataTypes[DataTypes["byteT"] = 0] = "byteT";
    DataTypes[DataTypes["int16T"] = 1] = "int16T";
    DataTypes[DataTypes["int32T"] = 2] = "int32T";
    DataTypes[DataTypes["floatT"] = 3] = "floatT";
    DataTypes[DataTypes["doubleT"] = 4] = "doubleT";
    DataTypes[DataTypes["none"] = 5] = "none";
})(DataTypes || (DataTypes = {}));
var FadeType;
(function (FadeType) {
    FadeType[FadeType["fadeIn"] = 1] = "fadeIn";
    FadeType[FadeType["fadeOut"] = 2] = "fadeOut";
    FadeType[FadeType["both"] = 3] = "both";
    FadeType[FadeType["none"] = 4] = "none";
})(FadeType || (FadeType = {}));
var FolderGroup;
(function (FolderGroup) {
    FolderGroup[FolderGroup["explorer"] = 0] = "explorer";
    FolderGroup[FolderGroup["tour"] = 1] = "tour";
    FolderGroup[FolderGroup["search"] = 2] = "search";
    FolderGroup[FolderGroup["constellation"] = 3] = "constellation";
    FolderGroup[FolderGroup["view"] = 4] = "view";
    FolderGroup[FolderGroup["goTo"] = 5] = "goTo";
    FolderGroup[FolderGroup["community"] = 6] = "community";
    FolderGroup[FolderGroup["context"] = 7] = "context";
    FolderGroup[FolderGroup["voTable"] = 8] = "voTable";
    FolderGroup[FolderGroup["imageStack"] = 9] = "imageStack";
})(FolderGroup || (FolderGroup = {}));
var FolderRefreshType;
(function (FolderRefreshType) {
    FolderRefreshType[FolderRefreshType["interval"] = 0] = "interval";
    FolderRefreshType[FolderRefreshType["conditionalGet"] = 1] = "conditionalGet";
    FolderRefreshType[FolderRefreshType["viewChange"] = 2] = "viewChange";
})(FolderRefreshType || (FolderRefreshType = {}));
var FolderType;
(function (FolderType) {
    FolderType[FolderType["earth"] = 0] = "earth";
    FolderType[FolderType["planet"] = 1] = "planet";
    FolderType[FolderType["sky"] = 2] = "sky";
    FolderType[FolderType["panorama"] = 3] = "panorama";
})(FolderType || (FolderType = {}));
var ImageSetType;
(function (ImageSetType) {
    ImageSetType[ImageSetType["earth"] = 0] = "earth";
    ImageSetType[ImageSetType["planet"] = 1] = "planet";
    ImageSetType[ImageSetType["sky"] = 2] = "sky";
    ImageSetType[ImageSetType["panorama"] = 3] = "panorama";
    ImageSetType[ImageSetType["solarSystem"] = 4] = "solarSystem";
    ImageSetType[ImageSetType["sandbox"] = 5] = "sandbox";
})(ImageSetType || (ImageSetType = {}));
var MarkerScales;
(function (MarkerScales) {
    MarkerScales[MarkerScales["screen"] = 0] = "screen";
    MarkerScales[MarkerScales["world"] = 1] = "world";
})(MarkerScales || (MarkerScales = {}));
var PlotTypes;
(function (PlotTypes) {
    PlotTypes[PlotTypes["gaussian"] = 0] = "gaussian";
    PlotTypes[PlotTypes["point"] = 1] = "point";
    PlotTypes[PlotTypes["circle"] = 2] = "circle";
    PlotTypes[PlotTypes["square"] = 3] = "square";
    PlotTypes[PlotTypes["pushPin"] = 4] = "pushPin";
    PlotTypes[PlotTypes["custom"] = 5] = "custom";
})(PlotTypes || (PlotTypes = {}));
var PointScaleTypes;
(function (PointScaleTypes) {
    PointScaleTypes[PointScaleTypes["linear"] = 0] = "linear";
    PointScaleTypes[PointScaleTypes["power"] = 1] = "power";
    PointScaleTypes[PointScaleTypes["log"] = 2] = "log";
    PointScaleTypes[PointScaleTypes["constant"] = 3] = "constant";
    PointScaleTypes[PointScaleTypes["stellarMagnitude"] = 4] = "stellarMagnitude";
})(PointScaleTypes || (PointScaleTypes = {}));
var ProjectionType;
(function (ProjectionType) {
    ProjectionType[ProjectionType["mercator"] = 0] = "mercator";
    ProjectionType[ProjectionType["equirectangular"] = 1] = "equirectangular";
    ProjectionType[ProjectionType["tangent"] = 2] = "tangent";
    ProjectionType[ProjectionType["tan"] = 2] = "tan";
    ProjectionType[ProjectionType["toast"] = 3] = "toast";
    ProjectionType[ProjectionType["spherical"] = 4] = "spherical";
    ProjectionType[ProjectionType["skyImage"] = 5] = "skyImage";
    ProjectionType[ProjectionType["plotted"] = 6] = "plotted";
})(ProjectionType || (ProjectionType = {}));
var RAUnits;
(function (RAUnits) {
    RAUnits[RAUnits["hours"] = 0] = "hours";
    RAUnits[RAUnits["degrees"] = 1] = "degrees";
})(RAUnits || (RAUnits = {}));
var ReferenceFrames;
(function (ReferenceFrames) {
    ReferenceFrames[ReferenceFrames["sky"] = 0] = "sky";
    ReferenceFrames[ReferenceFrames["ecliptic"] = 1] = "ecliptic";
    ReferenceFrames[ReferenceFrames["galactic"] = 2] = "galactic";
    ReferenceFrames[ReferenceFrames["sun"] = 3] = "sun";
    ReferenceFrames[ReferenceFrames["mercury"] = 4] = "mercury";
    ReferenceFrames[ReferenceFrames["venus"] = 5] = "venus";
    ReferenceFrames[ReferenceFrames["earth"] = 6] = "earth";
    ReferenceFrames[ReferenceFrames["mars"] = 7] = "mars";
    ReferenceFrames[ReferenceFrames["jupiter"] = 8] = "jupiter";
    ReferenceFrames[ReferenceFrames["saturn"] = 9] = "saturn";
    ReferenceFrames[ReferenceFrames["uranus"] = 10] = "uranus";
    ReferenceFrames[ReferenceFrames["neptune"] = 11] = "neptune";
    ReferenceFrames[ReferenceFrames["pluto"] = 12] = "pluto";
    ReferenceFrames[ReferenceFrames["moon"] = 13] = "moon";
    ReferenceFrames[ReferenceFrames["io"] = 14] = "io";
    ReferenceFrames[ReferenceFrames["europa"] = 15] = "europa";
    ReferenceFrames[ReferenceFrames["ganymede"] = 16] = "ganymede";
    ReferenceFrames[ReferenceFrames["callisto"] = 17] = "callisto";
    ReferenceFrames[ReferenceFrames["custom"] = 18] = "custom";
    ReferenceFrames[ReferenceFrames["identity"] = 19] = "identity";
    ReferenceFrames[ReferenceFrames["sandbox"] = 20] = "sandbox";
})(ReferenceFrames || (ReferenceFrames = {}));
var ReferenceFrameTypes;
(function (ReferenceFrameTypes) {
    ReferenceFrameTypes[ReferenceFrameTypes["fixedSherical"] = 0] = "fixedSherical";
    ReferenceFrameTypes[ReferenceFrameTypes["orbital"] = 1] = "orbital";
    ReferenceFrameTypes[ReferenceFrameTypes["trajectory"] = 2] = "trajectory";
    ReferenceFrameTypes[ReferenceFrameTypes["synodic"] = 3] = "synodic";
})(ReferenceFrameTypes || (ReferenceFrameTypes = {}));
var ScaleTypes;
(function (ScaleTypes) {
    ScaleTypes[ScaleTypes["linear"] = 0] = "linear";
    ScaleTypes[ScaleTypes["log"] = 1] = "log";
    ScaleTypes[ScaleTypes["power"] = 2] = "power";
    ScaleTypes[ScaleTypes["squareRoot"] = 3] = "squareRoot";
    ScaleTypes[ScaleTypes["histogramEqualization"] = 4] = "histogramEqualization";
})(ScaleTypes || (ScaleTypes = {}));
var SolarSystemObjects;
(function (SolarSystemObjects) {
    SolarSystemObjects[SolarSystemObjects["sun"] = 0] = "sun";
    SolarSystemObjects[SolarSystemObjects["mercury"] = 1] = "mercury";
    SolarSystemObjects[SolarSystemObjects["venus"] = 2] = "venus";
    SolarSystemObjects[SolarSystemObjects["mars"] = 3] = "mars";
    SolarSystemObjects[SolarSystemObjects["jupiter"] = 4] = "jupiter";
    SolarSystemObjects[SolarSystemObjects["saturn"] = 5] = "saturn";
    SolarSystemObjects[SolarSystemObjects["uranus"] = 6] = "uranus";
    SolarSystemObjects[SolarSystemObjects["neptune"] = 7] = "neptune";
    SolarSystemObjects[SolarSystemObjects["pluto"] = 8] = "pluto";
    SolarSystemObjects[SolarSystemObjects["moon"] = 9] = "moon";
    SolarSystemObjects[SolarSystemObjects["io"] = 10] = "io";
    SolarSystemObjects[SolarSystemObjects["europa"] = 11] = "europa";
    SolarSystemObjects[SolarSystemObjects["ganymede"] = 12] = "ganymede";
    SolarSystemObjects[SolarSystemObjects["callisto"] = 13] = "callisto";
    SolarSystemObjects[SolarSystemObjects["ioShadow"] = 14] = "ioShadow";
    SolarSystemObjects[SolarSystemObjects["europaShadow"] = 15] = "europaShadow";
    SolarSystemObjects[SolarSystemObjects["ganymedeShadow"] = 16] = "ganymedeShadow";
    SolarSystemObjects[SolarSystemObjects["callistoShadow"] = 17] = "callistoShadow";
    SolarSystemObjects[SolarSystemObjects["sunEclipsed"] = 18] = "sunEclipsed";
    SolarSystemObjects[SolarSystemObjects["earth"] = 19] = "earth";
    SolarSystemObjects[SolarSystemObjects["custom"] = 20] = "custom";
    SolarSystemObjects[SolarSystemObjects["undefined"] = 65536] = "undefined";
})(SolarSystemObjects || (SolarSystemObjects = {}));
// I'm not aware of any smart TypeScripty way to automate the construction of this table :-(
var baseEngineSettingTypeInfo = {
    "actualPlanetScale/boolean": true,
    "constellations/boolean": true,
    "constellationBoundryColor/string": true,
    "constellationFigureColor/string": true,
    "constellationsEnabled/string": true,
    "constellationSelectionColor/string": true,
    "crosshairsColor/string": true,
    "earthCutawayView/boolean": true,
    //"fovCamera/number": true,  // skipping because not settable
    //"fovEyepiece/number": true,  // skipping because not settable
    //"fovTelescope/number": true,  // skipping because not settable
    "localHorizonMode/boolean": true,
    "galacticMode/boolean": true,
    "locationAltitude/number": true,
    "locationLat/number": true,
    "locationLng/number": true,
    "milkyWayModel/boolean": true,
    "showAltAzGrid/boolean": true,
    "showAltAzGridText/boolean": true,
    //"showClouds/boolean": true,  // skipping because not settable
    "showConstellations/boolean": true,
    "showConstellationBoundries/boolean": true,
    "showConstellationFigures/boolean": true,
    "showConstellationLabels/boolean": true,
    "showConstellationPictures/boolean": true,
    "showConstellationSelection/boolean": true,
    "showCrosshairs/boolean": true,
    "showEarthSky/boolean": true,
    "showEcliptic/boolean": true,
    "showEclipticCircle/boolean": true,
    "showEclipticGrid/boolean": true,
    "showEclipticGridText/boolean": true,
    "showEclipticOverviewText/boolean": true,
    "showElevationModel/boolean": true,
    "showEquatorialGridText/boolean": true,
    //"showFieldOfView/boolean": true,  // skipping because not settable
    "showGalacticGrid/boolean": true,
    "showGalacticGridText/boolean": true,
    "showGrid/boolean": true,
    "showHorizon/boolean": true,
    //"showHorizonPanorama/boolean": true,  // skipping because not settable
    "showISSModel/boolean": true,
    //"showMoonsAsPointSource/boolean": true,  // skipping because not settable
    "showPrecessionChart/boolean": true,
    "showSkyGrids/boolean": true,
    "showSkyNode/boolean": true,
    "showSkyOverlays/boolean": true,
    "showSkyOverlaysIn3d/boolean": true,
    "showSolarSystem/boolean": true,
    "smoothPan/boolean": true,
    "solarSystemCMB/boolean": true,
    "solarSystemCosmos/boolean": true,
    "solarSystemMilkyWay/boolean": true,
    "solarSystemOrbits/boolean": true,
    "solarSystemOverlays/boolean": true,
    "solarSystemLighting/boolean": true,
    "solarSystemMultiRes/boolean": true,
    "solarSystemMinorPlanets/boolean": true,
    "solarSystemMinorOrbits/boolean": true,
    "solarSystemPlanets/boolean": true,
    "solarSystemStars/boolean": true,
    "minorPlanetsFilter/number": true,
    "planetOrbitsFilter/number": true,
    "solarSystemScale/number": true,
};
/** Type guard function for BaseEngineSetting. */
function src_isBaseEngineSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in baseEngineSettingTypeInfo);
}
var baseLayerSettingTypeInfo = {
    "astronomical/boolean": true,
    "enabled/boolean": true,
    "fadeSpan/number": true,
    "name/string": true,
    "opacity/number": true,
    "opened/boolean": true,
    "referenceFrame/string": true,
    "version/number": true,
};
/** Type guard function for BaseLayerSetting. */
function src_isBaseLayerSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return key in baseLayerSettingTypeInfo;
}
var baseImageSetLayerSettingTypeInfo = {
    "colorMapperName/string": true,
    "overrideDefaultLayer/boolean": true,
};
/** Type guard function for BaseImageSetLayerSetting. */
function src_isBaseImageSetLayerSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in baseImageSetLayerSettingTypeInfo) || src_isBaseLayerSetting(obj);
}
// See implementation below -- we need to handle enums specially
// to make sure that inputs are in-range.
var baseSpreadSheetLayerSettingTypeInfo = {
    "altColumn/number": "",
    "altType/number": "AltTypes",
    "altUnit/number": "AltUnits",
    "barChartBitmask/number": "",
    "beginRange/Date": "",
    "cartesianCustomScale/number": "",
    "cartesianScale/number": "AltUnits",
    "colorMapColumn/number": "",
    "colorMapperName/string": "",
    "coordinatesType/number": "CoordinatesType",
    "decay/number": "",
    "dynamicColor/boolean": "",
    "dynamicData/boolean": "",
    "endDateColumn/number": "",
    "endRange/Date": "",
    "geometryColumn/number": "",
    "hyperlinkColumn/number": "",
    "hyperlinkFormat/string": "",
    "latColumn/number": "",
    "lngColumn/number": "",
    "markerColumn/number": "",
    "markerIndex/number": "",
    "markerScale/number": "",
    "nameColumn/number": "",
    "normalizeColorMap/boolean": "",
    "normalizeColorMapMax/number": "",
    "normalizeColorMapMin/number": "",
    "normalizeSize/boolean": "",
    "normalizeSizeClip/boolean": "",
    "normalizeSizeMax/number": "",
    "normalizeSizeMin/number": "",
    "plotType/number": "PlotTypes",
    "pointScaleType/number": "PointScaleTypes",
    "raUnits/number": "RAUnits",
    "scaleFactor/number": "",
    "showFarSide/boolean": "",
    "sizeColumn/number": "",
    "startDateColumn/number": "",
    "timeSeries/boolean": "",
    "xAxisColumn/number": "",
    "xAxisReverse/boolean": "",
    "yAxisColumn/number": "",
    "yAxisReverse/boolean": "",
    "zAxisColumn/number": "",
    "zAxisReverse/boolean": "",
};
/** Type guard function for BaseSpreadSheetLayerSetting. */
function src_isBaseSpreadSheetLayerSetting(obj) {
    if (src_isBaseLayerSetting(obj))
        return true;
    // We want to be able to properly recognize Date objects
    var type = obj[1] instanceof Date ? 'Date' : typeof obj[1];
    var key = obj[0] + "/" + type;
    var enumType = baseSpreadSheetLayerSettingTypeInfo[key];
    if (enumType === undefined) {
        return false;
    }
    else if (enumType == "") {
        return true;
    }
    else if (enumType == "AltTypes") {
        return obj[1] in AltTypes;
    }
    else if (enumType == "AltUnits") {
        return obj[1] in AltUnits;
    }
    else if (enumType == "CoordinatesType") {
        return obj[1] in CoordinatesType;
    }
    else if (enumType == "PlotTypes") {
        return obj[1] in PlotTypes;
    }
    else if (enumType == "PointScaleTypes") {
        return obj[1] in PointScaleTypes;
    }
    else if (enumType == "RAUnits") {
        return obj[1] in RAUnits;
    }
    else {
        throw new Error('internal bug isBaseSpreadSheetLayerSetting');
    }
}
// See implementation below -- we need to handle enums specially
// to make sure that inputs are in-range.
var baseVoTableLayerSettingTypeInfo = {
    "altColumn/number": "",
    "altType/number": "AltTypes",
    "altUnit/number": "AltUnits",
    "beginRange/Date": "",
    "cartesianCustomScale/number": "",
    "cartesianScale/number": "AltUnits",
    "colorMapColumn/number": "",
    "coordinatesType/number": "CoordinatesType",
    "dataSourceUrl/string": "",
    "decay/number": "",
    "dynamicData/boolean": "",
    "endDateColumn/number": "",
    "endRange/Date": "",
    "hyperlinkColumn/number": "",
    "hyperlinkFormat/string": "",
    "latColumn/number": "",
    "lngColumn/number": "",
    "markerColumn/number": "",
    "markerIndex/number": "",
    "markerScale/number": "",
    "nameColumn/number": "",
    "plotType/number": "PlotTypes",
    "pointScaleType/number": "PointScaleTypes",
    "raUnits/number": "RAUnits",
    "scaleFactor/number": "",
    "showFarSide/boolean": "",
    "sizeColumn/number": "",
    "startDateColumn/number": "",
    "timeSeries/boolean": "",
    "xAxisColumn/number": "",
    "xAxisReverse/boolean": "",
    "yAxisColumn/number": "",
    "yAxisReverse/boolean": "",
    "zAxisColumn/number": "",
    "zAxisReverse/boolean": "",
};
/** Type guard function for BaseVoTableLayerSetting. */
function src_isBaseVoTableLayerSetting(obj) {
    if (src_isBaseLayerSetting(obj))
        return true;
    var key = obj[0] + "/" + typeof obj[1];
    var enumType = baseVoTableLayerSettingTypeInfo[key];
    if (enumType === undefined) {
        return false;
    }
    else if (enumType == "") {
        return true;
    }
    else if (enumType == "AltTypes") {
        return obj[1] in AltTypes;
    }
    else if (enumType == "AltUnits") {
        return obj[1] in AltUnits;
    }
    else if (enumType == "CoordinatesType") {
        return obj[1] in CoordinatesType;
    }
    else if (enumType == "PlotTypes") {
        return obj[1] in PlotTypes;
    }
    else if (enumType == "PointScaleTypes") {
        return obj[1] in PointScaleTypes;
    }
    else if (enumType == "RAUnits") {
        return obj[1] in RAUnits;
    }
    else {
        throw new Error('internal bug isBaseVoTableLayerSetting');
    }
}
function keysOf(o) { return Object.keys(o); } // eslint-disable-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function enumLookup(stringEnum, s) {
    var e_1, _a;
    try {
        for (var _b = __values(keysOf(stringEnum)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var enumKey = _c.value;
            if (stringEnum[enumKey] === s) {
                return stringEnum[enumKey];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: external {"amd":"@wwtelescope/engine","commonjs2":"@wwtelescope/engine","commonjs":"@wwtelescope/engine","root":"wwtlib"}
var engine_root_wwtlib_ = __nested_webpack_require_1513__(380);
;// CONCATENATED MODULE: ../engine-helpers/dist/src/layer.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Helpers for handling generic layers settings. */


/** A list of the names of the available settings for generic layers. */
var layerSettingNames = [
    "astronomical",
    "color",
    "enabled",
    "fadeSpan",
    "name",
    "opacity",
    "opened",
    "referenceFrame",
    "version",
];
var layerSettingTypeInfo = {
    "color/Color": true,
};
/** Type guard function for `LayerSetting`. */
function layer_isLayerSetting(obj) {
    var typekey = typeof obj[1];
    if (obj[1] instanceof Color) {
        typekey = "Color";
    }
    var key = obj[0] + "/" + typekey;
    return (key in layerSettingTypeInfo) || isBaseLayerSetting(obj);
}
/** Apply a setting to a generic `Layer` or equivalent. */
function applyLayerSetting(layer, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    layer[funcName](value);
}
/** Extract all of the current settings of a `Layer` or equivalent. */
function layer_extractLayerSettings(layer) {
    var e_1, _a;
    var s = [];
    try {
        for (var layerSettingNames_1 = __values(layerSettingNames), layerSettingNames_1_1 = layerSettingNames_1.next(); !layerSettingNames_1_1.done; layerSettingNames_1_1 = layerSettingNames_1.next()) {
            var n = layerSettingNames_1_1.value;
            s.push([n, layer["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (layerSettingNames_1_1 && !layerSettingNames_1_1.done && (_a = layerSettingNames_1.return)) _a.call(layerSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `Layer`, or equivalent, to another. */
function copyLayerSettings(source, dest) {
    var e_2, _a;
    try {
        for (var layerSettingNames_2 = tslib_es6_values(layerSettingNames), layerSettingNames_2_1 = layerSettingNames_2.next(); !layerSettingNames_2_1.done; layerSettingNames_2_1 = layerSettingNames_2.next()) {
            var n = layerSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (layerSettingNames_2_1 && !layerSettingNames_2_1.done && (_a = layerSettingNames_2.return)) _a.call(layerSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `LayerSettingsInterface`. */
var LayerState = /** @class */ (function () {
    // Maybe possible to use remapped keys to create this type?:
    // https://www.typescriptlang.org/docs/handbook/2/mapped-types.html#key-remapping-via-as
    // Don't think we can implement functions, though, and we're currently (Aug
    // 2021) on TypeScript 3.9, while the above requires 4.1.
    function LayerState(source) {
        copyLayerSettings(source, this);
    }
    LayerState.prototype.get_astronomical = function () {
        return this.astronomical;
    };
    LayerState.prototype.set_astronomical = function (v) {
        this.astronomical = v;
        return v;
    };
    LayerState.prototype.get_color = function () {
        return this.color;
    };
    LayerState.prototype.set_color = function (v) {
        this.color = v;
        return v;
    };
    LayerState.prototype.get_enabled = function () {
        return this.enabled;
    };
    LayerState.prototype.set_enabled = function (v) {
        this.enabled = v;
        return v;
    };
    LayerState.prototype.get_endTime = function () {
        return this.endTime;
    };
    LayerState.prototype.set_endTime = function (v) {
        this.endTime = v;
        return v;
    };
    LayerState.prototype.get_fadeSpan = function () {
        return this.fadeSpan;
    };
    LayerState.prototype.set_fadeSpan = function (v) {
        this.fadeSpan = v;
        return v;
    };
    LayerState.prototype.get_fadeType = function () {
        return this.fadeType;
    };
    LayerState.prototype.set_fadeType = function (v) {
        this.fadeType = v;
        return v;
    };
    LayerState.prototype.get_name = function () {
        return this.name;
    };
    LayerState.prototype.set_name = function (v) {
        this.name = v;
        return v;
    };
    LayerState.prototype.get_opacity = function () {
        return this.opacity;
    };
    LayerState.prototype.set_opacity = function (v) {
        this.opacity = v;
        return v;
    };
    LayerState.prototype.get_opened = function () {
        return this.opened;
    };
    LayerState.prototype.set_opened = function (v) {
        this.opened = v;
        return v;
    };
    LayerState.prototype.get_referenceFrame = function () {
        return this.referenceFrame;
    };
    LayerState.prototype.set_referenceFrame = function (v) {
        this.referenceFrame = v;
        return v;
    };
    LayerState.prototype.get_startTime = function () {
        return this.startTime;
    };
    LayerState.prototype.set_startTime = function (v) {
        this.startTime = v;
        return v;
    };
    LayerState.prototype.get_version = function () {
        return this.version;
    };
    LayerState.prototype.set_version = function (v) {
        this.version = v;
        return v;
    };
    return LayerState;
}());

//# sourceMappingURL=layer.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/imagesetlayer.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Helpers for handling imageset layer settings. */


var justImageSetLayerSettingNames = [
    "colorMapperName",
    "overrideDefaultLayer",
];
/** A list of the names of the available settings for `ImageSetLayer`
 * instances and their equivalents (things implementing
 * {@link ImageSetLayerSettingsInterface}).
 *
 * This is a superset of the names available for generic layers.
*/
var imageSetLayerSettingNames = layerSettingNames.concat(justImageSetLayerSettingNames);
/** Type guard function for `ImageSetLayerSetting`. */
function isImageSetLayerSetting(obj) {
    // No special settings specific to non-base ImageSetLayerSetting.
    return isLayerSetting(obj) || isBaseImageSetLayerSetting(obj);
}
/** Apply a setting to a `ImageSetLayer` or equivalent. */
function applyImageSetLayerSetting(layer, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    layer[funcName](value);
}
/** Extract all of the current settings of a `ImageSetLayer` or equivalent. */
function extractImageSetLayerSettings(layer) {
    var e_1, _a;
    var s = extractLayerSettings(layer);
    try {
        for (var justImageSetLayerSettingNames_1 = __values(justImageSetLayerSettingNames), justImageSetLayerSettingNames_1_1 = justImageSetLayerSettingNames_1.next(); !justImageSetLayerSettingNames_1_1.done; justImageSetLayerSettingNames_1_1 = justImageSetLayerSettingNames_1.next()) {
            var n = justImageSetLayerSettingNames_1_1.value;
            s.push([n, layer["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justImageSetLayerSettingNames_1_1 && !justImageSetLayerSettingNames_1_1.done && (_a = justImageSetLayerSettingNames_1.return)) _a.call(justImageSetLayerSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `ImageSetLayer`, or equivalent, to another. */
function copyImageSetLayerSettings(source, dest) {
    var e_2, _a;
    copyLayerSettings(source, dest);
    try {
        for (var justImageSetLayerSettingNames_2 = tslib_es6_values(justImageSetLayerSettingNames), justImageSetLayerSettingNames_2_1 = justImageSetLayerSettingNames_2.next(); !justImageSetLayerSettingNames_2_1.done; justImageSetLayerSettingNames_2_1 = justImageSetLayerSettingNames_2.next()) {
            var n = justImageSetLayerSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justImageSetLayerSettingNames_2_1 && !justImageSetLayerSettingNames_2_1.done && (_a = justImageSetLayerSettingNames_2.return)) _a.call(justImageSetLayerSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `ImageSetLayerSettingsInterface`. */
var imagesetlayer_ImageSetLayerState = /** @class */ (function (_super) {
    __extends(ImageSetLayerState, _super);
    function ImageSetLayerState(source) {
        var _this = 
        // Here we redundantly copy the generic Layer settings, but TypeScript
        // requires the super() call. Oh well.
        _super.call(this, source) || this;
        copyImageSetLayerSettings(source, _this);
        return _this;
    }
    ImageSetLayerState.prototype.get_colorMapperName = function () {
        return this.colorMapperName;
    };
    ImageSetLayerState.prototype.set_colorMapperName = function (v) {
        this.colorMapperName = v;
        return v;
    };
    ImageSetLayerState.prototype.get_overrideDefaultLayer = function () {
        return this.overrideDefaultLayer;
    };
    ImageSetLayerState.prototype.set_overrideDefaultLayer = function (v) {
        this.overrideDefaultLayer = v;
        return v;
    };
    return ImageSetLayerState;
}(LayerState));

//# sourceMappingURL=imagesetlayer.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/spreadsheetlayer.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Helpers for handling "spreadsheet" layer settings. */


var justSpreadSheetLayerSettingNames = [
    "altColumn",
    "altType",
    "altUnit",
    "barChartBitmask",
    "beginRange",
    "cartesianCustomScale",
    "cartesianScale",
    "colorMapColumn",
    "colorMapperName",
    "coordinatesType",
    "decay",
    "dynamicColor",
    "dynamicData",
    "endDateColumn",
    "endRange",
    "geometryColumn",
    "hyperlinkColumn",
    "hyperlinkFormat",
    "latColumn",
    "lngColumn",
    "markerColumn",
    "markerIndex",
    "markerScale",
    "nameColumn",
    "normalizeColorMap",
    "normalizeColorMapMax",
    "normalizeColorMapMin",
    "normalizeSize",
    "normalizeSizeClip",
    "normalizeSizeMax",
    "normalizeSizeMin",
    "plotType",
    "pointScaleType",
    "raUnits",
    "scaleFactor",
    "showFarSide",
    "sizeColumn",
    "startDateColumn",
    "timeSeries",
    "xAxisColumn",
    "xAxisReverse",
    "yAxisColumn",
    "yAxisReverse",
    "zAxisColumn",
    "zAxisReverse",
];
/** A list of the names of the available settings for `SpreadSheetLayer`
 * instances and their equivalents (things implementing
 * {@link SpreadSheetLayerSettingsInterface}).
 *
 * This is a superset of the names available for generic layers.
*/
var spreadSheetLayerSettingNames = layerSettingNames.concat(justSpreadSheetLayerSettingNames);
/** Type guard function for `SpreadSheetLayerSetting`. */
function isSpreadSheetLayerSetting(obj) {
    // No special settings specific to non-base SpreadSheetLayerSetting.
    return isLayerSetting(obj) || isBaseSpreadSheetLayerSetting(obj);
}
/** Apply a setting to a `SpreadSheetLayer` or equivalent. */
function applySpreadSheetLayerSetting(layer, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1]; // eslint-disable-line @typescript-eslint/no-explicit-any
    layer[funcName](value); // eslint-disable-line @typescript-eslint/no-explicit-any
}
/** Extract all of the current settings of a `SpreadSheetLayer` or equivalent. */
function extractSpreadSheetLayerSettings(layer) {
    var e_1, _a;
    var s = extractLayerSettings(layer);
    try {
        for (var justSpreadSheetLayerSettingNames_1 = __values(justSpreadSheetLayerSettingNames), justSpreadSheetLayerSettingNames_1_1 = justSpreadSheetLayerSettingNames_1.next(); !justSpreadSheetLayerSettingNames_1_1.done; justSpreadSheetLayerSettingNames_1_1 = justSpreadSheetLayerSettingNames_1.next()) {
            var n = justSpreadSheetLayerSettingNames_1_1.value;
            s.push([n, layer["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justSpreadSheetLayerSettingNames_1_1 && !justSpreadSheetLayerSettingNames_1_1.done && (_a = justSpreadSheetLayerSettingNames_1.return)) _a.call(justSpreadSheetLayerSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `SpreadSheetLayer`, or equivalent, to another. */
function copySpreadSheetLayerSettings(source, dest) {
    var e_2, _a;
    copyLayerSettings(source, dest);
    try {
        for (var justSpreadSheetLayerSettingNames_2 = tslib_es6_values(justSpreadSheetLayerSettingNames), justSpreadSheetLayerSettingNames_2_1 = justSpreadSheetLayerSettingNames_2.next(); !justSpreadSheetLayerSettingNames_2_1.done; justSpreadSheetLayerSettingNames_2_1 = justSpreadSheetLayerSettingNames_2.next()) {
            var n = justSpreadSheetLayerSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justSpreadSheetLayerSettingNames_2_1 && !justSpreadSheetLayerSettingNames_2_1.done && (_a = justSpreadSheetLayerSettingNames_2.return)) _a.call(justSpreadSheetLayerSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `SpreadSheetLayerSettingsInterface`. */
var SpreadSheetLayerState = /** @class */ (function (_super) {
    __extends(SpreadSheetLayerState, _super);
    function SpreadSheetLayerState(source) {
        var _this = 
        // Here we redundantly copy the generic Layer settings, but TypeScript
        // requires the super() call. Oh well.
        _super.call(this, source) || this;
        copySpreadSheetLayerSettings(source, _this);
        return _this;
    }
    SpreadSheetLayerState.prototype.get_altColumn = function () {
        return this.altColumn;
    };
    SpreadSheetLayerState.prototype.set_altColumn = function (v) {
        this.altColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_altType = function () {
        return this.altType;
    };
    SpreadSheetLayerState.prototype.set_altType = function (v) {
        this.altType = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_altUnit = function () {
        return this.altUnit;
    };
    SpreadSheetLayerState.prototype.set_altUnit = function (v) {
        this.altUnit = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_barChartBitmask = function () {
        return this.barChartBitmask;
    };
    SpreadSheetLayerState.prototype.set_barChartBitmask = function (v) {
        this.barChartBitmask = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_beginRange = function () {
        return this.beginRange;
    };
    SpreadSheetLayerState.prototype.set_beginRange = function (v) {
        this.beginRange = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_cartesianCustomScale = function () {
        return this.cartesianCustomScale;
    };
    SpreadSheetLayerState.prototype.set_cartesianCustomScale = function (v) {
        this.cartesianCustomScale = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_cartesianScale = function () {
        return this.cartesianScale;
    };
    SpreadSheetLayerState.prototype.set_cartesianScale = function (v) {
        this.cartesianScale = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_colorMapColumn = function () {
        return this.colorMapColumn;
    };
    SpreadSheetLayerState.prototype.set_colorMapColumn = function (v) {
        this.colorMapColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_colorMapperName = function () {
        return this.colorMapperName;
    };
    SpreadSheetLayerState.prototype.set_colorMapperName = function (v) {
        this.colorMapperName = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_coordinatesType = function () {
        return this.coordinatesType;
    };
    SpreadSheetLayerState.prototype.set_coordinatesType = function (v) {
        this.coordinatesType = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_decay = function () {
        return this.decay;
    };
    SpreadSheetLayerState.prototype.set_decay = function (v) {
        this.decay = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_dynamicColor = function () {
        return this.dynamicColor;
    };
    SpreadSheetLayerState.prototype.set_dynamicColor = function (v) {
        this.dynamicColor = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_dynamicData = function () {
        return this.dynamicData;
    };
    SpreadSheetLayerState.prototype.set_dynamicData = function (v) {
        this.dynamicData = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_endDateColumn = function () {
        return this.endDateColumn;
    };
    SpreadSheetLayerState.prototype.set_endDateColumn = function (v) {
        this.endDateColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_endRange = function () {
        return this.endRange;
    };
    SpreadSheetLayerState.prototype.set_endRange = function (v) {
        this.endRange = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_geometryColumn = function () {
        return this.geometryColumn;
    };
    SpreadSheetLayerState.prototype.set_geometryColumn = function (v) {
        this.geometryColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_hyperlinkColumn = function () {
        return this.hyperlinkColumn;
    };
    SpreadSheetLayerState.prototype.set_hyperlinkColumn = function (v) {
        this.hyperlinkColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_hyperlinkFormat = function () {
        return this.hyperlinkFormat;
    };
    SpreadSheetLayerState.prototype.set_hyperlinkFormat = function (v) {
        this.hyperlinkFormat = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_latColumn = function () {
        return this.latColumn;
    };
    SpreadSheetLayerState.prototype.set_latColumn = function (v) {
        this.latColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_lngColumn = function () {
        return this.lngColumn;
    };
    SpreadSheetLayerState.prototype.set_lngColumn = function (v) {
        this.lngColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_markerColumn = function () {
        return this.markerColumn;
    };
    SpreadSheetLayerState.prototype.set_markerColumn = function (v) {
        this.markerColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_markerIndex = function () {
        return this.markerIndex;
    };
    SpreadSheetLayerState.prototype.set_markerIndex = function (v) {
        this.markerIndex = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_markerScale = function () {
        return this.markerScale;
    };
    SpreadSheetLayerState.prototype.set_markerScale = function (v) {
        this.markerScale = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_nameColumn = function () {
        return this.nameColumn;
    };
    SpreadSheetLayerState.prototype.set_nameColumn = function (v) {
        this.nameColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeColorMap = function () {
        return this.normalizeColorMap;
    };
    SpreadSheetLayerState.prototype.set_normalizeColorMap = function (v) {
        this.normalizeColorMap = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeColorMapMax = function () {
        return this.normalizeColorMapMax;
    };
    SpreadSheetLayerState.prototype.set_normalizeColorMapMax = function (v) {
        this.normalizeColorMapMax = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeColorMapMin = function () {
        return this.normalizeColorMapMin;
    };
    SpreadSheetLayerState.prototype.set_normalizeColorMapMin = function (v) {
        this.normalizeColorMapMin = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeSize = function () {
        return this.normalizeSize;
    };
    SpreadSheetLayerState.prototype.set_normalizeSize = function (v) {
        this.normalizeSize = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeSizeClip = function () {
        return this.normalizeSizeClip;
    };
    SpreadSheetLayerState.prototype.set_normalizeSizeClip = function (v) {
        this.normalizeSizeClip = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeSizeMax = function () {
        return this.normalizeSizeMax;
    };
    SpreadSheetLayerState.prototype.set_normalizeSizeMax = function (v) {
        this.normalizeSizeMax = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_normalizeSizeMin = function () {
        return this.normalizeSizeMin;
    };
    SpreadSheetLayerState.prototype.set_normalizeSizeMin = function (v) {
        this.normalizeSizeMin = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_plotType = function () {
        return this.plotType;
    };
    SpreadSheetLayerState.prototype.set_plotType = function (v) {
        this.plotType = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_pointScaleType = function () {
        return this.pointScaleType;
    };
    SpreadSheetLayerState.prototype.set_pointScaleType = function (v) {
        this.pointScaleType = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_raUnits = function () {
        return this.raUnits;
    };
    SpreadSheetLayerState.prototype.set_raUnits = function (v) {
        this.raUnits = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_scaleFactor = function () {
        return this.scaleFactor;
    };
    SpreadSheetLayerState.prototype.set_scaleFactor = function (v) {
        this.scaleFactor = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_showFarSide = function () {
        return this.showFarSide;
    };
    SpreadSheetLayerState.prototype.set_showFarSide = function (v) {
        this.showFarSide = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_sizeColumn = function () {
        return this.sizeColumn;
    };
    SpreadSheetLayerState.prototype.set_sizeColumn = function (v) {
        this.sizeColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_startDateColumn = function () {
        return this.startDateColumn;
    };
    SpreadSheetLayerState.prototype.set_startDateColumn = function (v) {
        this.startDateColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_timeSeries = function () {
        return this.timeSeries;
    };
    SpreadSheetLayerState.prototype.set_timeSeries = function (v) {
        this.timeSeries = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_xAxisColumn = function () {
        return this.xAxisColumn;
    };
    SpreadSheetLayerState.prototype.set_xAxisColumn = function (v) {
        this.xAxisColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_xAxisReverse = function () {
        return this.xAxisReverse;
    };
    SpreadSheetLayerState.prototype.set_xAxisReverse = function (v) {
        this.xAxisReverse = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_yAxisColumn = function () {
        return this.yAxisColumn;
    };
    SpreadSheetLayerState.prototype.set_yAxisColumn = function (v) {
        this.yAxisColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_yAxisReverse = function () {
        return this.yAxisReverse;
    };
    SpreadSheetLayerState.prototype.set_yAxisReverse = function (v) {
        this.yAxisReverse = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_zAxisColumn = function () {
        return this.zAxisColumn;
    };
    SpreadSheetLayerState.prototype.set_zAxisColumn = function (v) {
        this.zAxisColumn = v;
        return v;
    };
    SpreadSheetLayerState.prototype.get_zAxisReverse = function () {
        return this.zAxisReverse;
    };
    SpreadSheetLayerState.prototype.set_zAxisReverse = function (v) {
        this.zAxisReverse = v;
        return v;
    };
    return SpreadSheetLayerState;
}(LayerState));

//# sourceMappingURL=spreadsheetlayer.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/annotation.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/** A list of the names of the available settings for annotations. */
var annotationSettingNames = [
    "id",
    "label",
    "opacity",
    "showHoverLabel",
    "tag",
];
var annotationSettingTypeInfo = {
    "id/string": true,
    "label/string": true,
    "opacity/number": true,
    "showHoverLabel/boolean": true,
    "tag/string": true,
};
/** Type guard function for `AnnotationSetting`. */
function annotation_isAnnotationSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return key in annotationSettingTypeInfo;
}
/** Apply a setting to a generic `Annotation` or equivalent. */
function applyAnnotationSetting(annotation, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    annotation[funcName](value);
}
/** Extract all of the current settings of a `Annotation` or equivalent. */
function annotation_extractAnnotationSettings(annotation) {
    var e_1, _a;
    var s = [];
    try {
        for (var annotationSettingNames_1 = __values(annotationSettingNames), annotationSettingNames_1_1 = annotationSettingNames_1.next(); !annotationSettingNames_1_1.done; annotationSettingNames_1_1 = annotationSettingNames_1.next()) {
            var n = annotationSettingNames_1_1.value;
            s.push([n, annotation["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (annotationSettingNames_1_1 && !annotationSettingNames_1_1.done && (_a = annotationSettingNames_1.return)) _a.call(annotationSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `Annotation`, or equivalent, to another. */
function copyAnnotationSettings(source, dest) {
    var e_2, _a;
    try {
        for (var annotationSettingNames_2 = tslib_es6_values(annotationSettingNames), annotationSettingNames_2_1 = annotationSettingNames_2.next(); !annotationSettingNames_2_1.done; annotationSettingNames_2_1 = annotationSettingNames_2.next()) {
            var n = annotationSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (annotationSettingNames_2_1 && !annotationSettingNames_2_1.done && (_a = annotationSettingNames_2.return)) _a.call(annotationSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `AnnotationSettingsInterface`. */
var AnnotationState = /** @class */ (function () {
    function AnnotationState(source) {
        copyAnnotationSettings(source, this);
    }
    AnnotationState.prototype.get_id = function () {
        return this.id;
    };
    AnnotationState.prototype.set_id = function (v) {
        this.id = v;
        return v;
    };
    AnnotationState.prototype.get_label = function () {
        return this.label;
    };
    AnnotationState.prototype.set_label = function (v) {
        this.label = v;
        return v;
    };
    AnnotationState.prototype.get_opacity = function () {
        return this.opacity;
    };
    AnnotationState.prototype.set_opacity = function (v) {
        this.opacity = v;
        return v;
    };
    AnnotationState.prototype.get_showHoverLabel = function () {
        return this.showHoverLabel;
    };
    AnnotationState.prototype.set_showHoverLabel = function (v) {
        this.showHoverLabel = v;
        return v;
    };
    AnnotationState.prototype.get_tag = function () {
        return this.tag;
    };
    AnnotationState.prototype.set_tag = function (v) {
        this.tag = v;
        return v;
    };
    return AnnotationState;
}());

//# sourceMappingURL=annotation.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/circleannotation.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License


var justCircleAnnotationSettingNames = [
    "fill",
    "fillColor",
    "lineColor",
    "lineWidth",
    "radius",
    "skyRelative",
];
/** A list of the names of the available settings for `CircleAnnotation`
 * instances and their equivalents (things implementing
 * {@link CircleAnnotationSettingsInterface}).
 *
 * This is a superset of the names available for generic annotations.
*/
var circleAnnotationSettingNames = annotationSettingNames.concat(justCircleAnnotationSettingNames);
var circleAnnotationSettingTypeInfo = {
    "fill/boolean": true,
    "fillColor/string": true,
    "lineColor/string": true,
    "lineWidth/number": true,
    "radius/number": true,
    "skyRelative/boolean": true,
};
/** Type guard function for `CircleAnnotationSetting`. */
function isCircleAnnotationSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in circleAnnotationSettingTypeInfo) || isAnnotationSetting(obj);
}
/** Apply a setting to a generic `CircleAnnotation` or equivalent. */
function applyCircleAnnotationSetting(circle, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    circle[funcName](value);
}
/** Extract all of the current settings of a `CircleAnnotation` or equivalent. */
function extractCircleAnnotationSettings(circle) {
    var e_1, _a;
    var s = extractAnnotationSettings(circle);
    try {
        for (var justCircleAnnotationSettingNames_1 = __values(justCircleAnnotationSettingNames), justCircleAnnotationSettingNames_1_1 = justCircleAnnotationSettingNames_1.next(); !justCircleAnnotationSettingNames_1_1.done; justCircleAnnotationSettingNames_1_1 = justCircleAnnotationSettingNames_1.next()) {
            var n = justCircleAnnotationSettingNames_1_1.value;
            s.push([n, circle["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justCircleAnnotationSettingNames_1_1 && !justCircleAnnotationSettingNames_1_1.done && (_a = justCircleAnnotationSettingNames_1.return)) _a.call(justCircleAnnotationSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `CircleAnnotation`, or equivalent, to another. */
function copyCircleAnnotationSettings(source, dest) {
    var e_2, _a;
    copyAnnotationSettings(source, dest);
    try {
        for (var justCircleAnnotationSettingNames_2 = tslib_es6_values(justCircleAnnotationSettingNames), justCircleAnnotationSettingNames_2_1 = justCircleAnnotationSettingNames_2.next(); !justCircleAnnotationSettingNames_2_1.done; justCircleAnnotationSettingNames_2_1 = justCircleAnnotationSettingNames_2.next()) {
            var n = justCircleAnnotationSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justCircleAnnotationSettingNames_2_1 && !justCircleAnnotationSettingNames_2_1.done && (_a = justCircleAnnotationSettingNames_2.return)) _a.call(justCircleAnnotationSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `CircleAnnotationSettingsInterface`. */
var CircleAnnotationState = /** @class */ (function (_super) {
    __extends(CircleAnnotationState, _super);
    function CircleAnnotationState(source) {
        var _this = _super.call(this, source) || this;
        copyCircleAnnotationSettings(source, _this);
        return _this;
    }
    CircleAnnotationState.prototype.get_fill = function () {
        return this.fill;
    };
    CircleAnnotationState.prototype.set_fill = function (v) {
        this.fill = v;
        return v;
    };
    CircleAnnotationState.prototype.get_fillColor = function () {
        return this.fillColor;
    };
    CircleAnnotationState.prototype.set_fillColor = function (v) {
        this.fillColor = v;
        return v;
    };
    CircleAnnotationState.prototype.get_lineColor = function () {
        return this.lineColor;
    };
    CircleAnnotationState.prototype.set_lineColor = function (v) {
        this.lineColor = v;
        return v;
    };
    CircleAnnotationState.prototype.get_lineWidth = function () {
        return this.lineWidth;
    };
    CircleAnnotationState.prototype.set_lineWidth = function (v) {
        this.lineWidth = v;
        return v;
    };
    CircleAnnotationState.prototype.get_radius = function () {
        return this.radius;
    };
    CircleAnnotationState.prototype.set_radius = function (v) {
        this.radius = v;
        return v;
    };
    CircleAnnotationState.prototype.get_skyRelative = function () {
        return this.skyRelative;
    };
    CircleAnnotationState.prototype.set_skyRelative = function (v) {
        this.skyRelative = v;
        return v;
    };
    return CircleAnnotationState;
}(AnnotationState));

//# sourceMappingURL=circleannotation.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/engine.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Helpers for handling core engine settings. */


/** A list of the names of the core engine settings. */
var engineSettingNames = [
    "actualPlanetScale",
    "altAzGridColor",
    "constellationArtFilter",
    "constellationBoundariesFilter",
    "constellationFigureColor",
    "constellationFiguresFilter",
    "constellationBoundryColor",
    "constellationNamesFilter",
    "constellationLabelsHeight",
    "constellations",
    "constellationSelectionColor",
    "constellationsEnabled",
    "crosshairsColor",
    "earthCutawayView",
    "eclipticColor",
    "eclipticGridColor",
    "equatorialGridColor",
    "galacticGridColor",
    "galacticMode",
    "localHorizonMode",
    "locationAltitude",
    "locationLat",
    "locationLng",
    "milkyWayModel",
    "minorPlanetsFilter",
    "planetOrbitsFilter",
    "precessionChartColor",
    "showAltAzGrid",
    "showAltAzGridText",
    "showConstellationBoundries",
    "showConstellationFigures",
    "showConstellationLabels",
    "showConstellationPictures",
    "showConstellations",
    "showConstellationSelection",
    "showCrosshairs",
    "showEarthSky",
    "showEcliptic",
    "showEclipticGrid",
    "showEclipticGridText",
    "showEclipticOverviewText",
    "showElevationModel",
    "showEquatorialGridText",
    "showGalacticGrid",
    "showGalacticGridText",
    "showGrid",
    "showHorizon",
    "showISSModel",
    "showPrecessionChart",
    "showSkyGrids",
    "showSkyOverlays",
    "showSkyOverlaysIn3d",
    "showSkyNode",
    "showSolarSystem",
    "smoothPan",
    "solarSystemCMB",
    "solarSystemCosmos",
    "solarSystemLighting",
    "solarSystemMilkyWay",
    "solarSystemMinorPlanets",
    "solarSystemMultiRes",
    "solarSystemOrbits",
    "solarSystemOverlays",
    "solarSystemPlanets",
    "solarSystemScale",
    "solarSystemStars",
    "solarSystemMinorOrbits",
];
var engineSettingTypeInfo = {
    "altAzGridColor/Color": true,
    "constellationArtFilter/ConstellationFilter": true,
    "constellationBoundariesFilter/ConstellationFilter": true,
    "constellationBoundryColor/Color": true,
    "constellationFigureColor/Color": true,
    "constellationFiguresFilter/ConstellationFilter": true,
    "constellationNamesFilter/ConstellationFilter": true,
    "constellationSelectionColor/Color": true,
    "crosshairsColor/Color": true,
    "eclipticColor/Color": true,
    "eclipticGridColor/Color": true,
    "equatorialGridColor/Color": true,
    "galacticGridColor/Color": true,
    "precessionChartColor/Color": true,
};
/** Type guard function for `EngineSetting`. */
function isEngineSetting(obj) {
    var typekey = typeof obj[1];
    if (obj[1] instanceof Color) {
        typekey = "Color";
    }
    else if (obj[1] instanceof ConstellationFilter) {
        typekey = "ConstellationFilter";
    }
    var key = obj[0] + "/" + typekey;
    return isBaseEngineSetting(obj) || (key in engineSettingTypeInfo);
}
/** Apply a setting to the engine or an equivalent. */
function applyEngineSetting(engine, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    engine[funcName](value);
}
/** Extract all of the current settings of the engine or an equivalent. */
function extractEngineSettings(engine) {
    var e_1, _a;
    var s = [];
    try {
        for (var engineSettingNames_1 = __values(engineSettingNames), engineSettingNames_1_1 = engineSettingNames_1.next(); !engineSettingNames_1_1.done; engineSettingNames_1_1 = engineSettingNames_1.next()) {
            var n = engineSettingNames_1_1.value;
            s.push([n, engine["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (engineSettingNames_1_1 && !engineSettingNames_1_1.done && (_a = engineSettingNames_1.return)) _a.call(engineSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from the engine, or an equivalent, to another. */
function copyEngineSettings(source, dest) {
    var e_2, _a;
    try {
        for (var engineSettingNames_2 = tslib_es6_values(engineSettingNames), engineSettingNames_2_1 = engineSettingNames_2.next(); !engineSettingNames_2_1.done; engineSettingNames_2_1 = engineSettingNames_2.next()) {
            var n = engineSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (engineSettingNames_2_1 && !engineSettingNames_2_1.done && (_a = engineSettingNames_2.return)) _a.call(engineSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `EngineSettingsInterface`. */
var EngineState = /** @class */ (function () {
    function EngineState(source) {
        copyEngineSettings(source, this);
    }
    EngineState.prototype.get_actualPlanetScale = function () {
        return this.actualPlanetScale;
    };
    EngineState.prototype.set_actualPlanetScale = function (v) {
        this.actualPlanetScale = v;
        return v;
    };
    EngineState.prototype.get_constellationArtFilter = function () {
        return this.constellationArtFilter;
    };
    EngineState.prototype.set_constellationArtFilter = function (v) {
        this.constellationArtFilter = v;
        return v;
    };
    EngineState.prototype.get_constellationBoundariesFilter = function () {
        return this.constellationBoundariesFilter;
    };
    EngineState.prototype.set_constellationBoundariesFilter = function (v) {
        this.constellationBoundariesFilter = v;
        return v;
    };
    EngineState.prototype.get_constellationFigureColor = function () {
        return this.constellationFigureColor;
    };
    EngineState.prototype.set_constellationFigureColor = function (v) {
        this.constellationFigureColor = v;
        return v;
    };
    EngineState.prototype.get_constellationFiguresFilter = function () {
        return this.constellationFiguresFilter;
    };
    EngineState.prototype.set_constellationFiguresFilter = function (v) {
        this.constellationFiguresFilter = v;
        return v;
    };
    EngineState.prototype.get_constellationBoundryColor = function () {
        return this.constellationBoundryColor;
    };
    EngineState.prototype.set_constellationBoundryColor = function (v) {
        this.constellationBoundryColor = v;
        return v;
    };
    EngineState.prototype.get_constellationNamesFilter = function () {
        return this.constellationNamesFilter;
    };
    EngineState.prototype.set_constellationNamesFilter = function (v) {
        this.constellationNamesFilter = v;
        return v;
    };
    EngineState.prototype.get_constellations = function () {
        return this.constellations;
    };
    EngineState.prototype.set_constellations = function (v) {
        this.constellations = v;
        return v;
    };
    EngineState.prototype.get_constellationSelectionColor = function () {
        return this.constellationSelectionColor;
    };
    EngineState.prototype.set_constellationSelectionColor = function (v) {
        this.constellationSelectionColor = v;
        return v;
    };
    EngineState.prototype.get_constellationsEnabled = function () {
        return this.constellationsEnabled;
    };
    EngineState.prototype.set_constellationsEnabled = function (v) {
        this.constellationsEnabled = v;
        return v;
    };
    EngineState.prototype.get_crosshairsColor = function () {
        return this.crosshairsColor;
    };
    EngineState.prototype.set_crosshairsColor = function (v) {
        this.crosshairsColor = v;
        return v;
    };
    EngineState.prototype.get_earthCutawayView = function () {
        return this.earthCutawayView;
    };
    EngineState.prototype.set_earthCutawayView = function (v) {
        this.earthCutawayView = v;
        return v;
    };
    EngineState.prototype.get_galacticMode = function () {
        return this.galacticMode;
    };
    EngineState.prototype.set_galacticMode = function (v) {
        this.galacticMode = v;
        return v;
    };
    EngineState.prototype.get_localHorizonMode = function () {
        return this.localHorizonMode;
    };
    EngineState.prototype.set_localHorizonMode = function (v) {
        this.localHorizonMode = v;
        return v;
    };
    EngineState.prototype.get_locationAltitude = function () {
        return this.locationAltitude;
    };
    EngineState.prototype.set_locationAltitude = function (v) {
        this.locationAltitude = v;
        return v;
    };
    EngineState.prototype.get_locationLat = function () {
        return this.locationLat;
    };
    EngineState.prototype.set_locationLat = function (v) {
        this.locationLat = v;
        return v;
    };
    EngineState.prototype.get_locationLng = function () {
        return this.locationLng;
    };
    EngineState.prototype.set_locationLng = function (v) {
        this.locationLng = v;
        return v;
    };
    EngineState.prototype.get_milkyWayModel = function () {
        return this.milkyWayModel;
    };
    EngineState.prototype.set_milkyWayModel = function (v) {
        this.milkyWayModel = v;
        return v;
    };
    EngineState.prototype.get_minorPlanetsFilter = function () {
        return this.minorPlanetsFilter;
    };
    EngineState.prototype.set_minorPlanetsFilter = function (v) {
        this.minorPlanetsFilter = v;
        return v;
    };
    EngineState.prototype.get_planetOrbitsFilter = function () {
        return this.planetOrbitsFilter;
    };
    EngineState.prototype.set_planetOrbitsFilter = function (v) {
        this.planetOrbitsFilter = v;
        return v;
    };
    EngineState.prototype.get_showAltAzGrid = function () {
        return this.showAltAzGrid;
    };
    EngineState.prototype.set_showAltAzGrid = function (v) {
        this.showAltAzGrid = v;
        return v;
    };
    EngineState.prototype.get_showAltAzGridText = function () {
        return this.showAltAzGridText;
    };
    EngineState.prototype.set_showAltAzGridText = function (v) {
        this.showAltAzGridText = v;
        return v;
    };
    EngineState.prototype.get_showConstellationBoundries = function () {
        return this.showConstellationBoundries;
    };
    EngineState.prototype.set_showConstellationBoundries = function (v) {
        this.showConstellationBoundries = v;
        return v;
    };
    EngineState.prototype.get_showConstellationFigures = function () {
        return this.showConstellationFigures;
    };
    EngineState.prototype.set_showConstellationFigures = function (v) {
        this.showConstellationFigures = v;
        return v;
    };
    EngineState.prototype.get_showConstellationLabels = function () {
        return this.showConstellationLabels;
    };
    EngineState.prototype.set_showConstellationLabels = function (v) {
        this.showConstellationLabels = v;
        return v;
    };
    EngineState.prototype.get_showConstellationPictures = function () {
        return this.showConstellationPictures;
    };
    EngineState.prototype.set_showConstellationPictures = function (v) {
        this.showConstellationPictures = v;
        return v;
    };
    EngineState.prototype.get_showConstellations = function () {
        return this.showConstellations;
    };
    EngineState.prototype.set_showConstellations = function (v) {
        this.showConstellations = v;
        return v;
    };
    EngineState.prototype.get_showConstellationSelection = function () {
        return this.showConstellationSelection;
    };
    EngineState.prototype.set_showConstellationSelection = function (v) {
        this.showConstellationSelection = v;
        return v;
    };
    EngineState.prototype.get_showCrosshairs = function () {
        return this.showCrosshairs;
    };
    EngineState.prototype.set_showCrosshairs = function (v) {
        this.showCrosshairs = v;
        return v;
    };
    EngineState.prototype.get_showEarthSky = function () {
        return this.showEarthSky;
    };
    EngineState.prototype.set_showEarthSky = function (v) {
        this.showEarthSky = v;
        return v;
    };
    EngineState.prototype.get_showEcliptic = function () {
        return this.showEcliptic;
    };
    EngineState.prototype.set_showEcliptic = function (v) {
        this.showEcliptic = v;
        return v;
    };
    EngineState.prototype.get_showEclipticGrid = function () {
        return this.showEclipticGrid;
    };
    EngineState.prototype.set_showEclipticGrid = function (v) {
        this.showEclipticGrid = v;
        return v;
    };
    EngineState.prototype.get_showEclipticGridText = function () {
        return this.showEclipticGridText;
    };
    EngineState.prototype.set_showEclipticGridText = function (v) {
        this.showEclipticGridText = v;
        return v;
    };
    EngineState.prototype.get_showEclipticOverviewText = function () {
        return this.showEclipticOverviewText;
    };
    EngineState.prototype.set_showEclipticOverviewText = function (v) {
        this.showEclipticOverviewText = v;
        return v;
    };
    EngineState.prototype.get_showElevationModel = function () {
        return this.showElevationModel;
    };
    EngineState.prototype.set_showElevationModel = function (v) {
        this.showElevationModel = v;
        return v;
    };
    EngineState.prototype.get_showEquatorialGridText = function () {
        return this.showEquatorialGridText;
    };
    EngineState.prototype.set_showEquatorialGridText = function (v) {
        this.showEquatorialGridText = v;
        return v;
    };
    EngineState.prototype.get_showGalacticGrid = function () {
        return this.showGalacticGrid;
    };
    EngineState.prototype.set_showGalacticGrid = function (v) {
        this.showGalacticGrid = v;
        return v;
    };
    EngineState.prototype.get_showGalacticGridText = function () {
        return this.showGalacticGridText;
    };
    EngineState.prototype.set_showGalacticGridText = function (v) {
        this.showGalacticGridText = v;
        return v;
    };
    EngineState.prototype.get_showGrid = function () {
        return this.showGrid;
    };
    EngineState.prototype.set_showGrid = function (v) {
        this.showGrid = v;
        return v;
    };
    EngineState.prototype.get_showHorizon = function () {
        return this.showHorizon;
    };
    EngineState.prototype.set_showHorizon = function (v) {
        this.showHorizon = v;
        return v;
    };
    EngineState.prototype.get_showISSModel = function () {
        return this.showISSModel;
    };
    EngineState.prototype.set_showISSModel = function (v) {
        this.showISSModel = v;
        return v;
    };
    EngineState.prototype.get_showPrecessionChart = function () {
        return this.showPrecessionChart;
    };
    EngineState.prototype.set_showPrecessionChart = function (v) {
        this.showPrecessionChart = v;
        return v;
    };
    EngineState.prototype.get_showSkyGrids = function () {
        return this.showSkyGrids;
    };
    EngineState.prototype.set_showSkyGrids = function (v) {
        this.showSkyGrids = v;
        return v;
    };
    EngineState.prototype.get_showSkyOverlays = function () {
        return this.showSkyOverlays;
    };
    EngineState.prototype.set_showSkyOverlays = function (v) {
        this.showSkyOverlays = v;
        return v;
    };
    EngineState.prototype.get_showSkyOverlaysIn3d = function () {
        return this.showSkyOverlaysIn3d;
    };
    EngineState.prototype.set_showSkyOverlaysIn3d = function (v) {
        this.showSkyOverlaysIn3d = v;
        return v;
    };
    EngineState.prototype.get_showSkyNode = function () {
        return this.showSkyNode;
    };
    EngineState.prototype.set_showSkyNode = function (v) {
        this.showSkyNode = v;
        return v;
    };
    EngineState.prototype.get_showSolarSystem = function () {
        return this.showSolarSystem;
    };
    EngineState.prototype.set_showSolarSystem = function (v) {
        this.showSolarSystem = v;
        return v;
    };
    EngineState.prototype.get_smoothPan = function () {
        return this.smoothPan;
    };
    EngineState.prototype.set_smoothPan = function (v) {
        this.smoothPan = v;
        return v;
    };
    EngineState.prototype.get_solarSystemCMB = function () {
        return this.solarSystemCMB;
    };
    EngineState.prototype.set_solarSystemCMB = function (v) {
        this.solarSystemCMB = v;
        return v;
    };
    EngineState.prototype.get_solarSystemCosmos = function () {
        return this.solarSystemCosmos;
    };
    EngineState.prototype.set_solarSystemCosmos = function (v) {
        this.solarSystemCosmos = v;
        return v;
    };
    EngineState.prototype.get_solarSystemLighting = function () {
        return this.solarSystemLighting;
    };
    EngineState.prototype.set_solarSystemLighting = function (v) {
        this.solarSystemLighting = v;
        return v;
    };
    EngineState.prototype.get_solarSystemMilkyWay = function () {
        return this.solarSystemMilkyWay;
    };
    EngineState.prototype.set_solarSystemMilkyWay = function (v) {
        this.solarSystemMilkyWay = v;
        return v;
    };
    EngineState.prototype.get_solarSystemMinorPlanets = function () {
        return this.solarSystemMinorPlanets;
    };
    EngineState.prototype.set_solarSystemMinorPlanets = function (v) {
        this.solarSystemMinorPlanets = v;
        return v;
    };
    EngineState.prototype.get_solarSystemMultiRes = function () {
        return this.solarSystemMultiRes;
    };
    EngineState.prototype.set_solarSystemMultiRes = function (v) {
        this.solarSystemMultiRes = v;
        return v;
    };
    EngineState.prototype.get_solarSystemOrbits = function () {
        return this.solarSystemOrbits;
    };
    EngineState.prototype.set_solarSystemOrbits = function (v) {
        this.solarSystemOrbits = v;
        return v;
    };
    EngineState.prototype.get_solarSystemOverlays = function () {
        return this.solarSystemOverlays;
    };
    EngineState.prototype.set_solarSystemOverlays = function (v) {
        this.solarSystemOverlays = v;
        return v;
    };
    EngineState.prototype.get_solarSystemPlanets = function () {
        return this.solarSystemPlanets;
    };
    EngineState.prototype.set_solarSystemPlanets = function (v) {
        this.solarSystemPlanets = v;
        return v;
    };
    EngineState.prototype.get_solarSystemScale = function () {
        return this.solarSystemScale;
    };
    EngineState.prototype.set_solarSystemScale = function (v) {
        this.solarSystemScale = v;
        return v;
    };
    EngineState.prototype.get_solarSystemStars = function () {
        return this.solarSystemStars;
    };
    EngineState.prototype.set_solarSystemStars = function (v) {
        this.solarSystemStars = v;
        return v;
    };
    EngineState.prototype.get_solarSystemMinorOrbits = function () {
        return this.solarSystemMinorOrbits;
    };
    EngineState.prototype.set_solarSystemMinorOrbits = function (v) {
        this.solarSystemMinorOrbits = v;
        return v;
    };
    return EngineState;
}());

//# sourceMappingURL=engine.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/polyannotation.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License


var justPolyAnnotationSettingNames = [
    "fill",
    "fillColor",
    "lineColor",
    "lineWidth",
];
/** A list of the names of the available settings for `PolyAnnotation`
 * instances and their equivalents (things implementing
 * {@link PolyAnnotationSettingsInterface}).
 *
 * This is a superset of the names available for generic annotations.
*/
var polyAnnotationSettingNames = annotationSettingNames.concat(justPolyAnnotationSettingNames);
var polyAnnotationSettingTypeInfo = {
    "fill/boolean": true,
    "fillColor/string": true,
    "lineColor/string": true,
    "lineWidth/number": true,
};
/** Type guard function for `PolyAnnotationSetting`. */
function isPolyAnnotationSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in polyAnnotationSettingTypeInfo) || isAnnotationSetting(obj);
}
/** Apply a setting to a generic `PolyAnnotation` or equivalent. */
function applyPolyAnnotationSetting(poly, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    poly[funcName](value);
}
/** Extract all of the current settings of a `PolyAnnotation` or equivalent. */
function extractPolyAnnotationSettings(poly) {
    var e_1, _a;
    var s = extractAnnotationSettings(poly);
    try {
        for (var justPolyAnnotationSettingNames_1 = __values(justPolyAnnotationSettingNames), justPolyAnnotationSettingNames_1_1 = justPolyAnnotationSettingNames_1.next(); !justPolyAnnotationSettingNames_1_1.done; justPolyAnnotationSettingNames_1_1 = justPolyAnnotationSettingNames_1.next()) {
            var n = justPolyAnnotationSettingNames_1_1.value;
            s.push([n, poly["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justPolyAnnotationSettingNames_1_1 && !justPolyAnnotationSettingNames_1_1.done && (_a = justPolyAnnotationSettingNames_1.return)) _a.call(justPolyAnnotationSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `PolyAnnotation`, or equivalent, to another. */
function copyPolyAnnotationSettings(source, dest) {
    var e_2, _a;
    copyAnnotationSettings(source, dest);
    try {
        for (var justPolyAnnotationSettingNames_2 = tslib_es6_values(justPolyAnnotationSettingNames), justPolyAnnotationSettingNames_2_1 = justPolyAnnotationSettingNames_2.next(); !justPolyAnnotationSettingNames_2_1.done; justPolyAnnotationSettingNames_2_1 = justPolyAnnotationSettingNames_2.next()) {
            var n = justPolyAnnotationSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justPolyAnnotationSettingNames_2_1 && !justPolyAnnotationSettingNames_2_1.done && (_a = justPolyAnnotationSettingNames_2.return)) _a.call(justPolyAnnotationSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `PolyAnnotationSettingsInterface`. */
var PolyAnnotationState = /** @class */ (function (_super) {
    __extends(PolyAnnotationState, _super);
    function PolyAnnotationState(source) {
        var _this = _super.call(this, source) || this;
        copyPolyAnnotationSettings(source, _this);
        return _this;
    }
    PolyAnnotationState.prototype.get_fill = function () {
        return this.fill;
    };
    PolyAnnotationState.prototype.set_fill = function (v) {
        this.fill = v;
        return v;
    };
    PolyAnnotationState.prototype.get_fillColor = function () {
        return this.fillColor;
    };
    PolyAnnotationState.prototype.set_fillColor = function (v) {
        this.fillColor = v;
        return v;
    };
    PolyAnnotationState.prototype.get_lineColor = function () {
        return this.lineColor;
    };
    PolyAnnotationState.prototype.set_lineColor = function (v) {
        this.lineColor = v;
        return v;
    };
    PolyAnnotationState.prototype.get_lineWidth = function () {
        return this.lineWidth;
    };
    PolyAnnotationState.prototype.set_lineWidth = function (v) {
        this.lineWidth = v;
        return v;
    };
    return PolyAnnotationState;
}(AnnotationState));

//# sourceMappingURL=polyannotation.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/polylineannotation.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License


var justPolyLineAnnotationSettingNames = [
    "lineColor",
    "lineWidth",
];
/** A list of the names of the available settings for `PolyLineAnnotation`
 * instances and their equivalents (things implementing
 * {@link PolyLineAnnotationSettingsInterface}).
 *
 * This is a superset of the names available for generic annotations.
*/
var polyLineAnnotationSettingNames = annotationSettingNames.concat(justPolyLineAnnotationSettingNames);
var polyLineAnnotationSettingTypeInfo = {
    "lineColor/string": true,
    "lineWidth/number": true,
};
/** Type guard function for `PolyLineAnnotationSetting`. */
function isPolyLineAnnotationSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in polyLineAnnotationSettingTypeInfo) || isAnnotationSetting(obj);
}
/** Apply a setting to a generic `PolyLineAnnotation` or equivalent. */
function applyPolyLineAnnotationSetting(poly, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1];
    poly[funcName](value);
}
/** Extract all of the current settings of a `PolyLineAnnotation` or equivalent. */
function extractPolyLineAnnotationSettings(poly) {
    var e_1, _a;
    var s = extractAnnotationSettings(poly);
    try {
        for (var justPolyLineAnnotationSettingNames_1 = __values(justPolyLineAnnotationSettingNames), justPolyLineAnnotationSettingNames_1_1 = justPolyLineAnnotationSettingNames_1.next(); !justPolyLineAnnotationSettingNames_1_1.done; justPolyLineAnnotationSettingNames_1_1 = justPolyLineAnnotationSettingNames_1.next()) {
            var n = justPolyLineAnnotationSettingNames_1_1.value;
            s.push([n, poly["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justPolyLineAnnotationSettingNames_1_1 && !justPolyLineAnnotationSettingNames_1_1.done && (_a = justPolyLineAnnotationSettingNames_1.return)) _a.call(justPolyLineAnnotationSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `PolyLineAnnotation`, or equivalent, to another. */
function copyPolyLineAnnotationSettings(source, dest) {
    var e_2, _a;
    copyAnnotationSettings(source, dest);
    try {
        for (var justPolyLineAnnotationSettingNames_2 = tslib_es6_values(justPolyLineAnnotationSettingNames), justPolyLineAnnotationSettingNames_2_1 = justPolyLineAnnotationSettingNames_2.next(); !justPolyLineAnnotationSettingNames_2_1.done; justPolyLineAnnotationSettingNames_2_1 = justPolyLineAnnotationSettingNames_2.next()) {
            var n = justPolyLineAnnotationSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justPolyLineAnnotationSettingNames_2_1 && !justPolyLineAnnotationSettingNames_2_1.done && (_a = justPolyLineAnnotationSettingNames_2.return)) _a.call(justPolyLineAnnotationSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `PolyLineAnnotationSettingsInterface`. */
var PolyLineAnnotationState = /** @class */ (function (_super) {
    __extends(PolyLineAnnotationState, _super);
    function PolyLineAnnotationState(source) {
        var _this = _super.call(this, source) || this;
        copyPolyLineAnnotationSettings(source, _this);
        return _this;
    }
    PolyLineAnnotationState.prototype.get_lineColor = function () {
        return this.lineColor;
    };
    PolyLineAnnotationState.prototype.set_lineColor = function (v) {
        this.lineColor = v;
        return v;
    };
    PolyLineAnnotationState.prototype.get_lineWidth = function () {
        return this.lineWidth;
    };
    PolyLineAnnotationState.prototype.set_lineWidth = function (v) {
        this.lineWidth = v;
        return v;
    };
    return PolyLineAnnotationState;
}(AnnotationState));

//# sourceMappingURL=polylineannotation.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/votablelayer.js
// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Helpers for handling "spreadsheet" layer settings. */


var justVoTableLayerSettingNames = [
    "altColumn",
    "altType",
    "altUnit",
    "autoUpdate",
    "beginRange",
    "cartesianCustomScale",
    "cartesianScale",
    "colorMapColumn",
    "coordinatesType",
    "dataSourceUrl",
    "decay",
    "dynamicData",
    "endDateColumn",
    "endRange",
    "hyperlinkColumn",
    "hyperlinkFormat",
    "latColumn",
    "lngColumn",
    "markerColumn",
    "markerIndex",
    "markerScale",
    "nameColumn",
    "plotType",
    "pointScaleType",
    "raUnits",
    "scaleFactor",
    "showFarSide",
    "sizeColumn",
    "startDateColumn",
    "timeSeries",
    "xAxisColumn",
    "xAxisReverse",
    "yAxisColumn",
    "yAxisReverse",
    "zAxisColumn",
    "zAxisReverse",
];
/** A list of the names of the available settings for `VoTableLayer`
 * instances and their equivalents (things implementing
 * {@link VoTableLayerSettingsInterface}).
 *
 * This is a superset of the names available for generic layers.
*/
var voTableLayerSettingNames = layerSettingNames.concat(justVoTableLayerSettingNames);
/** Type guard function for `VoTableLayerSetting`. */
function isVoTableLayerSetting(obj) {
    // No special settings specific to non-base VoTableLayerSetting.
    return isLayerSetting(obj) || isBaseVoTableLayerSetting(obj);
}
/** Apply a setting to a `VoTableLayer` or equivalent. */
function applyVoTableLayerSetting(layer, setting) {
    var funcName = "set_" + setting[0];
    var value = setting[1]; // eslint-disable-line @typescript-eslint/no-explicit-any
    layer[funcName](value); // eslint-disable-line @typescript-eslint/no-explicit-any
}
/** Extract all of the current settings of a `VoTableLayer` or equivalent. */
function extractVoTableLayerSettings(layer) {
    var e_1, _a;
    var s = extractLayerSettings(layer);
    try {
        for (var justVoTableLayerSettingNames_1 = __values(justVoTableLayerSettingNames), justVoTableLayerSettingNames_1_1 = justVoTableLayerSettingNames_1.next(); !justVoTableLayerSettingNames_1_1.done; justVoTableLayerSettingNames_1_1 = justVoTableLayerSettingNames_1.next()) {
            var n = justVoTableLayerSettingNames_1_1.value;
            s.push([n, layer["get_" + n]()]);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (justVoTableLayerSettingNames_1_1 && !justVoTableLayerSettingNames_1_1.done && (_a = justVoTableLayerSettingNames_1.return)) _a.call(justVoTableLayerSettingNames_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return s;
}
/** Copy settings from one `VoTableLayer`, or equivalent, to another. */
function copyVoTableLayerSettings(source, dest) {
    var e_2, _a;
    copyLayerSettings(source, dest);
    try {
        for (var justVoTableLayerSettingNames_2 = tslib_es6_values(justVoTableLayerSettingNames), justVoTableLayerSettingNames_2_1 = justVoTableLayerSettingNames_2.next(); !justVoTableLayerSettingNames_2_1.done; justVoTableLayerSettingNames_2_1 = justVoTableLayerSettingNames_2.next()) {
            var n = justVoTableLayerSettingNames_2_1.value;
            dest["set_" + n](source["get_" + n]());
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (justVoTableLayerSettingNames_2_1 && !justVoTableLayerSettingNames_2_1.done && (_a = justVoTableLayerSettingNames_2.return)) _a.call(justVoTableLayerSettingNames_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/** A plain-old-data class implementing `VoTableLayerSettingsInterface`. */
var VoTableLayerState = /** @class */ (function (_super) {
    __extends(VoTableLayerState, _super);
    function VoTableLayerState(source) {
        var _this = 
        // Here we redundantly copy the generic Layer settings, but TypeScript
        // requires the super() call. Oh well.
        _super.call(this, source) || this;
        copyVoTableLayerSettings(source, _this);
        return _this;
    }
    VoTableLayerState.prototype.get_altColumn = function () {
        return this.altColumn;
    };
    VoTableLayerState.prototype.set_altColumn = function (v) {
        this.altColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_altType = function () {
        return this.altType;
    };
    VoTableLayerState.prototype.set_altType = function (v) {
        this.altType = v;
        return v;
    };
    VoTableLayerState.prototype.get_altUnit = function () {
        return this.altUnit;
    };
    VoTableLayerState.prototype.set_altUnit = function (v) {
        this.altUnit = v;
        return v;
    };
    VoTableLayerState.prototype.get_autoUpdate = function () {
        return this.autoUpdate;
    };
    VoTableLayerState.prototype.set_autoUpdate = function (v) {
        this.autoUpdate = v;
        return v;
    };
    VoTableLayerState.prototype.get_beginRange = function () {
        return this.beginRange;
    };
    VoTableLayerState.prototype.set_beginRange = function (v) {
        this.beginRange = v;
        return v;
    };
    VoTableLayerState.prototype.get_cartesianCustomScale = function () {
        return this.cartesianCustomScale;
    };
    VoTableLayerState.prototype.set_cartesianCustomScale = function (v) {
        this.cartesianCustomScale = v;
        return v;
    };
    VoTableLayerState.prototype.get_cartesianScale = function () {
        return this.cartesianScale;
    };
    VoTableLayerState.prototype.set_cartesianScale = function (v) {
        this.cartesianScale = v;
        return v;
    };
    VoTableLayerState.prototype.get_colorMapColumn = function () {
        return this.colorMapColumn;
    };
    VoTableLayerState.prototype.set_colorMapColumn = function (v) {
        this.colorMapColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_coordinatesType = function () {
        return this.coordinatesType;
    };
    VoTableLayerState.prototype.set_coordinatesType = function (v) {
        this.coordinatesType = v;
        return v;
    };
    VoTableLayerState.prototype.get_dataSourceUrl = function () {
        return this.dataSourceUrl;
    };
    VoTableLayerState.prototype.set_dataSourceUrl = function (v) {
        this.dataSourceUrl = v;
        return v;
    };
    VoTableLayerState.prototype.get_decay = function () {
        return this.decay;
    };
    VoTableLayerState.prototype.set_decay = function (v) {
        this.decay = v;
        return v;
    };
    VoTableLayerState.prototype.get_dynamicData = function () {
        return this.dynamicData;
    };
    VoTableLayerState.prototype.set_dynamicData = function (v) {
        this.dynamicData = v;
        return v;
    };
    VoTableLayerState.prototype.get_endDateColumn = function () {
        return this.endDateColumn;
    };
    VoTableLayerState.prototype.set_endDateColumn = function (v) {
        this.endDateColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_endRange = function () {
        return this.endRange;
    };
    VoTableLayerState.prototype.set_endRange = function (v) {
        this.endRange = v;
        return v;
    };
    VoTableLayerState.prototype.get_hyperlinkColumn = function () {
        return this.hyperlinkColumn;
    };
    VoTableLayerState.prototype.set_hyperlinkColumn = function (v) {
        this.hyperlinkColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_hyperlinkFormat = function () {
        return this.hyperlinkFormat;
    };
    VoTableLayerState.prototype.set_hyperlinkFormat = function (v) {
        this.hyperlinkFormat = v;
        return v;
    };
    VoTableLayerState.prototype.get_latColumn = function () {
        return this.latColumn;
    };
    VoTableLayerState.prototype.set_latColumn = function (v) {
        this.latColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_lngColumn = function () {
        return this.lngColumn;
    };
    VoTableLayerState.prototype.set_lngColumn = function (v) {
        this.lngColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_markerColumn = function () {
        return this.markerColumn;
    };
    VoTableLayerState.prototype.set_markerColumn = function (v) {
        this.markerColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_markerIndex = function () {
        return this.markerIndex;
    };
    VoTableLayerState.prototype.set_markerIndex = function (v) {
        this.markerIndex = v;
        return v;
    };
    VoTableLayerState.prototype.get_markerScale = function () {
        return this.markerScale;
    };
    VoTableLayerState.prototype.set_markerScale = function (v) {
        this.markerScale = v;
        return v;
    };
    VoTableLayerState.prototype.get_nameColumn = function () {
        return this.nameColumn;
    };
    VoTableLayerState.prototype.set_nameColumn = function (v) {
        this.nameColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_plotType = function () {
        return this.plotType;
    };
    VoTableLayerState.prototype.set_plotType = function (v) {
        this.plotType = v;
        return v;
    };
    VoTableLayerState.prototype.get_pointScaleType = function () {
        return this.pointScaleType;
    };
    VoTableLayerState.prototype.set_pointScaleType = function (v) {
        this.pointScaleType = v;
        return v;
    };
    VoTableLayerState.prototype.get_raUnits = function () {
        return this.raUnits;
    };
    VoTableLayerState.prototype.set_raUnits = function (v) {
        this.raUnits = v;
        return v;
    };
    VoTableLayerState.prototype.get_scaleFactor = function () {
        return this.scaleFactor;
    };
    VoTableLayerState.prototype.set_scaleFactor = function (v) {
        this.scaleFactor = v;
        return v;
    };
    VoTableLayerState.prototype.get_showFarSide = function () {
        return this.showFarSide;
    };
    VoTableLayerState.prototype.set_showFarSide = function (v) {
        this.showFarSide = v;
        return v;
    };
    VoTableLayerState.prototype.get_sizeColumn = function () {
        return this.sizeColumn;
    };
    VoTableLayerState.prototype.set_sizeColumn = function (v) {
        this.sizeColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_startDateColumn = function () {
        return this.startDateColumn;
    };
    VoTableLayerState.prototype.set_startDateColumn = function (v) {
        this.startDateColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_timeSeries = function () {
        return this.timeSeries;
    };
    VoTableLayerState.prototype.set_timeSeries = function (v) {
        this.timeSeries = v;
        return v;
    };
    VoTableLayerState.prototype.get_xAxisColumn = function () {
        return this.xAxisColumn;
    };
    VoTableLayerState.prototype.set_xAxisColumn = function (v) {
        this.xAxisColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_xAxisReverse = function () {
        return this.xAxisReverse;
    };
    VoTableLayerState.prototype.set_xAxisReverse = function (v) {
        this.xAxisReverse = v;
        return v;
    };
    VoTableLayerState.prototype.get_yAxisColumn = function () {
        return this.yAxisColumn;
    };
    VoTableLayerState.prototype.set_yAxisColumn = function (v) {
        this.yAxisColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_yAxisReverse = function () {
        return this.yAxisReverse;
    };
    VoTableLayerState.prototype.set_yAxisReverse = function (v) {
        this.yAxisReverse = v;
        return v;
    };
    VoTableLayerState.prototype.get_zAxisColumn = function () {
        return this.zAxisColumn;
    };
    VoTableLayerState.prototype.set_zAxisColumn = function (v) {
        this.zAxisColumn = v;
        return v;
    };
    VoTableLayerState.prototype.get_zAxisReverse = function () {
        return this.zAxisReverse;
    };
    VoTableLayerState.prototype.set_zAxisReverse = function (v) {
        this.zAxisReverse = v;
        return v;
    };
    return VoTableLayerState;
}(LayerState));

//# sourceMappingURL=votablelayer.js.map
;// CONCATENATED MODULE: ../engine-helpers/dist/src/index.js
// Copyright 2020-2023 the .NET Foundation
// Licensed under the MIT License






// Settings-related re-exports









var SavedPromise = /** @class */ (function () {
    function SavedPromise(payload, resolve, reject) {
        this.payload = payload;
        this.resolve = resolve;
        this.reject = reject;
    }
    return SavedPromise;
}());
var WWTInstance = /** @class */ (function () {
    /** Create a WWT control, attaching it to a DOM element.
     *
     * @param options Options to apply to the control.
     *
     * Compared to the underlying library, this class provides a more JavaScript-y
     * API.
     */
    function WWTInstance(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        // Ready promises
        this.readyPromises = [];
        this.readyFired = false;
        // Arrival promises
        this.arrivePromises = [];
        this.arriveSeqnum = 0;
        // Collection-loaded promises. To simplify the handling, we never load the
        // same URL more than once. Otherwise, all of the timing issues about multiple
        // requests for the same URL get gnarly to handle. And as far as the engine is
        // concerned, collection loads are idempotent.
        this.collectionLoadedPromises = [];
        this.collectionRequests = new Map();
        this.tourReadyPromises = [];
        this.tourReadySeqnum = 0;
        /** A callback to be invoked when a tour completes playing. */
        this.tourEndedCallback = null;
        var builder = new engine_root_wwtlib_.WWTControlBuilder(options.elId || "wwt");
        if (options.startInternalRenderLoop !== undefined) {
            builder.startRenderLoop(options.startInternalRenderLoop);
        }
        if (options.freestandingAssetBaseurl !== undefined) {
            builder.freestandingMode(options.freestandingAssetBaseurl);
        }
        if (options.startLatDeg !== undefined && options.startLngDeg !== undefined) {
            var zoom = options.startZoomDeg || 360;
            builder.initialView(options.startLatDeg, options.startLngDeg, zoom);
        }
        if (options.startMode !== undefined) {
            builder.initialMode(options.startMode);
        }
        // We pretend that these objects aren't all singletons. One day.
        this.si = builder.create();
        this.ctl = engine_root_wwtlib_.WWTControl.singleton;
        this.lm = engine_root_wwtlib_.LayerManager;
        this.stc = engine_root_wwtlib_.SpaceTimeController;
        // Override some defaults
        this.applySetting(["showConstellationBoundries", false]);
        this.applySetting(["showConstellationFigures", false]);
        this.applySetting(["showConstellationSelection", false]);
        this.applySetting(["showCrosshairs", false]);
        // Ready promise initialization:
        this.si.add_ready(function (_si) {
            var e_1, _a;
            try {
                for (var _b = tslib_es6_values(_this.readyPromises), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var p = _c.value;
                    p.resolve();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.readyFired = true;
            _this.readyPromises = [];
        });
        // Arrival promise initialization:
        this.si.add_arrived(function (_si, _args) {
            var e_2, _a;
            try {
                for (var _b = tslib_es6_values(_this.arrivePromises), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var p = _c.value;
                    if (p.payload < _this.arriveSeqnum) {
                        p.reject("superseded");
                    }
                    else {
                        p.resolve();
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            _this.arrivePromises = [];
        });
        // TourReady promise init:
        this.si.add_tourReady(function (_si) {
            var e_3, _a;
            try {
                for (var _b = tslib_es6_values(_this.tourReadyPromises), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var p = _c.value;
                    if (p.payload < _this.tourReadySeqnum) {
                        p.reject("superseded");
                    }
                    else {
                        p.resolve();
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            _this.tourReadyPromises = [];
        });
        // TourEnded event init:
        engine_root_wwtlib_.TourPlayer.add_tourEnded(function (_tpclass) {
            var tp = _this.getActiveTourPlayer();
            if (tp !== null && _this.tourEndedCallback !== null) {
                _this.tourEndedCallback(tp);
            }
        });
    }
    WWTInstance.prototype.waitForReady = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.readyFired) {
                            resolve();
                        }
                        else {
                            _this.readyPromises.push(new SavedPromise(null, resolve, reject));
                        }
                    })];
            });
        });
    };
    WWTInstance.prototype.makeArrivePromise = function (instantResolve) {
        var e_4, _a;
        var _this = this;
        this.arriveSeqnum += 1;
        var seq = this.arriveSeqnum;
        try {
            for (var _b = tslib_es6_values(this.arrivePromises), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                p.reject("superseded");
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        this.arrivePromises = [];
        return new Promise(function (resolve, reject) {
            if (_this.arriveSeqnum > seq) {
                reject("superseded");
            }
            else if (instantResolve) {
                resolve();
            }
            else {
                _this.arrivePromises.push(new SavedPromise(seq, resolve, reject));
            }
        });
    };
    /** Navigate the camera to the specified position, asynchronously.
     *
     * This wraps the underlying engine function of the same name, but homogenizing some
     * of the angular arguments to use radians.
     *
     * @param raRad The RA to seek to, in radians
     * @param decRad The declination to seek to, in radians
     * @param zoomDeg The zoom setting, in *degrees*
     * @param instant Whether to snap the camera instantly, or pan it
     * @param rollRad If specified, the roll of the target camera position, in radians
     * @param duration If specified, the duration of the motion (in seconds)
     * @returns A void promise that resolves when the camera arrives at the target position.
     */
    WWTInstance.prototype.gotoRADecZoom = function (raRad, decRad, zoomDeg, instant, rollRad, duration) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.ctl.gotoRADecZoom(raRad * R2H, decRad * R2D, zoomDeg, instant, rollRad, duration);
                return [2 /*return*/, this.makeArrivePromise(instant)];
            });
        });
    };
    /** Returns how long moving to a given position will take, in seconds.
     *
     * This wraps the underlying engine function of the same name, but homogenizing some
     * of the angular arguments to use radians.
     *
     * @param raRad The RA of the target position, in radians
     * @param decRad The declination of the target position, in radians
     * @param zoomDeg The zoom setting, in *degrees*
     * @param rollRad If specified, the roll of the target camera position, in radians
     * @returns The amount of time, in seconds, that moving to the given position would take.
     */
    WWTInstance.prototype.timeToRADecZoom = function (raRad, decRad, zoomDeg, rollRad) {
        var time = this.ctl.timeToRADecZoom(raRad * R2H, decRad * R2D, zoomDeg, rollRad);
        return time;
    };
    /** Command the view to show a Place.
     *
     * @param options The options for the goto command.
     */
    WWTInstance.prototype.gotoTarget = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.ctl.gotoTarget(options.place, options.noZoom, options.instant, options.trackObject);
                return [2 /*return*/, this.makeArrivePromise(options.instant)];
            });
        });
    };
    /** Add an imageset directly into the engine's database.
     *
     * If an imageset with the same URL has already been loaded, this is a no-op.
     *
     * @param imgset The imageset to add
     * @returns Either the input argument, if it was added to the engine's
     *   database, or the pre-existing imageset. The pre-existing imageset will
     *   have the same URL but might differ in other respects, such as its name.
     */
    WWTInstance.prototype.addImagesetToRepository = function (imgset) {
        return engine_root_wwtlib_.WWTControl.addImageSetToRepository(imgset);
    };
    /** Load a WTML collection and the imagesets that it contains.
    *
    * This function triggers a download of the specified URL, which should return
    * an XML document in the [WTML collection][wtml] format. Any `ImageSet`
    * entries in the collection, or `Place` entries containing image sets, will
    * be added to the WWT instance’s list of available imagery. Subsequent calls
    * to functions like {@link setForegroundImageByName} will be able to locate the
    * new imagesets and display them to the user.
    *
    * Each unique URL is only requested once. Once a given URL has been
    * successfully loaded, the promise returned by additional calls will resolve
    * immediately. URL uniqueness is tested with simple string equality, so if
    * you really want to load the same URL more than once you could add a
    * fragment specifier.
    *
    * If the URL is not accessible due to CORS restrictions, the request will
    * automatically be routed through the WWT’s CORS proxying service.
    *
    * [wtml]: https://docs.worldwidetelescope.org/data-guide/1/data-file-formats/collections/
    *
    * @param url: The URL of the WTML collection file to load.
    * @param loadChildFolders When true, this method will recursively
    * download and unpack the content of all Folders contained in the WTML file.
    * @returns: A promise that resolves to an initialized Folder object.
    */
    WWTInstance.prototype.loadImageCollection = function (url, loadChildFolders) {
        return __awaiter(this, void 0, void 0, function () {
            var curState, holder_1;
            var _this = this;
            return __generator(this, function (_a) {
                curState = this.collectionRequests.get(url);
                // If we've already loaded the folder, insta-resolve to it.
                if (curState !== undefined && curState !== null) {
                    return [2 /*return*/, Promise.resolve(curState)];
                }
                // If we haven't even issued the request, do so.
                if (curState === undefined) {
                    // Mark this URL as having an in-flight request.
                    this.collectionRequests.set(url, null);
                    holder_1 = { f: null };
                    if (loadChildFolders === undefined) {
                        loadChildFolders = false;
                    }
                    holder_1.f = engine_root_wwtlib_.Wtml.getWtmlFile(url, function () {
                        // The folder at this URL is now fully loaded.
                        var f = holder_1.f;
                        _this.collectionRequests.set(url, f);
                        _this.collectionLoadedPromises = _this.collectionLoadedPromises.filter(function (p) {
                            if (p.payload == url) {
                                p.resolve(f);
                                return false;
                            }
                            // Don't filter out promises for other URLs.
                            return true;
                        });
                    }, loadChildFolders);
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var curState = _this.collectionRequests.get(url);
                        // By the time this promise callback is called, maybe the Folder has fully
                        // loaded?
                        if (curState !== undefined && curState !== null) {
                            resolve(curState);
                        }
                        else {
                            // If not, queue ourselves up to be resolved when the data finally come
                            // through.
                            _this.collectionLoadedPromises.push(new SavedPromise(url, resolve, reject));
                        }
                    })];
            });
        });
    };
    // Layers
    /** Load an image set or a remote FITS file into a data layer and display it.
     *
     * The FITS file must be downloaded and processed, so this API is
     * asynchronous, and is not appropriate for files that might be large.
     *
     * The image set must have previously been created with {@link loadImageCollection}
     */
    WWTInstance.prototype.addImageSetLayer = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, _reject) {
                        _this.si.addImageSetLayer(options.url, options.mode, options.name, options.goto, function (layer) {
                            resolve(layer);
                        });
                    })];
            });
        });
    };
    /** Change the ImageSetLayer position in the layer stack. */
    WWTInstance.prototype.setImageSetLayerOrder = function (options) {
        this.si.setImageSetLayerOrder(options.id, options.order);
    };
    /** Change the "stretch" settings of a FITS image layer. */
    WWTInstance.prototype.stretchFitsLayer = function (options) {
        var layer = this.lm.get_layerList()[options.id];
        if (layer && layer instanceof engine_root_wwtlib_.ImageSetLayer) {
            layer.setImageScalePhysical(options.stretch, options.vmin, options.vmax);
            // This is kind of random, but follows the pywwt API implementation.
            var fits = layer.getFitsImage();
            if (fits !== null) {
                layer.get_imageSet().get_fitsProperties().transparentBlack = false;
            }
        }
    };
    /** Change the colormap settings of a FITS image layer. */
    WWTInstance.prototype.setFitsLayerColormap = function (options) {
        var layer = this.lm.get_layerList()[options.id];
        if (layer && layer instanceof engine_root_wwtlib_.ImageSetLayer) {
            layer.set_colorMapperName(options.name);
        }
    };
    /** Apply settings to a FITS image layer. */
    WWTInstance.prototype.applyFitsLayerSettings = function (options) {
        var e_5, _a;
        var layer = this.lm.get_layerList()[options.id];
        if (layer && layer instanceof engine_root_wwtlib_.ImageSetLayer) {
            try {
                for (var _b = tslib_es6_values(options.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var setting = _c.value;
                    applyImageSetLayerSetting(layer, setting);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    };
    /** Update the data within a tabular data layer. */
    WWTInstance.prototype.updateTableLayer = function (options) {
        var layer = this.lm.get_layerList()[options.id];
        if (layer && layer instanceof engine_root_wwtlib_.SpreadSheetLayer) {
            layer.updateData(options.dataCsv, true, true, true);
        }
    };
    /** Apply settings to a tabular data layer. */
    WWTInstance.prototype.applyTableLayerSettings = function (options) {
        var e_6, _a;
        var layer = this.lm.get_layerList()[options.id];
        if (layer && layer instanceof engine_root_wwtlib_.SpreadSheetLayer) {
            try {
                for (var _b = tslib_es6_values(options.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var setting = _c.value;
                    applySpreadSheetLayerSetting(layer, setting);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    };
    /** Add a new HiPS catalog to the view, by name.
     *
     * The promise will resolve when the catalog metadata have fully downloaded.
     * It will reject if the name is unrecognized.
     *
     * HiPS catalogs are something of an awkward hybrid. They are managed like
     * imagesets, but rendered like spreadsheet layers. To get the
     * `SpreadSheetLayer` associated with a HiPS catalog imageset, access:
     *
     * ```
     * imgset.get_hipsProperties().get_catalogSpreadSheetLayer()
     * ```
     *
     * You can use methods like {@link applyTableLayerSettings} to modify the settings
     * of this layer by extracting its ID string with `layer.id.toString()`.
     *
     * The contents of this catalog will update dynamically as the user navigates
     * the WWT view.
     */
    WWTInstance.prototype.addCatalogHipsByName = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var imgset = _this.ctl.getImagesetByName(options.name);
                        if (imgset === null) {
                            reject();
                        }
                        else {
                            _this.ctl.renderContext.addCatalogHips(imgset, function () {
                                resolve(imgset);
                            });
                        }
                    })];
            });
        });
    };
    /** Fetch the subset of catalog HiPS data contained within the current view.
     *
     * The imageset should have been loaded with the {@link addCatalogHipsByName}
     * call. The *limit* option should almost always be true, since if it is false
     * the data-fetch operation can potentially attempt to download and return
     * gigabytes of data.
     * */
    WWTInstance.prototype.getCatalogHipsDataInView = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, _reject) {
                        _this.ctl.renderContext.getCatalogHipsDataInView(options.imageset, options.limit, function (msg) {
                            resolve(msg);
                        });
                    })];
            });
        });
    };
    // "Mutator" type operations -- not async.
    WWTInstance.prototype.applySetting = function (setting) {
        var funcName = "set_" + setting[0];
        var value = setting[1]; // eslint-disable-line @typescript-eslint/no-explicit-any
        this.si.settings[funcName](value); // eslint-disable-line @typescript-eslint/no-explicit-any
    };
    WWTInstance.prototype.setBackgroundImageByName = function (imagesetName) {
        this.ctl.setBackgroundImageByName(imagesetName);
    };
    WWTInstance.prototype.setForegroundImageByName = function (imagesetName) {
        this.ctl.setForegroundImageByName(imagesetName);
    };
    /** Set the opacity with which the foreground imageset is rendered.
     *
     * @param opacity The opacity, between 0 (invisible) and 100 (fully opaque).
     */
    WWTInstance.prototype.setForegroundOpacity = function (opacity) {
        this.si.setForegroundOpacity(opacity);
    };
    /** Set up the view to instantaneously display the specified imageset.
     *
     * This function aspires to provide a one-stop shop for configuring the engine
     * to show one arbitrary imageset. It aims to automatically choose the right,
     * or at least justifiable, values for things like the background imageset,
     * the camera position, and the zoom level.
     *
     * Because this function makes instantaneous changes, it is not appropriate
     * for interactive use. It is intended to be used as a WWT view is being
     * initialized.
     *
     * @param imageset The imageset to display.
     */
    WWTInstance.prototype.setupForImageset = function (options) {
        var bkg;
        if (options.background) {
            bkg = options.background;
        }
        else {
            bkg = this.ctl.getDefaultImageset(options.foreground.get_dataSetType(), options.foreground.get_bandPass());
        }
        var imageHeightDeg;
        if (options.foreground.get_levels() > 0) {
            // For tiled images, baseTileDegrees gives the image angular height
            // directly, modulo a factor of two uncertainty depending on how the image
            // pixel height rounds up to a power of two.
            imageHeightDeg = options.foreground.get_baseTileDegrees();
        }
        else {
            // Unfortunately, for untiled images we don't have the information needed
            // to assess the image's angular height reliably. In many cases offsetY
            // will be about half of the pixel height, but it could be anything.
            imageHeightDeg = options.foreground.get_baseTileDegrees() * options.foreground.get_offsetY() * 2;
        }
        var place = new engine_root_wwtlib_.Place();
        place.set_type(options.foreground.get_dataSetType());
        place.set_backgroundImageset(bkg);
        place.set_studyImageset(options.foreground);
        var noZoom = false;
        switch (options.foreground.get_dataSetType()) {
            case ImageSetType.sky:
                if (imageHeightDeg == 180) {
                    // All-sky image -- special behavior
                    noZoom = true;
                }
                else {
                    place.set_RA(options.foreground.get_centerX() * D2H);
                    place.set_dec(options.foreground.get_centerY());
                    place.set_zoomLevel(imageHeightDeg * 6);
                }
                break;
            case ImageSetType.earth:
            case ImageSetType.planet:
                place.set_zoomLevel(120); // a pleasing default, according to me
                if (imageHeightDeg != 180) {
                    // need to verify that this is right
                    place.set_lng(options.foreground.get_centerX());
                    place.set_lat(options.foreground.get_centerY());
                }
                break;
            default:
                // TODO: more cases ...
                place.set_zoomLevel(360);
                break;
        }
        this.ctl.renderContext.set_backgroundImageset(bkg);
        this.ctl.gotoTarget(place, noZoom, true, // instant
        true // trackObject
        );
    };
    // Tours
    /** If the tour playback mode is active, get the active TourPlayer object. */
    WWTInstance.prototype.getActiveTourPlayer = function () {
        if (this.ctl.uiController === null)
            return null;
        if (this.ctl.uiController instanceof engine_root_wwtlib_.TourPlayer)
            return this.ctl.uiController;
        return null;
    };
    /** Find out whether a tour is playing.
     *
     * For obscure reasons, this is a static method in WWT that is not attached to
     * a TourPlayer instance. We take one as an argument for future-proofiness.
     */
    WWTInstance.prototype.getIsTourPlaying = function (_player) {
        return engine_root_wwtlib_.TourPlayer.get_playing();
    };
    /** Load a tour from a URL.
     *
     * Once the tour has loaded, you can use {@link getActiveTourPlayer} to get the
     * tour player controller and the underlying tour document.
     *
     * @param url The URL of the tour to load and play.
     * @returns A promise that resolves when the tour has loaded.
     */
    WWTInstance.prototype.loadTour = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var seq, _a, _b, p;
            var e_7, _c;
            var _this = this;
            return __generator(this, function (_d) {
                this.ctl.loadTour(url);
                this.tourReadySeqnum += 1;
                seq = this.tourReadySeqnum;
                try {
                    for (_a = tslib_es6_values(this.tourReadyPromises), _b = _a.next(); !_b.done; _b = _a.next()) {
                        p = _b.value;
                        p.reject("superseded");
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
                this.tourReadyPromises = [];
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.tourReadySeqnum > seq) {
                            reject("superseded");
                        }
                        else {
                            _this.tourReadyPromises.push(new SavedPromise(seq, resolve, reject));
                        }
                    })];
            });
        });
    };
    /** Load a tour from a URL and start playing it.
     *
     * @param url The URL of the tour to load and play.
     * @returns A promise that resolves when the tour has loaded and started
     * playing.
     */
    WWTInstance.prototype.loadAndPlayTour = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var seq, _a, _b, p;
            var e_8, _c;
            var _this = this;
            return __generator(this, function (_d) {
                this.ctl.playTour(url);
                this.tourReadySeqnum += 1;
                seq = this.tourReadySeqnum;
                try {
                    for (_a = tslib_es6_values(this.tourReadyPromises), _b = _a.next(); !_b.done; _b = _a.next()) {
                        p = _b.value;
                        p.reject("superseded");
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                this.tourReadyPromises = [];
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.tourReadySeqnum > seq) {
                            reject("superseded");
                        }
                        else {
                            _this.tourReadyPromises.push(new SavedPromise(seq, resolve, reject));
                        }
                    })];
            });
        });
    };
    /** Find out how far we have progressed into the tour, in seconds.
     *
     * This number does not necessarily progress monotonically due to the way that
     * WWT measures tour playback progress. We associate a start time with each
     * "stop" in the tour, and can measure progress through a stop, but stops do
     * not necessarily transition from one to another in linear fashion.
     *
     * That being said, this number should range between 0 and the runtime of the
     * current tour. If no tour is loaded, it will be zero.
     */
    WWTInstance.prototype.getEffectiveTourTimecode = function () {
        var player = this.getActiveTourPlayer();
        if (player === null)
            return 0.0;
        var tour = player.get_tour();
        if (tour === null)
            return 0.0;
        var idx = tour.get_currentTourstopIndex();
        if (idx < 0)
            return 0.0;
        var base = tour.elapsedTimeTillTourstop(idx);
        var stop = tour.get_tourStops()[idx];
        var delta = stop.get_tweenPosition() * stop.get_duration() * 0.001; // ms => s
        var value = base + delta;
        // It's possible for our math to yield a value slightly larger than the
        // nominal tour runtime, which can upset code that expects the value to stay
        // rigorously within that bound. So, clamp it to be sure.
        if (value < 0)
            return 0.0;
        var runTime = tour.get_runTime() * 0.001; // ms => s
        if (value > runTime)
            return runTime;
        return value;
    };
    /** "Seek" tour playback to approximately the specified timecode (in seconds).
     *
     * The tour will start playing back.
     *
     * This operation is approximate because WWT can only resume playback from the
     * beginning of a "tour stop". So, if the desired timecode is in the middle of
     * such a stop, playback will start there, not at the exact value that was
     * commanded. This can be a little annoying when a slide is long.
     *
     * If no tour or tour player is active, nothing happens.
     */
    WWTInstance.prototype.seekToTourTimecode = function (value) {
        var player = this.getActiveTourPlayer();
        if (player === null)
            return;
        var tour = player.get_tour();
        if (tour === null)
            return;
        // Figure out the stop index that best matches the specified timecode.
        var stops = tour.get_tourStops();
        var index = stops.length - 1;
        for (var i = 0; i < stops.length; i++) {
            var tStart = tour.elapsedTimeTillTourstop(i);
            if (tStart >= value) {
                index = i - 1;
                break;
            }
        }
        if (index < 0) {
            index = 0;
        }
        // Apply the change.
        player.playFromTourstop(stops[index]);
    };
    /** Capture the current frame as an image.
     *
     * This function returns a Promise whose resolved value is the image
     * represented as a `Blob`.
    */
    WWTInstance.prototype.captureFrame = function (options) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            _this.ctl.captureFrame(function (blob) { return resolve(blob); }, options.width, options.height, options.format);
        });
    };
    /** Capture a video as a sequence of frames using the given parameters
     *
     * This function returns a readable stream whose values are the exported frames.
    */
    WWTInstance.prototype.captureVideo = function (options) {
        var wwtControl = this.ctl;
        var videoStream = new ReadableStream({
            start: function (controller) {
                function stream() {
                    var received = 0;
                    wwtControl.captureVideo(function (blob) {
                        received++;
                        controller.enqueue(blob);
                        if (received >= options.totalFrames) {
                            controller.close();
                        }
                    }, options.width, options.height, options.framesPerSecond, options.totalFrames, options.format);
                }
                return stream();
            }
        });
        return videoStream;
    };
    return WWTInstance;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/store.ts
// Copyright 2020-2023 the .NET Foundation
// Licensed under the MIT License






/** The class of the global `$wwt` magic singleton. */
var WWTGlobalState = /** @class */ (function () {
    function WWTGlobalState() {
        this.inst = null;
        this.onLinkedCallbacks = [];
    }
    WWTGlobalState.prototype.link = function (inst) {
        var e_1, _a;
        if (this.inst !== null)
            throw new Error("must unlink WWT Pinia global state before relinking");
        this.inst = inst;
        try {
            for (var _b = tslib_es6_values(this.onLinkedCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var cb = _c.value;
                cb();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.onLinkedCallbacks = [];
    };
    WWTGlobalState.prototype.unlink = function () {
        this.inst = null;
    };
    return WWTGlobalState;
}());

/** This class holds basic information about an imageset.
 *
 * Discover imagesets through the {@link engineStore.availableImagesets}
 * state variable. In standard practice there will be hundreds of available
 * imagesets of many different kinds.
 *
 * Imagesets may be uniquely identified by their associated image data {@link url}.
 * (If you really need to have multiple imagesets associated with the same URL,
 * add a `#fragment` to the end.)
 */
var ImagesetInfo = /** @class */ (function () {
    function ImagesetInfo(url, name, type, description, extension, id) {
        if (id === void 0) { id = null; }
        this.url = url;
        this.name = name;
        this.type = type;
        this.description = description;
        this.extension = extension;
        this.id = id;
    }
    ImagesetInfo.fromImageset = function (imageset) {
        var _a, _b;
        return new ImagesetInfo(imageset.get_url(), imageset.get_name(), imageset.get_dataSetType(), imageset.get_creditsText(), imageset.get_extension(), (_b = (_a = imageset.get_hipsProperties()) === null || _a === void 0 ? void 0 : _a.get_catalogSpreadSheetLayer().id.toString()) !== null && _b !== void 0 ? _b : null);
    };
    return ImagesetInfo;
}());

/** Information about a spreadsheet (data table) layer. */
var SpreadSheetLayerInfo = /** @class */ (function () {
    function SpreadSheetLayerInfo(id, referenceFrame, name) {
        this.id = id;
        this.referenceFrame = referenceFrame;
        this.name = name !== null && name !== void 0 ? name : id;
    }
    SpreadSheetLayerInfo.prototype.setName = function (name) {
        this.name = name;
    };
    return SpreadSheetLayerInfo;
}());

/** Information about an active imageset layer. */
var ImageSetLayerState = /** @class */ (function () {
    function ImageSetLayerState(source) {
        this.guidText = source.id.toString();
        this.settings = new imagesetlayer_ImageSetLayerState(source);
        var fits = source.get_imageSet().get_fitsProperties();
        this.scaleType = fits.scaleType;
        this.vmin = fits.lowerCut;
        this.vmax = fits.upperCut;
        this.colormapName = fits.colorMapName;
    }
    ImageSetLayerState.prototype.getGuid = function () {
        return this.guidText;
    };
    return ImageSetLayerState;
}());

/** This function creates the list of currently active layers.
 * Keeping this functionality outside of the store allows us to use it from
 * inside either an action or a mutation.
 */
function activeLayersList(wwt) {
    if (wwt.inst === null)
        throw new Error('cannot get activeLayersList without linking to WWTInstance');
    var layers = [];
    function accum(lm) {
        var e_2, _a, e_3, _b;
        try {
            for (var _c = tslib_es6_values(lm.layers), _d = _c.next(); !_d.done; _d = _c.next()) {
                var layer = _d.value;
                layers.push(layer.id.toString());
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var _e = tslib_es6_values(Object.entries(lm.childMaps)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var _g = __read(_f.value, 2), _mapname = _g[0], sublm = _g[1];
                accum(sublm);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
    var rootlm = wwt.inst.lm.get_allMaps()[wwt.inst.ctl.getCurrentReferenceFrame()];
    if (rootlm) {
        accum(rootlm);
    }
    return layers;
}
/** This function creates the list of currently available imagesets.
 * Keeping this functionality outside of the store allows us to use it from
 * inside either an action or a mutation.
 */
function availableImagesets() {
    return engine_root_wwtlib_.WWTControl.getImageSets().map(ImagesetInfo.fromImageset);
}
/** The [Pinia] “use store” function defining the state of the WWT engine.
 *
 * [Pinia]: https://pinia.vuejs.org/core-concepts/#Defining-a-Store
 *
 * According to modern conventions, this function should be named
 * `useWWTEngineStore()`. Calling it returns a [Pinia store
 * object](https://pinia.vuejs.org/api/modules/pinia.html#Store) that allows you
 * to access and modify the WWT state. To get a broad sense of how Pinia store
 * objects may be used  in general, [explore the Pinia
 * documentation](https://pinia.vuejs.org/core-concepts/).
 *
 * See [The WWT Pinia Interface](#md:the-wwt-pinia-interface) below for an
 * organized overview of all of the ways your code can control WWT using this
 * framework.
 *
 * ## Example
 *
 * If you were implementing a WWT-aware component using the Vue [“Composition
 * API”][comp-api] with a `<script setup>` single-file component, you might
 * write something like:
 *
 * [comp-api]: https://vuejs.org/guide/introduction.html#api-styles
 *
 * ```vue
 * <template>
 *   <div id="app">
 *     <!-- Include a WWT Component: -->
 *     <WorldWideTelescope></WorldWideTelescope>
 *     <p class="coord-overlay">{{ coordText }}</p>
 *   </div>
 * </template>
 *
 * <script setup lang="ts">
 * import { computed } from "vue";
 * import { fmtDegLat, fmtHours } from "@wwtelescope/astro";
 * import { engineStore } from "@wwtelescope/engine-pinia";
 *
 * const wwt = engineStore();
 * const coordText = computed(() => `${fmtHours(wwt.raRad)} ${fmtDegLat(wwt.decRad)}`);
 * </script>
 *
 * <style lang="less">
 * #app { ... blah blah ... }
 * </style>
 * ```
 *
 * If you wanted to define a Vue component manually in TypeScript using the
 * Options API, you could manually connect some of its state or methods to the
 * WWT Pinia store with code like:
 *
 * ```ts
 * import { defineComponent } from "vue";
 * import { mapActions } from "pinia";
 * import { engineStore } from "@wwtelescope/engine-pinia";
 *
 * export class MyWWTAwareComponent extends defineComponent({
 *   methods: {
 *    ...mapActions(engineStore, ["gotoRADecZoom"])
 *   }
 * }) {}
 * ```
 *
 * This would define a component with an associated method named `gotoRADecZoom`
 * that would be magically wired up to the corresponding {@link gotoRADecZoom}
 * store action. However, the whole point of the {@link WWTAwareComponent} class
 * is to make it so that you don’t need to write this code yourself: it exposes
 * all of the store’s state and methods in a predefined component. Instead of
 * manually mapping out of the store as written above, you can just extend it
 * and get everything “for free”.
 *
 * # The WWT Pinia Interface
 *
 * Here we document all of the available WWT interfaces, grouping them by
 * category. As a reminder, in the Pinia paradigm, state is expressed in [state
 * variables] and [getters], and modified either directly or through [actions]
 * (which can be asynchronous).
 *
 * [state variables]: https://pinia.vuejs.org/core-concepts/state.html
 *
 * [getters]: https://pinia.vuejs.org/core-concepts/getters.html
 *
 * [actions]: https://pinia.vuejs.org/core-concepts/actions.html
 *
 * ## Initialization
 *
 * Actions:
 *
 * - {@link waitForReady}
 * - {@link setupForImageset}
 *
 * ## Basic View Information
 *
 * State:
 *
 * - {@link currentTime}
 * - {@link clockDiscontinuities}
 * - {@link clockRate}
 * - {@link decRad}
 * - {@link raRad}
 * - {@link zoomDeg}
 * - {@link rollRad}
 *
 * Getters:
 *
 * - {@link findRADecForScreenPoint}
 * - {@link findScreenPointForRADec}
 *
 * Actions:
 *
 * - {@link gotoRADecZoom}
 * - {@link timeToRADecZoom}
 * - {@link gotoTarget}
 * - {@link setClockRate}
 * - {@link setClockSync}
 * - {@link setTime}
 * - {@link setTrackedObject}
 * - {@link zoom}
 * - {@link move}
 * - {@link tilt}
 *
 * ## Image Sets
 *
 * State:
 *
 * - {@link availableImagesets}
 * - {@link backgroundImageset}
 * - {@link foregroundImageset}
 * - {@link foregroundOpacity}
 * - {@link renderType}
 *
 * Getters:
 *
 * - {@link lookupImageset}
 *
 * Actions:
 *
 * - {@link loadImageCollection}
 * - {@link addImagesetToRepository}
 * - {@link setBackgroundImageByName}
 * - {@link setForegroundImageByName}
 * - {@link setForegroundOpacity}
 * - {@link setupForImageset}
 *
 *
 * ## General Layer Management
 *
 * State:
 *
 * - {@link activeLayers}
 *
 * Getters:
 *
 * - {@link layerById}
 *
 * Actions:
 *
 * - {@link deleteLayer}
 *
 * ## Imageset Layers (including FITS imagery)
 *
 * State:
 *
 * - {@link activeLayers}
 * - {@link imagesetLayers}
 *
 * Getters:
 *
 * - {@link activeImagesetLayerStates}
 * - {@link imagesetForLayer}
 * - {@link imagesetStateForLayer}
 * - {@link imagesetLayerById}
 *
 * Actions:
 *
 * - {@link addImageSetLayer}
 * - {@link loadFitsLayer} (deprecated)
 * - {@link applyFitsLayerSettings}
 * - {@link setFitsLayerColormap}
 * - {@link stretchFitsLayer}
 * - {@link setImageSetLayerOrder}
 * - {@link deleteLayer}
 *
 * ## Tabular (“Spreadsheet”) Data Layers
 *
 * State:
 *
 * - {@link activeLayers}
 * - {@link spreadSheetLayers}
 *
 * Getters:
 *
 * - {@link spreadSheetLayer}
 * - {@link spreadsheetState}
 * - {@link spreadSheetLayerById}
 * - {@link spreadsheetStateById}
 *
 * Actions:
 *
 * - {@link createTableLayer}
 * - {@link applyTableLayerSettings}
 * - {@link updateTableLayer}
 * - {@link deleteLayer}
 *
 * ## Annotations
 *
 * Actions:
 *
 * - {@link addAnnotation}
 * - {@link clearAnnotations}
 * - {@link removeAnnotation}
 *
 * ## Progressive HiPS Catalogs
 *
 * These have some characteristics of both imagesets and tabular ("spreadsheet")
 * data layers.
 *
 * Getters:
 *
 * - {@link layerForHipsCatalog}
 * - {@link spreadsheetStateForHipsCatalog}
 *
 * Actions:
 *
 * - {@link addCatalogHipsByName}
 * - {@link applyTableLayerSettings}
 * - {@link getCatalogHipsDataInView}
 * - {@link removeCatalogHipsByName}
 *
 * ## Tours
 *
 * State:
 *
 * - {@link isTourPlayerActive}
 * - {@link isTourPlaying}
 * - {@link tourCompletions}
 * - {@link tourRunTime}
 * - {@link tourStopStartTimes}
 * - {@link tourTimecode}
 *
 * Actions:
 *
 * - {@link loadTour}
 * - {@link seekToTourTimecode}
 * - {@link setTourPlayerLeaveSettingsWhenStopped}
 * - {@link startTour}
 * - {@link stopTour}
 * - {@link closeTourPlayer}
 * - {@link toggleTourPlayPauseState}
 *
 * ## Miscellaneous
 *
 * State:
 *
 * - {@link showWebGl2Warning}
 *
 * Actions:
 *
 * - {@link applySetting}
 * - {@link viewAsTourXml}
 * - {@link captureFrame}
 * - {@link captureVideo}
 * - {@link clearTileCache}
 */
var engineStore = defineStore('wwt-engine', {
    // NOTE: We were originally alphabetizing these all, but now I think it will
    // be better to group topically related fields.
    // Through typedoc magic, these fields are documented via the docstrings that
    // appear in the `WWTEnginePiniaState` interface definition.
    state: function () { return ({
        activeLayers: [],
        availableImagesets: [],
        backgroundImageset: null,
        clockDiscontinuities: 0,
        clockRate: 1.0,
        currentTime: new Date(),
        decRad: 0.0,
        foregroundImageset: null,
        foregroundOpacity: 100,
        imagesetLayers: {},
        isTourPlayerActive: false,
        isTourPlaying: false,
        raRad: 0.0,
        renderType: ImageSetType.sky,
        rollRad: 0,
        spreadSheetLayers: {},
        timeAtStartup: Date.now(),
        tourCompletions: 0,
        tourRunTime: null,
        tourStopStartTimes: [],
        tourTimecode: 0.0,
        showWebGl2Warning: false,
        zoomDeg: 0.0,
    }); },
    getters: {
        /** Look up an [Imageset](../../engine/classes/Imageset-1.html) in the engine’s
         * table of ones with registered names.
         *
         * This delegates to
         * [WWTControl.getImagesetByName()](../../engine/classes/WWTControl-1.html#getimagesetbyname),
         * which has very eager name-matching rules. But if nothing matches, null is
         * returned.
         *
         * Imagesets are not added to the engine’s list of names automatically. In
         * order for an imageset to be findable by this function, its containing
         * folder must have been loaded using the {@link loadImageCollection} action.
         */
        lookupImageset: function (_state) {
            var _this = this;
            return function (imagesetName) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot lookupImageset without linking to WWTInstance');
                return _this.$wwt.inst.ctl.getImagesetByName(imagesetName);
            };
        },
        /** Get the right ascension and declination, in degrees, for x, y coordinates on the screen */
        findRADecForScreenPoint: function (_state) {
            var _this = this;
            return function (pt) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot findRADecForScreenPoint without linking to WWTInstance');
                var coords = _this.$wwt.inst.ctl.getCoordinatesForScreenPoint(pt.x, pt.y);
                return { ra: (15 * coords.x + 720) % 360, dec: coords.y };
            };
        },
        /** Given an RA and Dec position, return the x, y coordinates of the screen point */
        findScreenPointForRADec: function (_state) {
            var _this = this;
            return function (pt) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot findScreenPointForRADec without linking to WWTInstance');
                return _this.$wwt.inst.ctl.getScreenPointForCoordinates(pt.ra / 15, pt.dec);
            };
        },
        /** Look up the reactive state for an active imageset layer.
         *
         * These layers are created using the {@link addImageSetLayer} action. The state
         * returned by this function is part of the reactive store, so you can
         * wire it up to your UI and it will update as the layer settings are changed.
         * If you need "runtime" state not captured in the reactivity system, you may
         * need to use {@link imagesetForLayer} instead.
         *
         * @param guidtext The GUID of the layer to query, as a string
         * @returns The layer state, or null if the GUID is unrecognized
         */
        imagesetStateForLayer: function (state) {
            return function (guidtext) {
                return state.imagesetLayers[guidtext] || null;
            };
        },
        // NOTE that this getter is defined in a weird way. This is intentional as a
        // "bug fix" but I forget the reasoning: see commit
        // efa9bf14656aa97b6f7609ec411e768dfb42bdf8 . This makes it so tha this
        // docstring is no rendered in the HTML docs :-(
        /** Get the reactive state for the active imageset layers
         *
         * These layers are created using the {@link addImageSetLayer} action. The state
         * structures returned by this function are part of the reactive store, so
         * you can wire them up to your UI and they will update correctly. The list is
         * returned in the engine's render order.
         *
         * @returns The layer states
         */
        activeImagesetLayerStates: function () {
            var e_4, _a;
            var states = [];
            try {
                for (var _b = tslib_es6_values(this.activeLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var guid = _c.value;
                    var layerState = this.imagesetLayers[guid];
                    if (layerState) {
                        states.push(layerState);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return states;
        },
        catalogLayerKey: function (_state) {
            return function (catalog) {
                var _a;
                return (_a = catalog.id) !== null && _a !== void 0 ? _a : "";
            };
        },
        /** Look up the WWT engine object for an active imageset layer.
         *
         * This getter gets the WWT `Imageset` object associated with an imageset
         * layer. The returned object is *not* part of the Vue(x) reactivity system,
         * so you shouldn't use it to set up UI elements, but you can obtain more
         * detailed information about the imageset than is stored in the state
         * management system. For UI purposes, use {@link imagesetStateForLayer}.
         *
         * @param guidtext The GUID of the layer to query, as a string
         * @returns The layer's underlying imageset, or null if the GUID is
         * unrecognized
         */
        imagesetForLayer: function (_state) {
            var _this = this;
            return function (guidtext) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get imagesetForLayer without linking to WWTInstance');
                var layer = _this.$wwt.inst.lm.get_layerList()[guidtext];
                if (layer !== null && layer instanceof engine_root_wwtlib_.ImageSetLayer) {
                    return layer.get_imageSet();
                }
                else {
                    return null;
                }
            };
        },
        /** Get the actual WWT `ImageSetLayer` for the imageset layer with the given ID.
         *
         * Do not use this function for UI purposes -- the WWT layer object is not
         * integrated into the reactive state system, and so if you use it as a basis
         * for UI elements, those elements will not be updated properly if/when the
         * layer's settings change. Use {@link imagesetStateForLayer} instead.
         *
         * @param id The imageset layer's identifier.
         */
        imagesetLayerById: function (_state) {
            var _this = this;
            return function (id) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get imagesetLayerById without linking to WWTInstance');
                var layer = _this.layerById(id);
                if (layer !== null && layer instanceof engine_root_wwtlib_.ImageSetLayer) {
                    return layer;
                }
                else {
                    return null;
                }
            };
        },
        /** Get the actual WWT `SpreadSheetLayer` for the named HiPS catalog.
         *
         * Do not use this function for UI purposes -- the WWT layer object is not
         * integrated into the reactive state system, and so if you use it as a basis
         * for UI elements, those elements will not be updated properly if/when the
         * layer's settings change. Use {@link spreadsheetStateForHipsCatalog} instead.
         *
         * @param name The `datasetName` of the HiPS catalog
         */
        layerForHipsCatalog: function (_state) {
            var _this = this;
            return function (name) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get layerForHipsCatalog without linking to WWTInstance');
                var id = engine_root_wwtlib_.Guid.createFrom(name).toString();
                return _this.spreadSheetLayerById(id);
            };
        },
        /** Get the actual WWT `Layer` for the layer with the given ID.
         *
         * Do not use this function for UI purposes -- the WWT layer object is not
         * integrated into the reactive state system, and so if you use it as a
         * basis for UI elements, those elements will not be updated properly
         * if/when the layer's settings change. If you know the specific type of
         * your layer, you can use functions like {@link imagesetStateForLayer} or
         * {@link spreadSheetStateById} to get reactive data structures.
         *
         * @param id The layer's identifier.
         */
        layerById: function (_state) {
            var _this = this;
            return function (id) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get layerById without linking to WWTInstance');
                return _this.$wwt.inst.lm.get_layerList()[id];
            };
        },
        /** Get reactive `SpreadSheetLayer` settings for the named HiPS catalog.
         *
         * The returned data structure is a component of the app's reactive state. You can
         * therefore use the settings to construct UI elements, and they will update
         * reactively as the state evolves. The actual data structures used by WWT are
         * separate, but the two mirror each other.
         *
         * @param name The `datasetName` of the HiPS catalog
         */
        spreadsheetStateForHipsCatalog: function (state) {
            var _this = this;
            return function (name) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get spreadsheetStateForHipsCatalog without linking to WWTInstance');
                var id = engine_root_wwtlib_.Guid.createFrom(name).toString();
                return state.spreadSheetLayers[id] || null;
            };
        },
        /** Get the actual WWT `SpreadSheetLayer` for the table layer with the given ID.
         *
         * Do not use this function for UI purposes -- the WWT layer object is not
         * integrated into the reactive state system, and so if you use it as a basis
         * for UI elements, those elements will not be updated properly if/when the
         * layer's settings change. Use {@link spreadsheetState} instead.
         *
         * @param id The table layer's identifier.
         */
        spreadSheetLayerById: function (_state) {
            var _this = this;
            return function (id) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get spreadsheetLayerById without linking to WWTInstance');
                var layer = _this.layerById(id);
                if (layer !== null && layer instanceof engine_root_wwtlib_.SpreadSheetLayer) {
                    return layer;
                }
                else {
                    return null;
                }
            };
        },
        /** Get reactive `SpreadSheetLayer` settings for the table layer with the given ID.
         *
         * The returned data structure is a component of the app's reactive state. You can
         * therefore use the settings to construct UI elements, and they will update
         * reactively as the state evolves. The actual data structures used by WWT are
         * separate, but the two mirror each other.
         *
         * @param id The identifier of the table layer.
         */
        spreadsheetStateById: function (state) {
            return function (id) {
                return state.spreadSheetLayers[id] || null;
            };
        },
        /** Get the actual WWT `SpreadSheetLayer` for the table layer corresponding
         * to the given CatalogLayerInfo.
         *
         * Do not use this function for UI purposes -- the WWT layer object is not
         * integrated into the reactive state system, and so if you use it as a basis
         * for UI elements, those elements will not be updated properly if/when the
         * layer's settings change. Use {@link spreadsheetState} instead.
         *
         * @param id The table layer's identifier.
         */
        spreadSheetLayer: function (_state) {
            var _this = this;
            return function (catalog) {
                if (_this.$wwt.inst === null)
                    throw new Error('cannot get spreadSheetLayer without linking to WWTInstance');
                var key = _this.catalogLayerKey(catalog);
                return _this.spreadSheetLayerById(key);
            };
        },
        /** Get reactive `SpreadSheetLayer` settings for the table layer corresponding to
         * the given CatalogLayerInfo.
         *
         * The returned data structure is a component of the app's reactive state. You can
         * therefore use the settings to construct UI elements, and they will update
         * reactively as the state evolves. The actual data structures used by WWT are
         * separate, but the two mirror each other.
         *
         * @param catalog A CatalogLayerInfo object corresponding to the layer.
         */
        spreadsheetState: function (state) {
            var _this = this;
            return function (catalog) {
                var key = _this.catalogLayerKey(catalog);
                return state.spreadSheetLayers[key] || null;
            };
        }
    },
    actions: {
        /** @hidden */
        internalLinkToInstance: function (wwt) {
            this.$wwt.link(wwt);
        },
        /** @hidden */
        internalUnlinkFromInstance: function () {
            this.$wwt.unlink();
        },
        /** @hidden */
        internalUpdate: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot internalUpdate without linking to WWTInstance');
            var wwt = this.$wwt.inst;
            var raRad = wwt.si.getRA() * H2R;
            if (this.raRad != raRad)
                this.raRad = raRad;
            var decRad = wwt.si.getDec() * D2R;
            if (this.decRad != decRad)
                this.decRad = decRad;
            var zoomDeg = wwt.ctl.renderContext.viewCamera.zoom;
            if (this.zoomDeg != zoomDeg)
                this.zoomDeg = zoomDeg;
            var rollRad = wwt.ctl.renderContext.viewCamera.rotation;
            if (this.rollRad != rollRad)
                this.rollRad = rollRad;
            var bg = wwt.ctl.renderContext.get_backgroundImageset() || null; // TEMP
            if (this.backgroundImageset != bg)
                this.backgroundImageset = bg;
            var time = wwt.stc.get_now();
            if (this.currentTime != time)
                this.currentTime = time;
            var fg = wwt.ctl.renderContext.get_foregroundImageset() || null; // TEMP
            if (this.foregroundImageset != fg)
                this.foregroundImageset = fg;
            if (this.foregroundOpacity != wwt.ctl.renderContext.viewCamera.opacity)
                this.foregroundOpacity = wwt.ctl.renderContext.viewCamera.opacity;
            if (this.renderType != wwt.ctl.renderType)
                this.renderType = wwt.ctl.renderType;
            var player = wwt.getActiveTourPlayer();
            this.tourTimecode = wwt.getEffectiveTourTimecode();
            if (player !== null) {
                this.isTourPlayerActive = true;
                this.isTourPlaying = wwt.getIsTourPlaying(player);
            }
            else {
                this.isTourPlayerActive = false;
                this.isTourPlaying = false;
            }
            var showWebGl2Warning = !wwt.si.isUsingWebGl2()
                && (Date.now() - this.timeAtStartup) < 15000;
            if (this.showWebGl2Warning != showWebGl2Warning) {
                this.showWebGl2Warning = showWebGl2Warning;
            }
        },
        /** @hidden */
        internalIncrementTourCompletions: function () {
            this.tourCompletions += 1;
        },
        /** Alter one [WWT engine setting](../../engine/modules.html#enginesetting). */
        applySetting: function (setting) {
            if (this.$wwt.inst === null)
                throw new Error('cannot applySetting without linking to WWTInstance');
            this.$wwt.inst.applySetting(setting);
        },
        /** Set the current background [Imageset](../../engine/classes/Imageset-1.html)
         * based on its name.
         *
         * The name lookup here is effectively done using {@link lookupImageset}. If
         * the name is not found, the current background imageset remains unchanged.
         *
         * Changing the background imageset may change the value of {@link renderType},
         * and the overall "mode" of the WWT renderer.
         */
        setBackgroundImageByName: function (imagesetName) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setBackgroundImageByName without linking to WWTInstance');
            this.$wwt.inst.setBackgroundImageByName(imagesetName);
        },
        /** Set the current foreground [Imageset](../../engine/classes/Imageset-1.html)
         * based on its name.
         *
         * The name lookup here is effectively done using {@link lookupImageset}. If
         * the name is not found, the current foreground imageset remains unchanged.
         */
        setForegroundImageByName: function (imagesetName) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setForegroundImageByName without linking to WWTInstance');
            this.$wwt.inst.setForegroundImageByName(imagesetName);
        },
        /** Set the opacity of the foreground imageset.
         *
         * Valid values are between 0 (invisible) and 100 (fully opaque).
         */
        setForegroundOpacity: function (opacity) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setForegroundOpacity without linking to WWTInstance');
            this.$wwt.inst.setForegroundOpacity(opacity);
            this.foregroundOpacity = opacity;
        },
        /** Set up the background and foreground imagesets according to
         * [the options](../../engine-helpers/interfaces/SetupForImagesetOptions.html)
         *
         * The main use of this interface is that it provides a mechanism to guess
         * the appropriate background imageset given a foreground imageset that you
         * want to show.
         */
        setupForImageset: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setupForImageset without linking to WWTInstance');
            this.$wwt.inst.setupForImageset(options);
        },
        /** Set the zoom level of the view.
         *
         * This action may result in an action that takes a perceptible amount of
         * time to resolve, if the "smooth pan" renderer option is enabled. To have
         * proper asynchronous feedback about when the zoom operation completes, use
         * {@link gotoRADecZoom}.
         */
        zoom: function (factor) {
            if (this.$wwt.inst === null)
                throw new Error('cannot zoom without linking to WWTInstance');
            this.$wwt.inst.ctl.zoom(factor);
        },
        /** Moves the position of the view */
        move: function (args) {
            if (this.$wwt.inst === null)
                throw new Error('cannot move without linking to WWTInstance');
            this.$wwt.inst.ctl.move(args.x, args.y);
        },
        /** Tilts the position of the view */
        tilt: function (args) {
            if (this.$wwt.inst === null)
                throw new Error('cannot tilt without linking to WWTInstance');
            this.$wwt.inst.ctl._tilt(args.x, args.y);
        },
        /** Set the current time of WWT's internal clock.
         *
         * Altering this causes an increment in {@link clockDiscontinuities}.
         */
        setTime: function (time) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setTime without linking to WWTInstance');
            this.$wwt.inst.stc.set_now(time);
            this.clockDiscontinuities += 1;
        },
        /** Set the rate at which the WWT clock progresses compared to wall-clock time.
         *
         * A value of 10 means that the WWT clock progresses ten times faster than
         * real time. A value of -0.1 means that the WWT clock moves backwards, ten
         * times slower than real time.
         *
         * Altering this causes an increment in {@link clockDiscontinuities}.
         */
        setClockRate: function (rate) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setClockRate without linking to WWTInstance');
            if (this.$wwt.inst.stc.get_timeRate() != rate) {
                this.$wwt.inst.stc.set_timeRate(rate);
                this.clockRate = rate;
                this.clockDiscontinuities += 1;
            }
        },
        /** Set whether the WWT clock should progress with real time.
         *
         * See
         * [SpaceTimeController.set_syncToClock()](../../engine/modules/SpaceTimeController.html#set_synctoclock).
         * This interface effectively allows you to pause the WWT clock.
         *
         * Altering this causes an increment in {@link clockDiscontinuities}.
         */
        setClockSync: function (isSynced) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setClockSync without linking to WWTInstance');
            if (this.$wwt.inst.stc.get_syncToClock() != isSynced) {
                this.$wwt.inst.stc.set_syncToClock(isSynced);
                if (isSynced) {
                    this.clockRate = this.$wwt.inst.stc.get_timeRate();
                }
                else {
                    this.clockRate = 0;
                }
                this.clockDiscontinuities += 1;
            }
        },
        /** Start playback of the currently loaded tour.
         *
         * Nothing happens if no tour is loaded.
         */
        startTour: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot start tour without linking to WWTInstance');
            var player = this.$wwt.inst.getActiveTourPlayer();
            player === null || player === void 0 ? void 0 : player.play();
        },
        /** Stop playing the currently loaded tour.
          *
          * Nothing happens if no tour is currently playing.
          */
        stopTour: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot stop tour without linking to WWTInstance');
            var player = this.$wwt.inst.getActiveTourPlayer();
            // The argument here is currently unused in the engine
            player === null || player === void 0 ? void 0 : player.stop(false);
        },
        /** Close the active tour player, if there is one active.
          *
          * Any tour that is currently playing will be stopped.
          */
        closeTourPlayer: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot close tour player without linking to WWTInstance');
            var player = this.$wwt.inst.getActiveTourPlayer();
            if (player !== null) {
                player.close();
                this.$wwt.inst.ctl.uiController = null;
            }
            this.tourRunTime = null;
            this.tourStopStartTimes = [];
            this.tourTimecode = 0;
        },
        /** Toggle the play/pause state of the current tour.
         *
         * Nothing happens if no tour is loaded.
         */
        toggleTourPlayPauseState: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot play/pause tour without linking to WWTInstance');
            var player = this.$wwt.inst.getActiveTourPlayer();
            // Despite the unclear name, this function does toggle play/pause state.
            player === null || player === void 0 ? void 0 : player.pauseTour();
        },
        /** Set whether the renderer settings of tours should remain applied after
         * those tours finish playing back.
         *
         * This specialized option helps avoid jarring visual effects when tours
         * finish playing. If a tour activates a renderer option like "local horizon
         * mode", by default that option will turn off when the tour finishes, causing
         * the view to suddenly change. If this option is set to True, that setting
         * will remain active, preventing the sudden change.
         */
        setTourPlayerLeaveSettingsWhenStopped: function (value) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setTourPlayerLeaveSettingsWhenStopped without linking to WWTInstance');
            var player = this.$wwt.inst.getActiveTourPlayer();
            if (player === null)
                throw new Error('no tour player to control');
            player.set_leaveSettingsWhenStopped(value);
        },
        /** Seek tour playback to the specified timecode.
         *
         * See {@link tourTimecode} for a definition of the tour timecode.
         *
         * An important limitation is that the engine can only seek to the very
         * beginning of a tour stop. If you request a timecode in the middle of a
         * slide, the seek will actually occur to the start time of that slide.
         */
        seekToTourTimecode: function (value) {
            if (this.$wwt.inst === null)
                throw new Error('cannot seekToTourTimecode without linking to WWTInstance');
            this.$wwt.inst.seekToTourTimecode(value);
        },
        /** Get the current view as a one-slide tour, serialized to XML */
        viewAsTourXml: function (name) {
            return __awaiter(this, void 0, void 0, function () {
                var editor, tour, blob, reader, tourXml;
                return __generator(this, function (_a) {
                    engine_root_wwtlib_.WWTControl.singleton.createTour(name || "");
                    editor = engine_root_wwtlib_.WWTControl.singleton.tourEdit;
                    editor.addSlide(false);
                    tour = editor.get_tour();
                    if (tour === null) {
                        return [2 /*return*/, Promise.resolve(null)];
                    }
                    blob = tour.saveToBlob();
                    reader = new FileReader();
                    reader.readAsText(blob);
                    tourXml = "";
                    return [2 /*return*/, new Promise(function (resolve, _reject) {
                            reader.onloadend = function () {
                                tourXml += reader.result;
                                resolve(tourXml);
                            };
                        })];
                });
            });
        },
        /** Wait for the WWT engine to become ready for usage.
         *
         * You should invoke this action and wait for is completion before trying to
         * do anything else with a WWT-aware component. The action resolves when the
         * WWT engine has completed its initialization, which involes the download of
         * some supporting data files.
         */
        waitForReady: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (this.$wwt.inst !== null) {
                        return [2 /*return*/, this.$wwt.inst.waitForReady()];
                    }
                    else {
                        return [2 /*return*/, new Promise(function (resolve, _reject) {
                                var waitThenResolve = function () {
                                    _this.$wwt.inst.waitForReady().then(resolve);
                                };
                                if (_this.$wwt.inst !== null) {
                                    waitThenResolve();
                                }
                                else {
                                    _this.$wwt.onLinkedCallbacks.push(waitThenResolve);
                                }
                            })];
                    }
                    return [2 /*return*/];
                });
            });
        },
        /** Command the view to steer to a specific configuration.
         *
         * The async action completes when the view arrives, or when
         * a subsequent view command overrides this one.
         *
         * TODO: document semantics when not in 2D sky mode!
         */
        gotoRADecZoom: function (_a) {
            var raRad = _a.raRad, decRad = _a.decRad, zoomDeg = _a.zoomDeg, instant = _a.instant, rollRad = _a.rollRad, duration = _a.duration;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    if (this.$wwt.inst === null)
                        throw new Error('cannot gotoRADecZoom without linking to WWTInstance');
                    return [2 /*return*/, this.$wwt.inst.gotoRADecZoom(raRad, decRad, zoomDeg, instant, rollRad, duration)];
                });
            });
        },
        /** Returns the time it would take, in seconds, to navigate to the given target. */
        timeToRADecZoom: function (_a) {
            var raRad = _a.raRad, decRad = _a.decRad, zoomDeg = _a.zoomDeg, rollRad = _a.rollRad;
            if (this.$wwt.inst === null)
                throw new Error('cannot get timeToRADecZoom without linking to WWTInstance');
            return this.$wwt.inst.timeToRADecZoom(raRad, decRad, zoomDeg, rollRad);
        },
        /** Command the view to steer as specified in
         * [the options](../../engine-helpers/interfaces/GotoTargetOptions.html).
         *
         * The async action completes when the view arrives, or when
         * a subsequent view command overrides this one.
         */
        gotoTarget: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (this.$wwt.inst === null)
                        throw new Error('cannot gotoTarget without linking to WWTInstance');
                    return [2 /*return*/, this.$wwt.inst.gotoTarget(options)];
                });
            });
        },
        /** Set the "tracked object" in the 3D solar system view.
         *
         * Allowed values are
         * [defined in @wwtelescope/engine-types](../../engine-types/enums/SolarSystemObjects.html).
         */
        setTrackedObject: function (obj) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setTrackedObject without linking to WWTInstance');
            this.$wwt.inst.ctl.renderContext.set_solarSystemTrack(obj);
        },
        /** Request the engine to load a tour file.
         *
         * The action resolves when the load is complete. It’s asynchronous because
         * the full WTT tour file has to be downloaded.
        */
        loadTour: function (_a) {
            var url = _a.url, play = _a.play;
            return __awaiter(this, void 0, void 0, function () {
                var tourRunTime, tourStopStartTimes, player, tour, nStops, i;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.$wwt.inst === null)
                                throw new Error('cannot loadTour without linking to WWTInstance');
                            if (!play) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.$wwt.inst.loadAndPlayTour(url)];
                        case 1:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.$wwt.inst.loadTour(url)];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4:
                            tourRunTime = null;
                            tourStopStartTimes = [];
                            player = this.$wwt.inst.getActiveTourPlayer();
                            if (player !== null) {
                                tour = player.get_tour();
                                if (tour !== null) {
                                    tourRunTime = tour.get_runTime() * 0.001; // ms => s
                                    nStops = tour.get_tourStops().length;
                                    for (i = 0; i < nStops; i++) {
                                        tourStopStartTimes.push(tour.elapsedTimeTillTourstop(i));
                                    }
                                }
                            }
                            this.tourRunTime = tourRunTime;
                            this.tourStopStartTimes = tourStopStartTimes;
                            return [2 /*return*/];
                    }
                });
            });
        },
        /** Request the engine to load the specified image collection.
         *
         * The image collection is a [WTML file](https://docs.worldwidetelescope.org/data-guide/1/data-file-formats/collections/)
         * Images in collections loaded this way become usable for name-based lookup
         * by interfaces such as {@link setForegroundImageByName}.
         *
         * The action resolves to a [Folder](../../engine/classes/Folder.html) instance.
         * It’s asynchronous because the specified WTML file has to be downloaded.
         */
        loadImageCollection: function (_a) {
            var url = _a.url, loadChildFolders = _a.loadChildFolders;
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.$wwt.inst === null)
                                throw new Error('cannot loadImageCollection without linking to WWTInstance');
                            return [4 /*yield*/, this.$wwt.inst.loadImageCollection(url, loadChildFolders)];
                        case 1:
                            result = _b.sent();
                            this.availableImagesets = availableImagesets();
                            return [2 /*return*/, result];
                    }
                });
            });
        },
        /** Add an imageset directly into the engine's database.
         *
         * If an imageset with the same URL has already been loaded, this is a
         * no-op.
         *
         * This returns the imageset that ultimately resides in the engine's
         * database. It could either be the input argument, if it was newly added,
         * or a pre-existing imageset in the no-op condition.
         */
        addImagesetToRepository: function (imgset) {
            if (this.$wwt.inst === null)
                throw new Error('cannot addImagesetToRepository without linking to WWTInstance');
            return this.$wwt.inst.addImagesetToRepository(imgset);
        },
        // General layers
        /** Delete the specified layer from the layer manager.
         *
         * A layer may be identified by either its name or its [id](../../engine/classes/Layer.html#id).
         */
        deleteLayer: function (id) {
            if (this.$wwt.inst === null)
                throw new Error('cannot deleteLayer without linking to WWTInstance');
            var stringId = "";
            if (typeof id === "string") {
                stringId = id;
                var guid = engine_root_wwtlib_.Guid.fromString(id);
                this.$wwt.inst.lm.deleteLayerByID(guid, true, true);
            }
            else {
                stringId = id.toString();
                this.$wwt.inst.lm.deleteLayerByID(id, true, true);
            }
            // Mirror modification in the reactive system. Here we just
            // delete willy-nilly and ignore any missing cases.
            delete this.imagesetLayers[stringId];
            delete this.spreadSheetLayers[stringId];
            this.activeLayers = activeLayersList(this.$wwt);
        },
        // Imageset layers, including FITS layers
        /** Request the creation of a image layer. Either a single FITS or an image set.
         *
         * The action resolves to a new [ImageSetLayer](../../engine/classes/ImageSetLayer.html) instance.
         * It’s asynchronous because the requested url has to be downloaded.
         */
        addImageSetLayer: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var wwtLayer, guidText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.$wwt.inst === null)
                                throw new Error('cannot addImageSetLayer without linking to WWTInstance');
                            return [4 /*yield*/, this.$wwt.inst.addImageSetLayer(options)];
                        case 1:
                            wwtLayer = _a.sent();
                            guidText = wwtLayer.id.toString();
                            this.imagesetLayers[guidText] = new ImageSetLayerState(wwtLayer);
                            this.activeLayers = activeLayersList(this.$wwt);
                            return [2 /*return*/, wwtLayer];
                    }
                });
            });
        },
        /** Deprecated. Use addImageSetLayer instead.
         * Request the creation of a FITS image layer.
         *
         * The action resolves to a new [ImageSetLayer](../../engine/classes/ImageSetLayer.html) instance.
         * It’s asynchronous because the requested FITS file has to be downloaded.
         */
        loadFitsLayer: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var addImageSetLayerOptions;
                return __generator(this, function (_a) {
                    if (this.$wwt.inst === null)
                        throw new Error('cannot loadFitsLayer without linking to WWTInstance');
                    addImageSetLayerOptions = {
                        url: options.url,
                        mode: "fits",
                        name: options.name,
                        goto: options.gotoTarget
                    };
                    return [2 /*return*/, this.$wwt.inst.addImageSetLayer(addImageSetLayerOptions)];
                });
            });
        },
        /** Change the [ImageSetLayer](../../engine/classes/ImageSetLayer.html)
         * position in the draw cycle.
         */
        setImageSetLayerOrder: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setImageSetLayerOrder without linking to WWTInstance');
            this.$wwt.inst.setImageSetLayerOrder(options);
            this.activeLayers = activeLayersList(this.$wwt);
        },
        /** Alter the "stretch" of a FITS image layer according to
         * [the options](../../engine-helpers/interfaces/StretchFitsLayerOptions.html).
         */
        stretchFitsLayer: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot stretchFitsLayer without linking to WWTInstance');
            this.$wwt.inst.stretchFitsLayer(options);
            // Update the reactive mirror.
            var state = this.imagesetLayers[options.id];
            if (state) {
                state.scaleType = options.stretch;
                state.vmin = options.vmin;
                state.vmax = options.vmax;
            }
        },
        /** Set the colormap used for a FITS image layer according to
         * [the options](../../engine-helpers/interfaces/SetFitsLayerColormapOptions.html).
         */
        setFitsLayerColormap: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot setFitsLayerColormap without linking to WWTInstance');
            this.$wwt.inst.setFitsLayerColormap(options);
            // Update the reactive mirror.
            var state = this.imagesetLayers[options.id];
            if (state) {
                state.colormapName = options.name;
            }
        },
        /** Alter one or more settings of the specified FITS image layer as specified
         * in [the options](../../engine-helpers/interfaces/ApplyFitsLayerSettingsOptions.html).
         */
        applyFitsLayerSettings: function (options) {
            var e_5, _a;
            if (this.$wwt.inst === null)
                throw new Error('cannot applyFitsLayerSettings without linking to WWTInstance');
            this.$wwt.inst.applyFitsLayerSettings(options);
            // Update the reactive mirror.
            var state = this.imagesetLayers[options.id];
            if (state) {
                try {
                    for (var _b = tslib_es6_values(options.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var s = _c.value;
                        applyImageSetLayerSetting(state.settings, s);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        },
        // Spreadsheet layers
        /** Request the creation of a tabular data layer.
         *
         * The action resolves to a new [SpreadSheetLayer](../../engine/classes/SpreadSheetLayer.html) instance.
         */
        createTableLayer: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var layer, prom, wwtLayer, guidText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.$wwt.inst === null)
                                throw new Error('cannot createTableLayer without linking to WWTInstance');
                            layer = this.$wwt.inst.lm.createSpreadsheetLayer(options.referenceFrame, options.name, options.dataCsv);
                            // Value-add init copied from the pywwt JS component.
                            // Override any column guesses:
                            layer.set_lngColumn(-1);
                            layer.set_latColumn(-1);
                            layer.set_altColumn(-1);
                            layer.set_sizeColumn(-1);
                            layer.set_colorMapColumn(-1);
                            layer.set_startDateColumn(-1);
                            layer.set_endDateColumn(-1);
                            layer.set_xAxisColumn(-1);
                            layer.set_yAxisColumn(-1);
                            layer.set_zAxisColumn(-1);
                            layer.set_altUnit(AltUnits.meters);
                            layer.set_referenceFrame(options.referenceFrame);
                            if (options.referenceFrame == 'Sky') {
                                layer.set_astronomical(true);
                            }
                            prom = Promise.resolve(layer);
                            return [4 /*yield*/, prom];
                        case 1:
                            wwtLayer = _a.sent();
                            guidText = wwtLayer.id.toString();
                            this.spreadSheetLayers[guidText] = new SpreadSheetLayerState(wwtLayer);
                            this.activeLayers = activeLayersList(this.$wwt);
                            return [2 /*return*/, wwtLayer];
                    }
                });
            });
        },
        /** Alter one or more settings of the specified tabular data layers as specified
         * in [the options](../../engine-helpers/interfaces/ApplyTableLayerSettingsOptions.html).
         */
        applyTableLayerSettings: function (options) {
            var e_6, _a;
            if (this.$wwt.inst === null)
                throw new Error('cannot applyTableLayerSettings without linking to WWTInstance');
            this.$wwt.inst.applyTableLayerSettings(options);
            // Mirror changes in the reactive framework.
            var state = this.spreadSheetLayers[options.id];
            if (state !== undefined) {
                try {
                    for (var _b = tslib_es6_values(options.settings), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var s = _c.value;
                        applySpreadSheetLayerSetting(state, s);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        },
        /** Update the contents of a tabular data layer according to
         * [the options](../../engine-helpers/interfaces/UpdateTableLayerOptions.html).
         */
        updateTableLayer: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot updateTableLayer without linking to WWTInstance');
            this.$wwt.inst.updateTableLayer(options);
            // Nothing to mirror in reactive-land -- this call affects the table data.
        },
        // Progressive HiPS catalogs.
        //
        // These have some characteristics of imagesets, and some characteristics
        // of spreadsheet layers.
        /** Add a "catalog HiPS" dataset to the current view, by name.
         *
         * If the catalog name is not in the engine's registry, the promise rejects.
         */
        addCatalogHipsByName: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var imgset, hips, wwtLayer, guidText, info;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.$wwt.inst == null)
                                throw new Error('cannot addCatalogHipsByName without linking to WWTInstance');
                            return [4 /*yield*/, this.$wwt.inst.addCatalogHipsByName(options)];
                        case 1:
                            imgset = _a.sent();
                            hips = imgset.get_hipsProperties();
                            if (hips !== null) {
                                wwtLayer = hips.get_catalogSpreadSheetLayer();
                                guidText = wwtLayer.id.toString();
                                this.spreadSheetLayers[guidText] = new SpreadSheetLayerState(wwtLayer);
                                info = availableImagesets().find(function (x) { return x.name === options.name; });
                                if (info !== undefined) {
                                    info.id = guidText;
                                }
                            }
                            this.activeLayers = activeLayersList(this.$wwt);
                            return [2 /*return*/, imgset];
                    }
                });
            });
        },
        /** Request an export of the catalog HiPS data within the current viewport. */
        getCatalogHipsDataInView: function (options) {
            if (this.$wwt.inst == null)
                throw new Error('cannot getCatalogHipsDataInView without linking to WWTInstance');
            return this.$wwt.inst.getCatalogHipsDataInView(options);
        },
        /** Remove a "catalog HiPS" dataset to the current view, by name. */
        removeCatalogHipsByName: function (name) {
            if (this.$wwt.inst == null)
                throw new Error('cannot removeCatalogHipsByName without linking to WWTInstance');
            this.$wwt.inst.ctl.removeCatalogHipsByName(name);
            var id = engine_root_wwtlib_.Guid.createFrom(name).toString();
            delete this.spreadSheetLayers[id];
            this.activeLayers = activeLayersList(this.$wwt);
        },
        // Annotations
        /** Add an [Annotation](../../engine/classes/Annotation.html) to the view. */
        addAnnotation: function (ann) {
            if (this.$wwt.inst === null)
                throw new Error('cannot addAnnotation without linking to WWTInstance');
            this.$wwt.inst.si.addAnnotation(ann);
        },
        /** Remove the specified [Annotation](../../engine/classes/Annotation.html) from the view. */
        removeAnnotation: function (ann) {
            if (this.$wwt.inst === null)
                throw new Error('cannot removeAnnotation without linking to WWTInstance');
            this.$wwt.inst.si.removeAnnotation(ann);
        },
        /** Clear all [Annotations](../../engine/classes/Annotation.html) from the view. */
        clearAnnotations: function () {
            if (this.$wwt.inst === null)
                throw new Error('cannot clearAnnotations without linking to WWTInstance');
            this.$wwt.inst.si.clearAnnotations();
        },
        // Capturing the current display
        /** Capture the current frame as an image `Blob` with the desired width, height, and format.
         * The first argument is a callback function to execute on the created `Blob`. */
        captureFrame: function (options) {
            if (this.$wwt.inst === null)
                throw new Error('cannot captureThumbnail without linking to WWTInstance');
            return this.$wwt.inst.captureFrame(options);
        },
        /** Capture a video as a stream of image `Blob`s with the desired width, height and format.
         * The number of frames per second and total frame count are specified as well. */
        captureVideo: function (options) {
            if (this.$wwt.inst === null)
                throw new Error("cannot captureVideo without linking to WWTInstance");
            return this.$wwt.inst.captureVideo(options);
        },
        /** Clear the current cache of tiles.
          * The intended use case here is if a network issue caused a necessary tile to not load.
          * This should only be used when necessary, as any previously downloaded tiles will need
          * to be re-fetched.
          * */
        clearTileCache: function () {
            engine_root_wwtlib_.TileCache.clearCache();
        }
    },
});

;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Component.vue?vue&type=template&id=701e24aa&ts=true

var _hoisted_1 = ["id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        id: _ctx.uniqueId,
        class: "wwtelescope-component"
    }, null, 8, _hoisted_1));
}

;// CONCATENATED MODULE: ./src/Component.vue?vue&type=template&id=701e24aa&ts=true

;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Component.vue?vue&type=script&lang=ts





var idCounter = 0;
// Due to something weird about how TypeDoc is handling this, the docstring for
// this variable is in `shims-vue.d.ts`. That looks like it would be a problem
// if we had more than one SFC `.vue` file, but we don't.
/* harmony default export */ const Componentvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        // This was required for Vuex, but is no longer used with Pinia.
        wwtNamespace: { type: String, default: "wwt", required: false },
        wwtFreestandingAssetBaseurl: String,
        customId: String
    },
    data: function () {
        return {
            uniqueId: "",
            wwt: undefined,
            renderLoopId: undefined
        };
    },
    methods: __assign({}, mapActions(engineStore, [
        "internalIncrementTourCompletions",
        "internalLinkToInstance",
        "internalUnlinkFromInstance",
        "internalUpdate",
        "waitForReady",
    ])),
    created: function () {
        // Create a globally unique ID for the div that the WWT engine can latch onto.
        var uid = this.customId === undefined ? "wwtcmpt".concat(idCounter) : this.customId;
        Object.defineProperties(this, {
            uniqueId: { get: function () { return uid; } },
        });
        idCounter += 1;
    },
    mounted: function () {
        var _this = this;
        this.wwt = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.markRaw)(new WWTInstance({
            elId: this.uniqueId,
            startInternalRenderLoop: false,
            // Start at the Galactic Center by default. RA of the GC ~= 266.4 deg; in WWT, lng = 360 - RA.
            startLatDeg: -28.9,
            startLngDeg: 93.6,
            freestandingAssetBaseurl: this.wwtFreestandingAssetBaseurl,
        }));
        // TODO: The build fails with a TypeScript error without "as WWTInstance"
        // Figure out why!
        this.internalLinkToInstance(this.wwt);
        var render = function () {
            var wwt = _this.wwt;
            _this.renderLoopId = window.requestAnimationFrame(render);
            wwt.ctl.renderOneFrame();
            _this.internalUpdate();
        };
        // Wait for the WWT engine to signal readiness, then wait another tick, then
        // start the rendering loop. This way, if a user wants to do some
        // initialization that has to wait for the ready signal, we won't flash any
        // weirdly-initialized content.
        this.waitForReady().then(function () {
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)().then(function () {
                _this.renderLoopId = window.requestAnimationFrame(render);
            });
        });
        this.wwt.tourEndedCallback = (function (_tp) {
            _this.internalIncrementTourCompletions();
        });
    },
    unmounted: function () {
        if (this.renderLoopId !== undefined) {
            window.cancelAnimationFrame(this.renderLoopId);
            this.renderLoopId = undefined;
        }
        if (this.wwt !== undefined) {
            this.wwt.tourEndedCallback = null;
        }
        this.internalUnlinkFromInstance();
    }
}));

;// CONCATENATED MODULE: ./src/Component.vue?vue&type=script&lang=ts
 
// EXTERNAL MODULE: ../node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __nested_webpack_require_1513__(890);
;// CONCATENATED MODULE: ./src/Component.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(Componentvue_type_script_lang_ts, [['render',render]])

/* harmony default export */ const Component = (__exports__);
;// CONCATENATED MODULE: ./src/wwtaware.ts
// Copyright 2020-2023 the .NET Foundation
// Licensed under the MIT License




/** This is a helper base class for Vue components that wish to interact with a
 * {@link WWTComponent} through the Pinia state management system. It is only
 * recommended for using using Vue’s [“options API”][opt-api]. If you are
 * instead using the “composition API”, it is recommended to use
 * {@link engineStore} directly.
 *
 * [opt-api]: https://vuejs.org/guide/introduction.html#api-styles
 *
 * This class doesn’t implement any special functionality itself. All it does is
 * provide a set of state variables and methods that are pre-connected to [the
 * WWT Pinia interface][api-summary]. A component inheriting from this class can
 * use whichever ones it needs without having to set up that integration itself.
 * For that reason, **the detailed API associated with this class is
 * intentionally undocumented**, so that the in-depth documentation can be
 * centralized in one place: see [the API summary][api-summary] associated with
 * the {@link engineStore} function.
 *
 * [api-summary]: ../functions/engineStore.html#md:the-wwt-pinia-interface
 *
 * # Example
 *
 * Say that you are creating a simple WWT-powered app with a main `App.vue`
 * component that includes a WWT sub-component and a readout of the current
 * coordinates of the WWT view center. Your app Vue file might look like this:
 *
 * ```vue
 * <template>
 *   <div id="app">
 *     <WorldWideTelescope wwt-namespace="mywwt"></WorldWideTelescope>
 *     <p class="coord-overlay">{{ coordText }}</p>
 *   </div>
 * </template>
 *
 * <script lang="ts">
 *   import { defineComponent } from "vue";
 *   import { fmtDegLat, fmtHours } from "@wwtelescope/astro";
 *   import { WWTAwareComponent } from "@wwtelescope/engine-pinia";
 *
 *   export default App = defineComponent({
 *     extends: WWTAwareComponent, // <== we are extending WWTAwareComponent
 *
 *     computed: {
 *      coordText() {
 *        // We don't have to define `wwtRARad` and `wwtDecRad` ourselves:
 *        return `${fmtHours(this.wwtRARad)} ${fmtDegLat(this.wwtDecRad)}`;
 *      }
 *     }
 *   });
 * </script>
 * ```
 *
 * Because this component extends {@link WWTAwareComponent}, it automatically
 * has getters for {@link wwtRARad} and {@link wwtDecRad} that can be used to
 * set up the coordinate readout easily.
 *
 * Note that [the `extends` option is not recommended (or easily used) in the
 * Composition API][1], which is why it is recommended to use
 * {@link engineStore} directly instead.
 *
 * [1]: https://vuejs.org/api/options-composition.html#extends
 **/
var WWTAwareComponent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        /** This property is unused. It is retained for API compatibility from the
         * days of Vuex.
         */
        wwtNamespace: { type: String, default: "wwt", required: false },
        /** @hidden this was a mistake; keep it just in case */
        wwtFreestandingAssetBaseurl: String,
    },
    computed: __assign(__assign({}, mapState(engineStore, {
        wwtActiveLayers: 'activeLayers',
        wwtAvailableImagesets: 'availableImagesets',
        wwtBackgroundImageset: 'backgroundImageset',
        wwtCurrentTime: 'currentTime',
        wwtClockDiscontinuities: 'clockDiscontinuities',
        wwtClockRate: 'clockRate',
        wwtDecRad: 'decRad',
        wwtForegroundImageset: 'foregroundImageset',
        wwtForegroundOpacity: 'foregroundOpacity',
        wwtImagesetLayers: 'imagesetLayers',
        wwtIsTourPlayerActive: 'isTourPlayerActive',
        wwtIsTourPlaying: 'isTourPlaying',
        wwtRARad: 'raRad',
        wwtRenderType: 'renderType',
        wwtRollRad: 'rollRad',
        wwtShowWebGl2Warning: 'showWebGl2Warning',
        wwtSpreadSheetLayers: 'spreadSheetLayers',
        wwtTourCompletions: 'tourCompletions',
        wwtTourRunTime: 'tourRunTime',
        wwtTourStopStartTimes: 'tourStopStartTimes',
        wwtTourTimecode: 'tourTimecode',
        wwtZoomDeg: 'zoomDeg',
    })), mapState(engineStore, [
        "activeImagesetLayerStates",
        "findRADecForScreenPoint",
        "findScreenPointForRADec",
        "layerById",
        "imagesetForLayer",
        "imagesetLayerById",
        "imagesetStateForLayer",
        "layerForHipsCatalog",
        "lookupImageset",
        "spreadSheetLayerById",
        "spreadSheetLayer",
        "spreadsheetState",
        "spreadsheetStateById",
        "spreadsheetStateForHipsCatalog",
    ])),
    methods: __assign({}, mapActions(engineStore, [
        "addCatalogHipsByName",
        "createTableLayer",
        "getCatalogHipsDataInView",
        "gotoRADecZoom",
        "timeToRADecZoom",
        "gotoTarget",
        "loadImageCollection",
        "addImagesetToRepository",
        "loadFitsLayer",
        "addImageSetLayer",
        "loadTour",
        "stopTour",
        "closeTourPlayer",
        "viewAsTourXml",
        "waitForReady",
        // Formerly mutations
        "addAnnotation",
        "applyFitsLayerSettings",
        "applyTableLayerSettings",
        "applySetting",
        'captureFrame',
        'captureVideo',
        "clearAnnotations",
        "deleteLayer",
        "removeAnnotation",
        "removeCatalogHipsByName",
        "seekToTourTimecode",
        "setBackgroundImageByName",
        "setClockRate",
        "setClockSync",
        "setFitsLayerColormap",
        "setForegroundImageByName",
        "setForegroundOpacity",
        "setImageSetLayerOrder",
        "setTourPlayerLeaveSettingsWhenStopped",
        "setTime",
        "setTrackedObject",
        "setupForImageset",
        "startTour",
        "stretchFitsLayer",
        "toggleTourPlayPauseState",
        "updateTableLayer",
        //"updateAvailableImagesets",
        "zoom",
        "move",
        "tilt",
        "clearTileCache",
    ]))
});

;// CONCATENATED MODULE: ./src/index.ts
// Copyright 2020-2023 the .NET Foundation
// Licensed under the MIT License



// Finally, we define the `wwtPinia` thingie.


/** A Pinia instance customized for use in WWT-based applications.
 *
 * In most cases, you would use this variable in the following way while
 * initializing your Vue app:
 *
 * ```ts
 * import { createApp } from "vue";
 * import { wwtPinia, WWTComponent } from "@wwtelescope/engine-pinia";
 *
 * import MyApp from "./MyApp.vue";
 *
 * createApp(MyApp)
 *   .use(wwtPinia)
 *   .component("WorldWideTelescope", WWTComponent)
 *   .mount("#app");
 * ```
 *
 * Once you’ve activated the special WWT Pinia instance in this way, you can
 * interact with the WWT engine state via the {@link engineStore} interface.
 *
 * This Pinia instance is initialized with a special `$wwt` singleton value that
 * the {@link WWTComponent} uses to share global state with Pinia.
 */
var wwtPinia = createPinia();
wwtPinia.use(function (_a) {
    var store = _a.store;
    store.$wwt = new WWTGlobalState();
});

;// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.umd.js.map

/***/ }),

/***/ 210:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(278);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finder-scope{position:absolute;top:var(--top);left:var(--left);width:var(--width);background:transparent;color:hsla(0,0%,100%,.8);pointer-events:auto;padding:5px;min-height:var(--canvas-size);height:-moz-fit-content;height:fit-content;padding:0;pointer-events:none}.finder-scope .fs-header,.finder-scope .fs-info{margin-left:5px}.fs-moveable{position:absolute;top:0;left:0;width:calc(var(--width) - var(--canvas-size));height:calc(var(--canvas-size) - var(--header-height))}.fs-crosshairs{position:absolute;width:var(--canvas-size);height:var(--canvas-size);top:0;right:0}.fs-header{position:absolute;pointer-events:auto;top:calc(var(--canvas-size) - var(--header-height));left:0;background:var(--fs-background-color);width:calc(var(--width) - var(--canvas-size) - 4px);height:var(--header-height)}.fs-header a{margin-top:5px;height:-moz-fit-content;height:fit-content;display:inline-block}.fs-header img{border:1px solid gray;padding:2px;border-radius:2px}.fs-header .close-icon{position:absolute;top:7px;right:7px}.fs-header .close-icon:hover{cursor:pointer}.fs-info{pointer-events:auto;position:absolute;top:var(--canvas-size);left:0;background:var(--fs-background-color);width:var(--info-width)}.fs-info div{font-size:10pt;font-style:normal}.fs-buttons{display:flex;flex-direction:row;gap:10px}.fs-buttons button{background:transparent;border:1px solid var(--fs-crosshairs-color);border-radius:2px;color:#fff}.fs-buttons button:hover{background:#fff;color:var(--fs-background-color);cursor:pointer}.fs-values{display:grid;grid-template-rows:repeat(4,1fr);grid-template-columns:repeat(2,1fr);grid-auto-flow:column;-moz-column-gap:10px;column-gap:10px}.fs-values .fs-value{display:flex;justify-content:space-between}.fs-logos{margin-top:10px;display:flex;flex-direction:row;align-items:center}.fs-logos .icon-link img{width:36px;margin:2px}`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 716:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(278);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skyball{margin:2px auto;position:relative;height:var(--height);width:var(--width);border:solid 1px var(--ellipse-color);border-radius:50%;background-color:var(--background-color)}.skyball .v-ellipse{top:0;left:41%;height:100%;width:21%}.skyball .h-ellipse,.skyball .v-ellipse{position:absolute;border:solid 1px var(--ellipse-color);border-radius:50%}.skyball .h-ellipse{left:0;top:41%;width:100%;height:21%}.skyball .x-axis{position:absolute;border-bottom:solid 1px var(--axis-color);height:0;width:100%;top:50%;left:-1px}.skyball .y-axis{position:absolute;border-right:solid 1px var(--axis-color);width:0;height:100%;left:50%;top:-1px}`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 278:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 645:
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   j: () => (/* binding */ DefaultSearchDataProvider)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(629);
/* harmony import */ var _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(594);
/* harmony import */ var _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380);
/* harmony import */ var _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(771);




function rewriteURLs(item) {
    var thumbURL = item.get_thumbnailUrl();
    if (thumbURL) {
        item.set_thumbnailUrl(_wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.URLHelpers.singleton.rewrite(thumbURL, _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.URLRewriteMode.AsIfAbsolute));
    }
    var url = item.get_url();
    if (url) {
        item.set_url(_wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.URLHelpers.singleton.rewrite(url, _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.URLRewriteMode.AsIfAbsolute));
    }
}
function createPlace(searchPlace, constellation) {
    var place = new _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.Place();
    place.set_names([searchPlace.n]);
    place.set_dec(searchPlace.d);
    place.set_RA(searchPlace.r);
    var classification = searchPlace.c != null ? searchPlace.c : _wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .Classification */ .Jq.unidentified;
    place.set_classification(classification);
    place.set_constellation(constellation);
    place.set_type(_wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .ImageSetType */ .sI.sky);
    var zoom = searchPlace.z != null ? searchPlace.z : -1;
    place.set_zoomLevel(zoom);
    return place;
}
function createImageset(searchImageset) {
    var bandPass = (searchImageset.bp !== undefined) ? searchImageset.bp : _wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .BandPass */ .Hg.visible;
    var projection = (searchImageset.pr !== undefined) ? searchImageset.pr : _wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .ProjectionType */ .Q9.tan;
    var baseTileLevel = (searchImageset.bl !== undefined) ? searchImageset.bl : 0;
    var fileType = (searchImageset.ft !== undefined) ? searchImageset.ft : ".png";
    var tileLevels = (searchImageset.lv !== undefined) ? searchImageset.lv : 4;
    var bottomsUp = (searchImageset.bu !== undefined) ? searchImageset.bu : false;
    var quadTreeMap = (searchImageset.q !== undefined) ? searchImageset.q : "";
    var offsetX = (searchImageset.oX !== undefined) ? searchImageset.oX : 0;
    var offsetY = (searchImageset.oY !== undefined) ? searchImageset.oY : 0;
    var defaultSet = (searchImageset.ds !== undefined) ? searchImageset.ds : false; // "StockSet" in XML
    var rotation = (searchImageset.r !== undefined) ? searchImageset.r : 0;
    var widthFactor = (searchImageset.wf !== undefined) ? searchImageset.wf : 2;
    var imageset = new _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.Imageset();
    imageset.set_name(searchImageset.n);
    imageset.set_url(searchImageset.u);
    imageset.set_thumbnailUrl(searchImageset.tu);
    imageset.set_creditsText(searchImageset.ct);
    imageset.set_creditsUrl(searchImageset.cu);
    imageset.set_centerX(searchImageset.cX);
    imageset.set_centerY(searchImageset.cY);
    imageset.set_baseTileDegrees(searchImageset.bd);
    imageset.set_dataSetType(_wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .ImageSetType */ .sI.sky);
    imageset.set_bandPass(bandPass);
    imageset.set_projection(projection);
    imageset.set_baseLevel(baseTileLevel);
    imageset.set_extension(fileType);
    imageset.set_levels(tileLevels);
    imageset.set_bottomsUp(bottomsUp);
    imageset.set_quadTreeTileMap(quadTreeMap);
    imageset.set_offsetX(offsetX);
    imageset.set_offsetY(offsetY);
    imageset.set_defaultSet(defaultSet);
    imageset.set_rotation(rotation);
    imageset.set_widthFactor(widthFactor);
    imageset.set_sparse(true);
    imageset.set_elevationModel(false);
    imageset.set_demUrl("");
    imageset.set_altUrl("");
    imageset.set_referenceFrame("");
    imageset.set_meanRadius(0);
    imageset.set_baseTileDegrees(-1);
    imageset.set_imageSetID(imageset.getHashCode());
    return imageset;
}
var DefaultSearchDataProvider = /** @class */ (function () {
    function DefaultSearchDataProvider() {
        this._data = {};
        this._dataLoaded = false;
    }
    DefaultSearchDataProvider.prototype.loadDataIfNeeded = function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                if (!this._dataLoaded) {
                    return [2 /*return*/, this.fetchData().then(function (searchData) {
                            _this._data = _this.parseData(searchData);
                            _this._dataLoaded = true;
                        })];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    DefaultSearchDataProvider.prototype.fetchData = function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, void 0, function () {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                return [2 /*return*/, fetch(DefaultSearchDataProvider._dataUrl)
                        .then(function (res) { return res.text(); })
                        .then(function (text) {
                        var prunedText = text.slice(DefaultSearchDataProvider._prefix.length);
                        var js = "const x=".concat(prunedText, "; x");
                        return eval(js);
                    })];
            });
        });
    };
    DefaultSearchDataProvider.prototype.parseData = function (data) {
        var places = {};
        data.Constellations.forEach(function (info) {
            var constellation = info.name;
            var constellationPlaces = [];
            info.places.forEach(function (searchPlace) {
                var place = createPlace(searchPlace, constellation);
                var imagesetInfo = searchPlace.fgi;
                if (imagesetInfo) {
                    var imageset = createImageset(imagesetInfo);
                    place.set_studyImageset(imageset);
                    rewriteURLs(imageset);
                }
                if (constellation === "SolarSystem") {
                    place.set_target(_wwtelescope_engine_types__WEBPACK_IMPORTED_MODULE_2__/* .SolarSystemObjects */ .Pj.undefined);
                }
                rewriteURLs(place);
                constellationPlaces.push(place);
            });
            places[constellation] = constellationPlaces;
        });
        return places;
    };
    DefaultSearchDataProvider.prototype.placeForLocation = function (location) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, void 0, function () {
            var constellation, constellationPlaces, ssPlaces, con, searchPlaces, closestDist, closestPlace;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadDataIfNeeded()];
                    case 1:
                        _a.sent();
                        constellation = _wwtelescope_engine__WEBPACK_IMPORTED_MODULE_1__.Constellations.containment.findConstellationForPoint(location.raDeg * _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .D2H */ .zV, location.decDeg);
                        constellationPlaces = [];
                        ssPlaces = this._data["SolarSystem"];
                        for (con in this._data) {
                            if (con === constellation) {
                                constellationPlaces = this._data[constellation];
                            }
                        }
                        searchPlaces = ssPlaces.concat(constellationPlaces);
                        closestDist = null;
                        closestPlace = null;
                        searchPlaces.forEach(function (place) {
                            try {
                                var dist = (0,_wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .distance */ .Io)(place.get_RA() * _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .H2R */ .dt, place.get_dec() * _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .D2R */ .zq, location.raDeg * _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .D2R */ .zq, location.decDeg * _wwtelescope_astro__WEBPACK_IMPORTED_MODULE_0__/* .D2R */ .zq);
                                if ((!isNaN(dist)) && ((closestDist === null) || (dist < closestDist))) {
                                    closestPlace = place;
                                    closestDist = dist;
                                }
                            }
                            catch (error) {
                                if (place && place.get_name() !== "Earth") {
                                    console.warn(error);
                                }
                            }
                        });
                        return [2 /*return*/, closestPlace];
                }
            });
        });
    };
    DefaultSearchDataProvider._dataUrl = "https://web.wwtassets.org/data/searchdata_v2.min.js";
    DefaultSearchDataProvider._prefix = "wwt.searchData=";
    return DefaultSearchDataProvider;
}());



/***/ }),

/***/ 890:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.A = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(56)/* ["default"] */ .A)
var update = add("2ca961f7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 358:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(716);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(56)/* ["default"] */ .A)
var update = add("56f9bfb2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 56:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ addStylesClient)
});

;// CONCATENATED MODULE: ../node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ../node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 380:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__380__;

/***/ }),

/***/ 274:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__274__;

/***/ }),

/***/ 594:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Io: () => (/* binding */ distance),
/* harmony export */   NC: () => (/* binding */ fmtDegLat),
/* harmony export */   dX: () => (/* binding */ R2D),
/* harmony export */   dt: () => (/* binding */ H2R),
/* harmony export */   hL: () => (/* binding */ fmtHours),
/* harmony export */   p8: () => (/* binding */ formatSexagesimal),
/* harmony export */   y0: () => (/* binding */ formatDecimalHours),
/* harmony export */   zV: () => (/* binding */ D2H),
/* harmony export */   zq: () => (/* binding */ D2R)
/* harmony export */ });
/* unused harmony exports PI, TWOPI, R2H, H2D, angnorm, fmtDegLon */
// Copyright 2020 the .NET Foundation
// Licensed under the MIT License
/** The mathematical constant pi, around 3.14. */
var PI = 3.14159265358979;
/** Two times the mathematical constan pi, around 6.28. */
var TWOPI = 2 * PI;
/** Radians-to-degrees conversion factor.
 *
 * ```
 * let degrees = radians * R2D;
 * ```
 */
var R2D = 180 / PI;
/** Degrees-to-radians conversion factor.
 *
 * ```
 * let radians = degrees * D2R;
 * ```
 */
var D2R = PI / 180;
/** Radians-to-hours conversion factor.
 *
 * ```
 * let hours = radians * R2H;
 * ```
 */
var R2H = 12 / PI;
/** Hours-to-radians conversion factor.
 *
 * ```
 * let radians = hours * H2R;
 * ```
 */
var H2R = PI / 12;
/** Degrees-to-hours conversion factor.
 *
 * ```
 * let hours = degrees * D2H;
 * ```
 */
var D2H = 12. / 180;
/** Hours-to-degrees conversion factor.
 *
 * ```
 * let degrees = hours * H2D;
 * ```
 */
var H2D = 15;
/** Normalize an angle in radians to lie between 0 and 2pi.
 *
 * @param angleRad The input angle, in radians.
 * @returns An equivalent angle, also in radians.
 */
function angnorm(angleRad) {
    while (angleRad < 0)
        angleRad += TWOPI;
    while (angleRad >= TWOPI)
        angleRad -= TWOPI;
    return angleRad;
}
/**
 * Find the great-circle distance between two points
 *
 * This implementation uses a special case of the Vincenty formula
 * See the last formula in https://en.wikipedia.org/wiki/Great-circle_distance#Computational_formulas
 *
 * @param ra1 The right ascension of the first point, in radians
 * @param dec1 The declination of the first point, in radians
 * @param ra2 The right ascension of the second point, in radians
 * @param dec2 The declination of the second point, in radians
 * @returns The great-circle distance
 */
function distance(ra1, dec1, ra2, dec2) {
    var dAbsRA = Math.abs(ra1 - ra2);
    var nt1 = Math.pow((Math.cos(dec2) * Math.sin(dAbsRA)), 2);
    var nt2 = Math.pow((Math.cos(dec1) * Math.sin(dec2) - Math.sin(dec1) * Math.cos(dec2) * Math.cos(dAbsRA)), 2);
    var num = Math.sqrt(nt1 + nt2);
    var den = Math.sin(dec1) * Math.sin(dec2) + Math.cos(dec1) * Math.cos(dec2) * Math.cos(dAbsRA);
    return Math.atan2(num, den);
}
function formatSexagesimal(options) {
    var _a;
    var prefix = "";
    var value = options.value;
    if (value < 0) {
        value = -value;
        prefix = "-";
    }
    else if (options.showPlus) {
        prefix = "+";
    }
    var whole = Math.floor(value);
    value = (value - whole) * 60;
    var minutes = Math.floor(value);
    value = (value - minutes) * 60;
    var seconds = Math.floor(value);
    var remainder = value - seconds;
    var wText = String(whole).padStart(options.padWhole, '0');
    var mText = String(minutes).padStart(2, '0');
    var sText = String(seconds).padStart(2, '0');
    var rText = remainder.toFixed(options.precision).slice(1); // drop the leading "0"
    var suffix = (_a = options.suffix) !== null && _a !== void 0 ? _a : "";
    var sep1 = options.firstSeparator;
    var sep2 = options.secondSeparator;
    return "".concat(prefix).concat(wText).concat(sep1).concat(mText).concat(sep2).concat(sText).concat(rText).concat(suffix);
}
/** Format an angle, measured in radians, as sexagesimal hours.
 *
 * Before formatting, the angle is normalized to lie within 0-2pi.
 *
 * @param angleRad The angle in radians.
 * @param sep1 The text to put between the hours and the minutes. Defaults to
 * `":"`.
 * @param sep2 The text to put between the minutes and the seconds. Defaults to
 * `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtHours(angleRad, sep1, sep2, precision, suffix) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    if (suffix === void 0) { suffix = ""; }
    return formatSexagesimal({
        value: angnorm(angleRad) * R2H,
        showPlus: false,
        padWhole: 2,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
        suffix: suffix,
    });
}
/** Format a latitudinal angle, measured in radians, as sexagesimal degrees.
 *
 * If the number is not in the range [-pi, pi], `" ??${sep1}??${sep2}??"` is
 * returned.
 *
 * @param angleRad The latitude in radians.
 * @param sep1 The text to put between the degrees and the arcminutes. Defaults
 * to `":"`.
 * @param sep2 The text to put between the arcminutes and the arcseconds.
 * Defaults to `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtDegLat(angleRad, sep1, sep2, precision) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    if (angleRad < -PI || angleRad > PI)
        return " ??".concat(sep1, "??").concat(sep2, "??");
    return formatSexagesimal({
        value: angleRad * R2D,
        showPlus: true,
        padWhole: 2,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
    });
}
/** Format a longitudinal angle, measured in radians, as sexagesimal degrees.
 *
 * Before formatting, the angle is normalized to lie within 0-2pi. The output
 * will be zero-padded to three digits, e.g. `"000:01:30"` or `"359:59:59.123"`.
 *
 * @param angleRad The longitude in radians.
 * @param sep1 The text to put between the degrees and the arcminutes. Defaults
 * to `":"`.
 * @param sep2 The text to put between the arcminutes and the arcseconds.
 * Defaults to `":"`.
 * @param precision The number of places of decimal precision to include in the
 * result. Defaults to 0.
 * @returns The formatted angle.
 */
function fmtDegLon(angleRad, sep1, sep2, precision) {
    if (sep1 === void 0) { sep1 = ":"; }
    if (sep2 === void 0) { sep2 = ":"; }
    if (precision === void 0) { precision = 0; }
    return formatSexagesimal({
        value: angnorm(angleRad) * R2D,
        showPlus: false,
        padWhole: 3,
        firstSeparator: sep1,
        secondSeparator: sep2,
        precision: precision,
    });
}
function formatDecimalHours(dayFraction, sep) {
    if (sep === void 0) { sep = ":"; }
    // Looks like a timezone correction?
    var ts = new Date(new Date().toUTCString()).valueOf() - new Date().valueOf();
    var hr = ts / (1000 * 60 * 60);
    var day = (dayFraction - hr);
    while (day > 24) {
        day -= 24;
    }
    while (day < 0) {
        day += 24;
    }
    var hours = Math.floor(day);
    var minutes = ((day * 60) - (hours * 60)).toFixed(0);
    return [hours, minutes].map(function (n) { return n.toString().padStart(2, '0'); }).join(sep);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 771:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Hg: () => (/* binding */ BandPass),
/* harmony export */   Jq: () => (/* binding */ Classification),
/* harmony export */   Pj: () => (/* binding */ SolarSystemObjects),
/* harmony export */   Q9: () => (/* binding */ ProjectionType),
/* harmony export */   sI: () => (/* binding */ ImageSetType)
/* harmony export */ });
/* unused harmony exports AltTypes, AltUnits, CoordinatesType, DataTypes, FadeType, FolderGroup, FolderRefreshType, FolderType, MarkerScales, PlotTypes, PointScaleTypes, RAUnits, ReferenceFrames, ReferenceFrameTypes, ScaleTypes, isBaseEngineSetting, isBaseLayerSetting, isBaseImageSetLayerSetting, isBaseSpreadSheetLayerSetting, isBaseVoTableLayerSetting, enumLookup */
/* eslint-disable no-unused-vars */

// Copyright 2020-2021 the .NET Foundation
// Licensed under the MIT License
//
// Based types used in the WWT WebGL engine.
//
// Try to keep everything alphabetized.
var AltTypes;
(function (AltTypes) {
    AltTypes[AltTypes["depth"] = 0] = "depth";
    AltTypes[AltTypes["altitude"] = 1] = "altitude";
    AltTypes[AltTypes["distance"] = 2] = "distance";
    AltTypes[AltTypes["seaLevel"] = 3] = "seaLevel";
    AltTypes[AltTypes["terrain"] = 4] = "terrain";
})(AltTypes || (AltTypes = {}));
var AltUnits;
(function (AltUnits) {
    AltUnits[AltUnits["meters"] = 1] = "meters";
    AltUnits[AltUnits["feet"] = 2] = "feet";
    AltUnits[AltUnits["inches"] = 3] = "inches";
    AltUnits[AltUnits["miles"] = 4] = "miles";
    AltUnits[AltUnits["kilometers"] = 5] = "kilometers";
    AltUnits[AltUnits["astronomicalUnits"] = 6] = "astronomicalUnits";
    AltUnits[AltUnits["lightYears"] = 7] = "lightYears";
    AltUnits[AltUnits["parsecs"] = 8] = "parsecs";
    AltUnits[AltUnits["megaParsecs"] = 9] = "megaParsecs";
    AltUnits[AltUnits["custom"] = 10] = "custom";
})(AltUnits || (AltUnits = {}));
var BandPass;
(function (BandPass) {
    BandPass[BandPass["gamma"] = 0] = "gamma";
    BandPass[BandPass["xRay"] = 1] = "xRay";
    BandPass[BandPass["ultraviolet"] = 2] = "ultraviolet";
    BandPass[BandPass["visible"] = 3] = "visible";
    BandPass[BandPass["hydrogenAlpha"] = 4] = "hydrogenAlpha";
    BandPass[BandPass["IR"] = 4] = "IR";
    BandPass[BandPass["microwave"] = 5] = "microwave";
    BandPass[BandPass["radio"] = 6] = "radio";
    BandPass[BandPass["visibleNight"] = 6] = "visibleNight";
})(BandPass || (BandPass = {}));
var Classification;
(function (Classification) {
    Classification[Classification["star"] = 1] = "star";
    Classification[Classification["supernova"] = 2] = "supernova";
    Classification[Classification["blackHole"] = 4] = "blackHole";
    Classification[Classification["neutronStar"] = 8] = "neutronStar";
    Classification[Classification["doubleStar"] = 16] = "doubleStar";
    Classification[Classification["multipleStars"] = 32] = "multipleStars";
    Classification[Classification["asterism"] = 64] = "asterism";
    Classification[Classification["constellation"] = 128] = "constellation";
    Classification[Classification["openCluster"] = 256] = "openCluster";
    Classification[Classification["globularCluster"] = 512] = "globularCluster";
    Classification[Classification["nebulousCluster"] = 1024] = "nebulousCluster";
    Classification[Classification["nebula"] = 2048] = "nebula";
    Classification[Classification["emissionNebula"] = 4096] = "emissionNebula";
    Classification[Classification["planetaryNebula"] = 8192] = "planetaryNebula";
    Classification[Classification["reflectionNebula"] = 16384] = "reflectionNebula";
    Classification[Classification["darkNebula"] = 32768] = "darkNebula";
    Classification[Classification["giantMolecularCloud"] = 65536] = "giantMolecularCloud";
    Classification[Classification["supernovaRemnant"] = 131072] = "supernovaRemnant";
    Classification[Classification["interstellarDust"] = 262144] = "interstellarDust";
    Classification[Classification["quasar"] = 524288] = "quasar";
    Classification[Classification["galaxy"] = 1048576] = "galaxy";
    Classification[Classification["spiralGalaxy"] = 2097152] = "spiralGalaxy";
    Classification[Classification["irregularGalaxy"] = 4194304] = "irregularGalaxy";
    Classification[Classification["ellipticalGalaxy"] = 8388608] = "ellipticalGalaxy";
    Classification[Classification["knot"] = 16777216] = "knot";
    Classification[Classification["plateDefect"] = 33554432] = "plateDefect";
    Classification[Classification["clusterOfGalaxies"] = 67108864] = "clusterOfGalaxies";
    Classification[Classification["otherNGC"] = 134217728] = "otherNGC";
    Classification[Classification["unidentified"] = 268435456] = "unidentified";
    Classification[Classification["solarSystem"] = 536870912] = "solarSystem";
    Classification[Classification["unfiltered"] = 1073741823] = "unfiltered";
    Classification[Classification["stellar"] = 63] = "stellar";
    Classification[Classification["stellarGroupings"] = 2032] = "stellarGroupings";
    Classification[Classification["nebulae"] = 523264] = "nebulae";
    Classification[Classification["galactic"] = 133693440] = "galactic";
    Classification[Classification["other"] = 436207616] = "other";
})(Classification || (Classification = {}));
var CoordinatesType;
(function (CoordinatesType) {
    CoordinatesType[CoordinatesType["spherical"] = 0] = "spherical";
    CoordinatesType[CoordinatesType["rectangular"] = 1] = "rectangular";
    CoordinatesType[CoordinatesType["orbital"] = 2] = "orbital";
})(CoordinatesType || (CoordinatesType = {}));
var DataTypes;
(function (DataTypes) {
    DataTypes[DataTypes["byteT"] = 0] = "byteT";
    DataTypes[DataTypes["int16T"] = 1] = "int16T";
    DataTypes[DataTypes["int32T"] = 2] = "int32T";
    DataTypes[DataTypes["floatT"] = 3] = "floatT";
    DataTypes[DataTypes["doubleT"] = 4] = "doubleT";
    DataTypes[DataTypes["none"] = 5] = "none";
})(DataTypes || (DataTypes = {}));
var FadeType;
(function (FadeType) {
    FadeType[FadeType["fadeIn"] = 1] = "fadeIn";
    FadeType[FadeType["fadeOut"] = 2] = "fadeOut";
    FadeType[FadeType["both"] = 3] = "both";
    FadeType[FadeType["none"] = 4] = "none";
})(FadeType || (FadeType = {}));
var FolderGroup;
(function (FolderGroup) {
    FolderGroup[FolderGroup["explorer"] = 0] = "explorer";
    FolderGroup[FolderGroup["tour"] = 1] = "tour";
    FolderGroup[FolderGroup["search"] = 2] = "search";
    FolderGroup[FolderGroup["constellation"] = 3] = "constellation";
    FolderGroup[FolderGroup["view"] = 4] = "view";
    FolderGroup[FolderGroup["goTo"] = 5] = "goTo";
    FolderGroup[FolderGroup["community"] = 6] = "community";
    FolderGroup[FolderGroup["context"] = 7] = "context";
    FolderGroup[FolderGroup["voTable"] = 8] = "voTable";
    FolderGroup[FolderGroup["imageStack"] = 9] = "imageStack";
})(FolderGroup || (FolderGroup = {}));
var FolderRefreshType;
(function (FolderRefreshType) {
    FolderRefreshType[FolderRefreshType["interval"] = 0] = "interval";
    FolderRefreshType[FolderRefreshType["conditionalGet"] = 1] = "conditionalGet";
    FolderRefreshType[FolderRefreshType["viewChange"] = 2] = "viewChange";
})(FolderRefreshType || (FolderRefreshType = {}));
var FolderType;
(function (FolderType) {
    FolderType[FolderType["earth"] = 0] = "earth";
    FolderType[FolderType["planet"] = 1] = "planet";
    FolderType[FolderType["sky"] = 2] = "sky";
    FolderType[FolderType["panorama"] = 3] = "panorama";
})(FolderType || (FolderType = {}));
var ImageSetType;
(function (ImageSetType) {
    ImageSetType[ImageSetType["earth"] = 0] = "earth";
    ImageSetType[ImageSetType["planet"] = 1] = "planet";
    ImageSetType[ImageSetType["sky"] = 2] = "sky";
    ImageSetType[ImageSetType["panorama"] = 3] = "panorama";
    ImageSetType[ImageSetType["solarSystem"] = 4] = "solarSystem";
    ImageSetType[ImageSetType["sandbox"] = 5] = "sandbox";
})(ImageSetType || (ImageSetType = {}));
var MarkerScales;
(function (MarkerScales) {
    MarkerScales[MarkerScales["screen"] = 0] = "screen";
    MarkerScales[MarkerScales["world"] = 1] = "world";
})(MarkerScales || (MarkerScales = {}));
var PlotTypes;
(function (PlotTypes) {
    PlotTypes[PlotTypes["gaussian"] = 0] = "gaussian";
    PlotTypes[PlotTypes["point"] = 1] = "point";
    PlotTypes[PlotTypes["circle"] = 2] = "circle";
    PlotTypes[PlotTypes["square"] = 3] = "square";
    PlotTypes[PlotTypes["pushPin"] = 4] = "pushPin";
    PlotTypes[PlotTypes["custom"] = 5] = "custom";
})(PlotTypes || (PlotTypes = {}));
var PointScaleTypes;
(function (PointScaleTypes) {
    PointScaleTypes[PointScaleTypes["linear"] = 0] = "linear";
    PointScaleTypes[PointScaleTypes["power"] = 1] = "power";
    PointScaleTypes[PointScaleTypes["log"] = 2] = "log";
    PointScaleTypes[PointScaleTypes["constant"] = 3] = "constant";
    PointScaleTypes[PointScaleTypes["stellarMagnitude"] = 4] = "stellarMagnitude";
})(PointScaleTypes || (PointScaleTypes = {}));
var ProjectionType;
(function (ProjectionType) {
    ProjectionType[ProjectionType["mercator"] = 0] = "mercator";
    ProjectionType[ProjectionType["equirectangular"] = 1] = "equirectangular";
    ProjectionType[ProjectionType["tangent"] = 2] = "tangent";
    ProjectionType[ProjectionType["tan"] = 2] = "tan";
    ProjectionType[ProjectionType["toast"] = 3] = "toast";
    ProjectionType[ProjectionType["spherical"] = 4] = "spherical";
    ProjectionType[ProjectionType["skyImage"] = 5] = "skyImage";
    ProjectionType[ProjectionType["plotted"] = 6] = "plotted";
})(ProjectionType || (ProjectionType = {}));
var RAUnits;
(function (RAUnits) {
    RAUnits[RAUnits["hours"] = 0] = "hours";
    RAUnits[RAUnits["degrees"] = 1] = "degrees";
})(RAUnits || (RAUnits = {}));
var ReferenceFrames;
(function (ReferenceFrames) {
    ReferenceFrames[ReferenceFrames["sky"] = 0] = "sky";
    ReferenceFrames[ReferenceFrames["ecliptic"] = 1] = "ecliptic";
    ReferenceFrames[ReferenceFrames["galactic"] = 2] = "galactic";
    ReferenceFrames[ReferenceFrames["sun"] = 3] = "sun";
    ReferenceFrames[ReferenceFrames["mercury"] = 4] = "mercury";
    ReferenceFrames[ReferenceFrames["venus"] = 5] = "venus";
    ReferenceFrames[ReferenceFrames["earth"] = 6] = "earth";
    ReferenceFrames[ReferenceFrames["mars"] = 7] = "mars";
    ReferenceFrames[ReferenceFrames["jupiter"] = 8] = "jupiter";
    ReferenceFrames[ReferenceFrames["saturn"] = 9] = "saturn";
    ReferenceFrames[ReferenceFrames["uranus"] = 10] = "uranus";
    ReferenceFrames[ReferenceFrames["neptune"] = 11] = "neptune";
    ReferenceFrames[ReferenceFrames["pluto"] = 12] = "pluto";
    ReferenceFrames[ReferenceFrames["moon"] = 13] = "moon";
    ReferenceFrames[ReferenceFrames["io"] = 14] = "io";
    ReferenceFrames[ReferenceFrames["europa"] = 15] = "europa";
    ReferenceFrames[ReferenceFrames["ganymede"] = 16] = "ganymede";
    ReferenceFrames[ReferenceFrames["callisto"] = 17] = "callisto";
    ReferenceFrames[ReferenceFrames["custom"] = 18] = "custom";
    ReferenceFrames[ReferenceFrames["identity"] = 19] = "identity";
    ReferenceFrames[ReferenceFrames["sandbox"] = 20] = "sandbox";
})(ReferenceFrames || (ReferenceFrames = {}));
var ReferenceFrameTypes;
(function (ReferenceFrameTypes) {
    ReferenceFrameTypes[ReferenceFrameTypes["fixedSherical"] = 0] = "fixedSherical";
    ReferenceFrameTypes[ReferenceFrameTypes["orbital"] = 1] = "orbital";
    ReferenceFrameTypes[ReferenceFrameTypes["trajectory"] = 2] = "trajectory";
    ReferenceFrameTypes[ReferenceFrameTypes["synodic"] = 3] = "synodic";
})(ReferenceFrameTypes || (ReferenceFrameTypes = {}));
var ScaleTypes;
(function (ScaleTypes) {
    ScaleTypes[ScaleTypes["linear"] = 0] = "linear";
    ScaleTypes[ScaleTypes["log"] = 1] = "log";
    ScaleTypes[ScaleTypes["power"] = 2] = "power";
    ScaleTypes[ScaleTypes["squareRoot"] = 3] = "squareRoot";
    ScaleTypes[ScaleTypes["histogramEqualization"] = 4] = "histogramEqualization";
})(ScaleTypes || (ScaleTypes = {}));
var SolarSystemObjects;
(function (SolarSystemObjects) {
    SolarSystemObjects[SolarSystemObjects["sun"] = 0] = "sun";
    SolarSystemObjects[SolarSystemObjects["mercury"] = 1] = "mercury";
    SolarSystemObjects[SolarSystemObjects["venus"] = 2] = "venus";
    SolarSystemObjects[SolarSystemObjects["mars"] = 3] = "mars";
    SolarSystemObjects[SolarSystemObjects["jupiter"] = 4] = "jupiter";
    SolarSystemObjects[SolarSystemObjects["saturn"] = 5] = "saturn";
    SolarSystemObjects[SolarSystemObjects["uranus"] = 6] = "uranus";
    SolarSystemObjects[SolarSystemObjects["neptune"] = 7] = "neptune";
    SolarSystemObjects[SolarSystemObjects["pluto"] = 8] = "pluto";
    SolarSystemObjects[SolarSystemObjects["moon"] = 9] = "moon";
    SolarSystemObjects[SolarSystemObjects["io"] = 10] = "io";
    SolarSystemObjects[SolarSystemObjects["europa"] = 11] = "europa";
    SolarSystemObjects[SolarSystemObjects["ganymede"] = 12] = "ganymede";
    SolarSystemObjects[SolarSystemObjects["callisto"] = 13] = "callisto";
    SolarSystemObjects[SolarSystemObjects["ioShadow"] = 14] = "ioShadow";
    SolarSystemObjects[SolarSystemObjects["europaShadow"] = 15] = "europaShadow";
    SolarSystemObjects[SolarSystemObjects["ganymedeShadow"] = 16] = "ganymedeShadow";
    SolarSystemObjects[SolarSystemObjects["callistoShadow"] = 17] = "callistoShadow";
    SolarSystemObjects[SolarSystemObjects["sunEclipsed"] = 18] = "sunEclipsed";
    SolarSystemObjects[SolarSystemObjects["earth"] = 19] = "earth";
    SolarSystemObjects[SolarSystemObjects["custom"] = 20] = "custom";
    SolarSystemObjects[SolarSystemObjects["undefined"] = 65536] = "undefined";
})(SolarSystemObjects || (SolarSystemObjects = {}));
// I'm not aware of any smart TypeScripty way to automate the construction of this table :-(
var baseEngineSettingTypeInfo = {
    "actualPlanetScale/boolean": true,
    "constellations/boolean": true,
    "constellationBoundryColor/string": true,
    "constellationFigureColor/string": true,
    "constellationsEnabled/string": true,
    "constellationSelectionColor/string": true,
    "crosshairsColor/string": true,
    "earthCutawayView/boolean": true,
    //"fovCamera/number": true,  // skipping because not settable
    //"fovEyepiece/number": true,  // skipping because not settable
    //"fovTelescope/number": true,  // skipping because not settable
    "localHorizonMode/boolean": true,
    "galacticMode/boolean": true,
    "locationAltitude/number": true,
    "locationLat/number": true,
    "locationLng/number": true,
    "milkyWayModel/boolean": true,
    "showAltAzGrid/boolean": true,
    "showAltAzGridText/boolean": true,
    //"showClouds/boolean": true,  // skipping because not settable
    "showConstellations/boolean": true,
    "showConstellationBoundries/boolean": true,
    "showConstellationFigures/boolean": true,
    "showConstellationLabels/boolean": true,
    "showConstellationPictures/boolean": true,
    "showConstellationSelection/boolean": true,
    "showCrosshairs/boolean": true,
    "showEarthSky/boolean": true,
    "showEcliptic/boolean": true,
    "showEclipticCircle/boolean": true,
    "showEclipticGrid/boolean": true,
    "showEclipticGridText/boolean": true,
    "showEclipticOverviewText/boolean": true,
    "showElevationModel/boolean": true,
    "showEquatorialGridText/boolean": true,
    //"showFieldOfView/boolean": true,  // skipping because not settable
    "showGalacticGrid/boolean": true,
    "showGalacticGridText/boolean": true,
    "showGrid/boolean": true,
    "showHorizon/boolean": true,
    //"showHorizonPanorama/boolean": true,  // skipping because not settable
    "showISSModel/boolean": true,
    //"showMoonsAsPointSource/boolean": true,  // skipping because not settable
    "showPrecessionChart/boolean": true,
    "showSkyGrids/boolean": true,
    "showSkyNode/boolean": true,
    "showSkyOverlays/boolean": true,
    "showSkyOverlaysIn3d/boolean": true,
    "showSolarSystem/boolean": true,
    "smoothPan/boolean": true,
    "solarSystemCMB/boolean": true,
    "solarSystemCosmos/boolean": true,
    "solarSystemMilkyWay/boolean": true,
    "solarSystemOrbits/boolean": true,
    "solarSystemOverlays/boolean": true,
    "solarSystemLighting/boolean": true,
    "solarSystemMultiRes/boolean": true,
    "solarSystemMinorPlanets/boolean": true,
    "solarSystemMinorOrbits/boolean": true,
    "solarSystemPlanets/boolean": true,
    "solarSystemStars/boolean": true,
    "minorPlanetsFilter/number": true,
    "planetOrbitsFilter/number": true,
    "solarSystemScale/number": true,
};
/** Type guard function for BaseEngineSetting. */
function isBaseEngineSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in baseEngineSettingTypeInfo);
}
var baseLayerSettingTypeInfo = {
    "astronomical/boolean": true,
    "enabled/boolean": true,
    "fadeSpan/number": true,
    "name/string": true,
    "opacity/number": true,
    "opened/boolean": true,
    "referenceFrame/string": true,
    "version/number": true,
};
/** Type guard function for BaseLayerSetting. */
function isBaseLayerSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return key in baseLayerSettingTypeInfo;
}
var baseImageSetLayerSettingTypeInfo = {
    "colorMapperName/string": true,
    "overrideDefaultLayer/boolean": true,
};
/** Type guard function for BaseImageSetLayerSetting. */
function isBaseImageSetLayerSetting(obj) {
    var key = obj[0] + "/" + typeof obj[1];
    return (key in baseImageSetLayerSettingTypeInfo) || isBaseLayerSetting(obj);
}
// See implementation below -- we need to handle enums specially
// to make sure that inputs are in-range.
var baseSpreadSheetLayerSettingTypeInfo = {
    "altColumn/number": "",
    "altType/number": "AltTypes",
    "altUnit/number": "AltUnits",
    "barChartBitmask/number": "",
    "beginRange/Date": "",
    "cartesianCustomScale/number": "",
    "cartesianScale/number": "AltUnits",
    "colorMapColumn/number": "",
    "colorMapperName/string": "",
    "coordinatesType/number": "CoordinatesType",
    "decay/number": "",
    "dynamicColor/boolean": "",
    "dynamicData/boolean": "",
    "endDateColumn/number": "",
    "endRange/Date": "",
    "geometryColumn/number": "",
    "hyperlinkColumn/number": "",
    "hyperlinkFormat/string": "",
    "latColumn/number": "",
    "lngColumn/number": "",
    "markerColumn/number": "",
    "markerIndex/number": "",
    "markerScale/number": "",
    "nameColumn/number": "",
    "normalizeColorMap/boolean": "",
    "normalizeColorMapMax/number": "",
    "normalizeColorMapMin/number": "",
    "normalizeSize/boolean": "",
    "normalizeSizeClip/boolean": "",
    "normalizeSizeMax/number": "",
    "normalizeSizeMin/number": "",
    "plotType/number": "PlotTypes",
    "pointScaleType/number": "PointScaleTypes",
    "raUnits/number": "RAUnits",
    "scaleFactor/number": "",
    "showFarSide/boolean": "",
    "sizeColumn/number": "",
    "startDateColumn/number": "",
    "timeSeries/boolean": "",
    "xAxisColumn/number": "",
    "xAxisReverse/boolean": "",
    "yAxisColumn/number": "",
    "yAxisReverse/boolean": "",
    "zAxisColumn/number": "",
    "zAxisReverse/boolean": "",
};
/** Type guard function for BaseSpreadSheetLayerSetting. */
function isBaseSpreadSheetLayerSetting(obj) {
    if (isBaseLayerSetting(obj))
        return true;
    // We want to be able to properly recognize Date objects
    var type = obj[1] instanceof Date ? 'Date' : typeof obj[1];
    var key = obj[0] + "/" + type;
    var enumType = baseSpreadSheetLayerSettingTypeInfo[key];
    if (enumType === undefined) {
        return false;
    }
    else if (enumType == "") {
        return true;
    }
    else if (enumType == "AltTypes") {
        return obj[1] in AltTypes;
    }
    else if (enumType == "AltUnits") {
        return obj[1] in AltUnits;
    }
    else if (enumType == "CoordinatesType") {
        return obj[1] in CoordinatesType;
    }
    else if (enumType == "PlotTypes") {
        return obj[1] in PlotTypes;
    }
    else if (enumType == "PointScaleTypes") {
        return obj[1] in PointScaleTypes;
    }
    else if (enumType == "RAUnits") {
        return obj[1] in RAUnits;
    }
    else {
        throw new Error('internal bug isBaseSpreadSheetLayerSetting');
    }
}
// See implementation below -- we need to handle enums specially
// to make sure that inputs are in-range.
var baseVoTableLayerSettingTypeInfo = {
    "altColumn/number": "",
    "altType/number": "AltTypes",
    "altUnit/number": "AltUnits",
    "beginRange/Date": "",
    "cartesianCustomScale/number": "",
    "cartesianScale/number": "AltUnits",
    "colorMapColumn/number": "",
    "coordinatesType/number": "CoordinatesType",
    "dataSourceUrl/string": "",
    "decay/number": "",
    "dynamicData/boolean": "",
    "endDateColumn/number": "",
    "endRange/Date": "",
    "hyperlinkColumn/number": "",
    "hyperlinkFormat/string": "",
    "latColumn/number": "",
    "lngColumn/number": "",
    "markerColumn/number": "",
    "markerIndex/number": "",
    "markerScale/number": "",
    "nameColumn/number": "",
    "plotType/number": "PlotTypes",
    "pointScaleType/number": "PointScaleTypes",
    "raUnits/number": "RAUnits",
    "scaleFactor/number": "",
    "showFarSide/boolean": "",
    "sizeColumn/number": "",
    "startDateColumn/number": "",
    "timeSeries/boolean": "",
    "xAxisColumn/number": "",
    "xAxisReverse/boolean": "",
    "yAxisColumn/number": "",
    "yAxisReverse/boolean": "",
    "zAxisColumn/number": "",
    "zAxisReverse/boolean": "",
};
/** Type guard function for BaseVoTableLayerSetting. */
function isBaseVoTableLayerSetting(obj) {
    if (isBaseLayerSetting(obj))
        return true;
    var key = obj[0] + "/" + typeof obj[1];
    var enumType = baseVoTableLayerSettingTypeInfo[key];
    if (enumType === undefined) {
        return false;
    }
    else if (enumType == "") {
        return true;
    }
    else if (enumType == "AltTypes") {
        return obj[1] in AltTypes;
    }
    else if (enumType == "AltUnits") {
        return obj[1] in AltUnits;
    }
    else if (enumType == "CoordinatesType") {
        return obj[1] in CoordinatesType;
    }
    else if (enumType == "PlotTypes") {
        return obj[1] in PlotTypes;
    }
    else if (enumType == "PointScaleTypes") {
        return obj[1] in PointScaleTypes;
    }
    else if (enumType == "RAUnits") {
        return obj[1] in RAUnits;
    }
    else {
        throw new Error('internal bug isBaseVoTableLayerSetting');
    }
}
function keysOf(o) { return Object.keys(o); } // eslint-disable-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function enumLookup(stringEnum, s) {
    var e_1, _a;
    try {
        for (var _b = __values(keysOf(stringEnum)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var enumKey = _c.value;
            if (stringEnum[enumKey] === s) {
                return stringEnum[enumKey];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 629:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cl: () => (/* binding */ __assign),
/* harmony export */   YH: () => (/* binding */ __generator),
/* harmony export */   fX: () => (/* binding */ __spreadArray),
/* harmony export */   sH: () => (/* binding */ __awaiter),
/* harmony export */   zs: () => (/* binding */ __read)
/* harmony export */ });
/* unused harmony exports __extends, __rest, __decorate, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  DefaultSearchDataProvider: () => (/* reexport */ default_search/* DefaultSearchDataProvider */.j),
  FinderScope: () => (/* reexport */ FinderScope),
  Skyball: () => (/* reexport */ Skyball)
});

;// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

// EXTERNAL MODULE: ./src/default_search.ts
var default_search = __webpack_require__(238);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(629);
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(274);
;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/FinderScope.vue?vue&type=template&id=41e4c249&ts=true


var _hoisted_1 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("canvas", { class: "fs-crosshairs" }, null, -1);
var _hoisted_2 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", { class: "fs-moveable" }, null, -1);
var _hoisted_3 = { class: "fs-header" };
var _hoisted_4 = { class: "thumbnail" };
var _hoisted_5 = ["src"];
var _hoisted_6 = { class: "fs-info" };
var _hoisted_7 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("strong", null, "Classification:", -1);
var _hoisted_8 = { key: 0 };
var _hoisted_9 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("strong", null, "Constellation:", -1);
var _hoisted_10 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("strong", null, "Names:", -1);
var _hoisted_11 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("hr", null, null, -1);
var _hoisted_12 = {
    key: 1,
    class: "fs-values"
};
var _hoisted_13 = { class: "fs-value" };
var _hoisted_14 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "RA:", -1);
var _hoisted_15 = { class: "fs-value" };
var _hoisted_16 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Dec:", -1);
var _hoisted_17 = {
    key: 0,
    class: "fs-value"
};
var _hoisted_18 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Alt:", -1);
var _hoisted_19 = {
    key: 1,
    class: "fs-value"
};
var _hoisted_20 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Az:", -1);
var _hoisted_21 = {
    key: 2,
    class: "fs-value"
};
var _hoisted_22 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Rise:", -1);
var _hoisted_23 = { key: 0 };
var _hoisted_24 = { key: 1 };
var _hoisted_25 = {
    key: 3,
    class: "fs-value"
};
var _hoisted_26 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Transit:", -1);
var _hoisted_27 = {
    key: 4,
    class: "fs-value"
};
var _hoisted_28 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", null, "Set:", -1);
var _hoisted_29 = { key: 0 };
var _hoisted_30 = { key: 1 };
var _hoisted_31 = { key: 0 };
var _hoisted_32 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("strong", null, "Image Credit:", -1);
var _hoisted_33 = { class: "fs-buttons" };
var _hoisted_34 = { class: "fs-logos" };
var _hoisted_35 = ["alt", "href"];
var _hoisted_36 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_font_awesome_icon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("font-awesome-icon");
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        class: "finder-scope",
        style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.cssVars)
    }, [
        _hoisted_1,
        _hoisted_2,
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_3, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", _hoisted_4, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", { src: _ctx.thumbnail }, null, 8, _hoisted_5)
            ]),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_font_awesome_icon, {
                icon: "xmark",
                size: "lg",
                class: "close-icon",
                onKeyup: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)(_ctx.close, ["enter"]),
                onClick: _ctx.close
            }, null, 8, ["onKeyup", "onClick"])
        ]),
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_6, [
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [
                    _hoisted_7,
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.classification), 1)
                ]),
                (_ctx.isSurvey)
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_8, [
                        _hoisted_9,
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.constellation), 1)
                    ]))
                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [
                    _hoisted_10,
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.names), 1)
                ]),
                _hoisted_11,
                (_ctx.place && _ctx.isSurvey)
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_12, [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_13, [
                            _hoisted_14,
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatHms(_ctx.place.get_RA() * _ctx.H2R)), 1)
                        ]),
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_15, [
                            _hoisted_16,
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDegLat(_ctx.place.get_dec() * _ctx.D2R)), 1)
                        ]),
                        (_ctx.altAz)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_17, [
                                _hoisted_18,
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDegLat(_ctx.altAz.get_alt() * _ctx.D2R)), 1)
                            ]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                        (_ctx.altAz)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_19, [
                                _hoisted_20,
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(),
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDegAz(_ctx.altAz.get_az() * _ctx.D2R)), 1)
                            ]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                        (_ctx.riseSet)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_21, [
                                _hoisted_22,
                                (!_ctx.riseSet.bNeverRises)
                                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_23, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDecimal(_ctx.riseSet.rise)), 1))
                                    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_24, "N/A"))
                            ]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                        (_ctx.riseSet)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_25, [
                                _hoisted_26,
                                (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDecimal(_ctx.riseSet.transit)), 1)
                            ]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                        (_ctx.riseSet)
                            ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_27, [
                                _hoisted_28,
                                (_ctx.riseSet.bValid || _ctx.riseSet.bNeverRises)
                                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_29, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formatDecimal(_ctx.riseSet.set)), 1))
                                    : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_30, "N/A"))
                            ]))
                            : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
                    ]))
                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
            ]),
            (_ctx.credits)
                ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("h5", _hoisted_31, [
                    _hoisted_32,
                    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.credits), 1)
                ]))
                : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_33, [
                (_ctx.place)
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.showObject && _ctx.showObject.apply(_ctx, (0,tslib_es6/* __spreadArray */.fX)([], (0,tslib_es6/* __read */.zs)(args), false)));
                            })
                    }, " Show Object "))
                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                (_ctx.imageset != null)
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.setAsBackground && _ctx.setAsBackground.apply(_ctx, (0,tslib_es6/* __spreadArray */.fX)([], (0,tslib_es6/* __read */.zs)(args), false)));
                            })
                    }, " Set as background "))
                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true),
                (_ctx.imageset != null)
                    ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
                        key: 2,
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.setAsForeground && _ctx.setAsForeground.apply(_ctx, (0,tslib_es6/* __spreadArray */.fX)([], (0,tslib_es6/* __read */.zs)(args), false)));
                            })
                    }, " Set as foreground "))
                    : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)
            ]),
            (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_34, [
                ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.infoURLData, function (info, index) {
                    return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
                        key: index,
                        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(['icon-link', info.name]),
                        alt: info.alt,
                        href: info.url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, [
                        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                            src: info.img
                        }, null, 8, _hoisted_36)
                    ], 10, _hoisted_35));
                }), 128))
            ])
        ])
    ], 4)), [
        [external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.modelValue && _ctx.place]
    ]);
}

;// CONCATENATED MODULE: ./src/FinderScope.vue?vue&type=template&id=41e4c249&ts=true

;// CONCATENATED MODULE: ../node_modules/vue-demi/lib/index.mjs


var lib_isVue2 = false
var isVue3 = true
var Vue2 = (/* unused pure expression or super */ null && (undefined))

function install() {}

function lib_set(target, key, val) {
  if (Array.isArray(target)) {
    target.length = Math.max(target.length, key)
    target.splice(key, 1, val)
    return val
  }
  target[key] = val
  return val
}

function del(target, key) {
  if (Array.isArray(target)) {
    target.splice(key, 1)
    return
  }
  delete target[key]
}




;// CONCATENATED MODULE: ../node_modules/pinia/dist/pinia.mjs
/*!
 * pinia v2.1.7
 * (c) 2023 Eduardo San Martin Morote
 * @license MIT
 */



/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */
let activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */
// @ts-expect-error: cannot constrain the type of the return
const setActivePinia = (pinia) => (activePinia = pinia);
/**
 * Get the currently active pinia if there is any.
 */
const getActivePinia = () => (hasInjectionContext() && inject(piniaSymbol)) || activePinia;
const piniaSymbol = (( false) ? 0 : /* istanbul ignore next */ Symbol());

function isPlainObject(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return (o &&
        typeof o === 'object' &&
        Object.prototype.toString.call(o) === '[object Object]' &&
        typeof o.toJSON !== 'function');
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */
var MutationType;
(function (MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */
    MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */
    MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */
    MutationType["patchFunction"] = "patch function";
    // maybe reset? for $state = {} and $reset
})(MutationType || (MutationType = {}));

const IS_CLIENT = typeof window !== 'undefined';
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */
const USE_DEVTOOLS = (/* unused pure expression or super */ null && ( false && 0));

/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */
// The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const _global = /*#__PURE__*/ (() => typeof window === 'object' && window.window === window
    ? window
    : typeof self === 'object' && self.self === self
        ? self
        : typeof global === 'object' && global.global === global
            ? global
            : typeof globalThis === 'object'
                ? globalThis
                : { HTMLElement: null })();
function bom(blob, { autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom &&
        /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xfeff), blob], { type: blob.type });
    }
    return blob;
}
function download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function () {
        saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function () {
        console.error('could not download file');
    };
    xhr.send();
}
function corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    }
    catch (e) { }
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    }
    catch (e) {
        const evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const _navigator = 
 typeof navigator === 'object' ? navigator : { userAgent: '' };
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const isMacOSWebView = /*#__PURE__*/ (() => /Macintosh/.test(_navigator.userAgent) &&
    /AppleWebKit/.test(_navigator.userAgent) &&
    !/Safari/.test(_navigator.userAgent))();
const saveAs = !IS_CLIENT
    ? () => { } // noop
    : // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
        typeof HTMLAnchorElement !== 'undefined' &&
            'download' in HTMLAnchorElement.prototype &&
            !isMacOSWebView
            ? downloadSaveAs
            : // Use msSaveOrOpenBlob as a second approach
                'msSaveOrOpenBlob' in _navigator
                    ? msSaveAs
                    : // Fallback to using FileReader and a popup
                        fileSaverSaveAs;
function downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if (corsEnabled(a.href)) {
                download(blob, name, opts);
            }
            else {
                a.target = '_blank';
                click(a);
            }
        }
        else {
            click(a);
        }
    }
    else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function () {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function () {
            click(a);
        }, 0);
    }
}
function msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if (corsEnabled(blob)) {
            download(blob, name, opts);
        }
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function () {
                click(a);
            });
        }
    }
    else {
        // @ts-ignore: works on windows
        navigator.msSaveOrOpenBlob(bom(blob, opts), name);
    }
}
function fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) {
        popup.document.title = popup.document.body.innerText = 'downloading...';
    }
    if (typeof blob === 'string')
        return download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String(_global.HTMLElement)) || 'safari' in _global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || (force && isSafari) || isMacOSWebView) &&
        typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function () {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS
                ? url
                : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) {
                popup.location.href = url;
            }
            else {
                location.assign(url);
            }
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    }
    else {
        const url = URL.createObjectURL(blob);
        if (popup)
            popup.location.assign(url);
        else
            location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function () {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}

/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */
function toastMessage(message, type) {
    const piniaMessage = '🍍 ' + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') {
        // No longer available :(
        __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    }
    else if (type === 'error') {
        console.error(piniaMessage);
    }
    else if (type === 'warn') {
        console.warn(piniaMessage);
    }
    else {
        console.log(piniaMessage);
    }
}
function isPinia(o) {
    return '_a' in o && 'install' in o;
}

/**
 * This file contain devtools actions, they are not Pinia actions.
 */
// ---
function checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function checkNotFocusedError(error) {
    if (error instanceof Error &&
        error.message.toLowerCase().includes('document is not focused')) {
        toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function actionGlobalCopyState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        toastMessage('Global state copied to clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalPasteState(pinia) {
    if (checkClipboardAccess())
        return;
    try {
        loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        toastMessage('Global state pasted from clipboard.');
    }
    catch (error) {
        if (checkNotFocusedError(error))
            return;
        toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function actionGlobalSaveState(pinia) {
    try {
        saveAs(new Blob([JSON.stringify(pinia.state.value)], {
            type: 'text/plain;charset=utf-8',
        }), 'pinia-state.json');
    }
    catch (error) {
        toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let fileInput;
function getFileOpener() {
    if (!fileInput) {
        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject) => {
            fileInput.onchange = async () => {
                const files = fileInput.files;
                if (!files)
                    return resolve(null);
                const file = files.item(0);
                if (!file)
                    return resolve(null);
                return resolve({ text: await file.text(), file });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            fileInput.oncancel = () => resolve(null);
            fileInput.onerror = reject;
            fileInput.click();
        });
    }
    return openFile;
}
async function actionGlobalOpenStateFile(pinia) {
    try {
        const open = getFileOpener();
        const result = await open();
        if (!result)
            return;
        const { text, file } = result;
        loadStoresState(pinia, JSON.parse(text));
        toastMessage(`Global state imported from "${file.name}".`);
    }
    catch (error) {
        toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function loadStoresState(pinia, state) {
    for (const key in state) {
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) {
            Object.assign(storeState, state[key]);
        }
        else {
            // store is not instantiated, set the initial state
            pinia.state.value[key] = state[key];
        }
    }
}

function formatDisplay(display) {
    return {
        _custom: {
            display,
        },
    };
}
const PINIA_ROOT_LABEL = '🍍 Pinia (root)';
const PINIA_ROOT_ID = '_root';
function formatStoreForInspectorTree(store) {
    return isPinia(store)
        ? {
            id: PINIA_ROOT_ID,
            label: PINIA_ROOT_LABEL,
        }
        : {
            id: store.$id,
            label: store.$id,
        };
}
function formatStoreForInspectorState(store) {
    if (isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId) => ({
                editable: true,
                key: storeId,
                value: store.state.value[storeId],
            })),
            getters: storeNames
                .filter((id) => storeMap.get(id)._getters)
                .map((id) => {
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key) => {
                        getters[key] = store[key];
                        return getters;
                    }, {}),
                };
            }),
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key) => ({
            editable: true,
            key,
            value: store.$state[key],
        })),
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) {
        state.getters = store._getters.map((getterName) => ({
            editable: false,
            key: getterName,
            value: store[getterName],
        }));
    }
    if (store._customProperties.size) {
        state.customProperties = Array.from(store._customProperties).map((key) => ({
            editable: true,
            key,
            value: store[key],
        }));
    }
    return state;
}
function formatEventData(events) {
    if (!events)
        return {};
    if (Array.isArray(events)) {
        // TODO: handle add and delete for arrays and objects
        return events.reduce((data, event) => {
            data.keys.push(event.key);
            data.operations.push(event.type);
            data.oldValue[event.key] = event.oldValue;
            data.newValue[event.key] = event.newValue;
            return data;
        }, {
            oldValue: {},
            keys: [],
            operations: [],
            newValue: {},
        });
    }
    else {
        return {
            operation: formatDisplay(events.type),
            key: formatDisplay(events.key),
            oldValue: events.oldValue,
            newValue: events.newValue,
        };
    }
}
function formatMutationType(type) {
    switch (type) {
        case MutationType.direct:
            return 'mutation';
        case MutationType.patchFunction:
            return '$patch';
        case MutationType.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}

// timeline can be paused when directly changing the state
let isTimelineActive = true;
const componentStateTypes = (/* unused pure expression or super */ null && ([]));
const MUTATIONS_LAYER_ID = 'pinia:mutations';
const INSPECTOR_ID = 'pinia';
const { assign: assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */
const getStoreType = (id) => '🍍 ' + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */
function registerPiniaDevtools(app, pinia) {
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
    }, (api) => {
        if (typeof api.now !== 'function') {
            toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        }
        api.addTimelineLayer({
            id: MUTATIONS_LAYER_ID,
            label: `Pinia 🍍`,
            color: 0xe5df88,
        });
        api.addInspector({
            id: INSPECTOR_ID,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: () => {
                        actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state',
                },
                {
                    icon: 'content_paste',
                    action: async () => {
                        await actionGlobalPasteState(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard',
                },
                {
                    icon: 'save',
                    action: () => {
                        actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file',
                },
                {
                    icon: 'folder_open',
                    action: async () => {
                        await actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree(INSPECTOR_ID);
                        api.sendInspectorState(INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file',
                },
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId) => {
                        const store = pinia._s.get(nodeId);
                        if (!store) {
                            toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        }
                        else if (typeof store.$reset !== 'function') {
                            toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        }
                        else {
                            store.$reset();
                            toastMessage(`Store "${nodeId}" reset.`);
                        }
                    },
                },
            ],
        });
        api.on.inspectComponent((payload, ctx) => {
            const proxy = (payload.componentInstance &&
                payload.componentInstance.proxy);
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store) => {
                    payload.instanceData.state.push({
                        type: getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI
                            ? {
                                _custom: {
                                    value: toRaw(store.$state),
                                    actions: [
                                        {
                                            icon: 'restore',
                                            tooltip: 'Reset the state of this store',
                                            action: () => store.$reset(),
                                        },
                                    ],
                                },
                            }
                            : // NOTE: workaround to unwrap transferred refs
                                Object.keys(store.$state).reduce((state, key) => {
                                    state[key] = store.$state[key];
                                    return state;
                                }, {}),
                    });
                    if (store._getters && store._getters.length) {
                        payload.instanceData.state.push({
                            type: getStoreType(store.$id),
                            key: 'getters',
                            editable: false,
                            value: store._getters.reduce((getters, key) => {
                                try {
                                    getters[key] = store[key];
                                }
                                catch (error) {
                                    // @ts-expect-error: we just want to show it in devtools
                                    getters[key] = error;
                                }
                                return getters;
                            }, {}),
                        });
                    }
                });
            }
        });
        api.on.getInspectorTree((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                let stores = [pinia];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter
                    ? stores.filter((store) => '$id' in store
                        ? store.$id
                            .toLowerCase()
                            .includes(payload.filter.toLowerCase())
                        : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase()))
                    : stores).map(formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    // this could be the selected store restored for a different project
                    // so it's better not to say anything here
                    return;
                }
                if (inspectedStore) {
                    payload.state = formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload, ctx) => {
            if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === PINIA_ROOT_ID
                    ? pinia
                    : pinia._s.get(payload.nodeId);
                if (!inspectedStore) {
                    return toastMessage(`store "${payload.nodeId}" not found`, 'error');
                }
                const { path } = payload;
                if (!isPinia(inspectedStore)) {
                    // access only the state
                    if (path.length !== 1 ||
                        !inspectedStore._customProperties.has(path[0]) ||
                        path[0] in inspectedStore.$state) {
                        path.unshift('$state');
                    }
                }
                else {
                    // Root access, we can omit the `.value` because the devtools API does it for us
                    path.unshift('state');
                }
                isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload) => {
            if (payload.type.startsWith('🍍')) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) {
                    return toastMessage(`store "${storeId}" not found`, 'error');
                }
                const { path } = payload;
                if (path[0] !== 'state') {
                    return toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                }
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                isTimelineActive = true;
            }
        });
    });
}
function addStoreToDevtools(app, store) {
    if (!componentStateTypes.includes(getStoreType(store.$id))) {
        componentStateTypes.push(getStoreType(store.$id));
    }
    setupDevtoolsPlugin({
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes,
        app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true,
            },
            // useEmojis: {
            //   label: 'Use emojis in messages ⚡️',
            //   type: 'boolean',
            //   defaultValue: true,
            // },
        },
    }, (api) => {
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after, onError, name, args }) => {
            const groupId = runningActionId++;
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🛫 ' + name,
                    subtitle: 'start',
                    data: {
                        store: formatDisplay(store.$id),
                        action: formatDisplay(name),
                        args,
                    },
                    groupId,
                },
            });
            after((result) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: '🛬 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            result,
                        },
                        groupId,
                    },
                });
            });
            onError((error) => {
                activeAction = undefined;
                api.addTimelineEvent({
                    layerId: MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: '💥 ' + name,
                        subtitle: 'end',
                        data: {
                            store: formatDisplay(store.$id),
                            action: formatDisplay(name),
                            args,
                            error,
                        },
                        groupId,
                    },
                });
            });
        }, true);
        store._customProperties.forEach((name) => {
            watch(() => unref(store[name]), (newValue, oldValue) => {
                api.notifyComponentUpdate();
                api.sendInspectorState(INSPECTOR_ID);
                if (isTimelineActive) {
                    api.addTimelineEvent({
                        layerId: MUTATIONS_LAYER_ID,
                        event: {
                            time: now(),
                            title: 'Change',
                            subtitle: name,
                            data: {
                                newValue,
                                oldValue,
                            },
                            groupId: activeAction,
                        },
                    });
                }
            }, { deep: true });
        });
        store.$subscribe(({ events, type }, state) => {
            api.notifyComponentUpdate();
            api.sendInspectorState(INSPECTOR_ID);
            if (!isTimelineActive)
                return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: formatMutationType(type),
                data: assign$1({ store: formatDisplay(store.$id) }, formatEventData(events)),
                groupId: activeAction,
            };
            if (type === MutationType.patchFunction) {
                eventData.subtitle = '⤵️';
            }
            else if (type === MutationType.patchObject) {
                eventData.subtitle = '🧩';
            }
            else if (events && !Array.isArray(events)) {
                eventData.subtitle = events.type;
            }
            if (events) {
                eventData.data['rawEvent(s)'] = {
                    _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: events,
                    },
                };
            }
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: eventData,
            });
        }, { detached: true, flush: 'sync' });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = markRaw((newStore) => {
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: '🔥 ' + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: formatDisplay(store.$id),
                        info: formatDisplay(`HMR update`),
                    },
                },
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
        });
        const { $dispose } = store;
        store.$dispose = () => {
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
            api.getSettings().logStoreChanges &&
                toastMessage(`Disposed "${store.$id}" store 🗑`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree(INSPECTOR_ID);
        api.sendInspectorState(INSPECTOR_ID);
        api.getSettings().logStoreChanges &&
            toastMessage(`"${store.$id}" store installed 🆕`);
    });
}
let runningActionId = 0;
let activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */
function patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName) => {
        // use toRaw to avoid tracking #541
        storeActions[actionName] = toRaw(store)[actionName];
        return storeActions;
    }, {});
    for (const actionName in actions) {
        store[actionName] = function () {
            // the running action id is incremented in a before action hook
            const _actionId = runningActionId;
            const trackedStore = wrapWithProxy
                ? new Proxy(store, {
                    get(...args) {
                        activeAction = _actionId;
                        return Reflect.get(...args);
                    },
                    set(...args) {
                        activeAction = _actionId;
                        return Reflect.set(...args);
                    },
                })
                : store;
            // For Setup Stores we need https://github.com/tc39/proposal-async-context
            activeAction = _actionId;
            const retValue = actions[actionName].apply(trackedStore, arguments);
            // this is safer as async actions in Setup Stores would associate mutations done outside of the action
            activeAction = undefined;
            return retValue;
        };
    }
}
/**
 * pinia.use(devtoolsPlugin)
 */
function devtoolsPlugin({ app, store, options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) {
        return;
    }
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
    // Upgrade the HMR to also update the new actions
    const originalHotUpdate = store._hotUpdate;
    toRaw(store)._hotUpdate = function (newStore) {
        originalHotUpdate.apply(this, arguments);
        patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
    };
    addStoreToDevtools(app, 
    // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}

/**
 * Creates a Pinia instance to be used by the application
 */
function createPinia() {
    const scope = effectScope(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(() => ref({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = markRaw({
        install(app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            setActivePinia(pinia);
            if (!isVue2) {
                pinia._a = app;
                app.provide(piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(app, pinia);
                }
                toBeInstalled.forEach((plugin) => _p.push(plugin));
                toBeInstalled = [];
            }
        },
        use(plugin) {
            if (!this._a && !isVue2) {
                toBeInstalled.push(plugin);
            }
            else {
                _p.push(plugin);
            }
            return this;
        },
        _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state,
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (USE_DEVTOOLS && typeof Proxy !== 'undefined') {
        pinia.use(devtoolsPlugin);
    }
    return pinia;
}

/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */
const isUseStore = (fn) => {
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */
function patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in oldState) {
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) {
            continue;
        }
        const targetValue = newState[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            !isRef(subPatch) &&
            !isReactive(subPatch)) {
            newState[key] = patchObject(targetValue, subPatch);
        }
        else {
            // objects are either a bit more complex (e.g. refs) or primitives, so we
            // just set the whole thing
            if (isVue2) {
                set(newState, key, subPatch);
            }
            else {
                newState[key] = subPatch;
            }
        }
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */
function acceptHMRUpdate(initialUseStore, hot) {
    // strip as much as possible from iife.prod
    if (true) {
        return () => { };
    }
    return (newModule) => {
        const pinia = hot.data.pinia || initialUseStore._pinia;
        if (!pinia) {
            // this store is still not used
            return;
        }
        // preserve the pinia instance across loads
        hot.data.pinia = pinia;
        // console.log('got data', newStore)
        for (const exportName in newModule) {
            const useStore = newModule[exportName];
            // console.log('checking for', exportName)
            if (isUseStore(useStore) && pinia._s.has(useStore.$id)) {
                // console.log('Accepting update for', useStore.$id)
                const id = useStore.$id;
                if (id !== initialUseStore.$id) {
                    console.warn(`The id of the store changed from "${initialUseStore.$id}" to "${id}". Reloading.`);
                    // return import.meta.hot.invalidate()
                    return hot.invalidate();
                }
                const existingStore = pinia._s.get(id);
                if (!existingStore) {
                    console.log(`[Pinia]: skipping hmr because store doesn't exist yet`);
                    return;
                }
                useStore(pinia, existingStore);
            }
        }
    };
}

const noop = () => { };
function addSubscription(subscriptions, callback, detached, onCleanup = noop) {
    subscriptions.push(callback);
    const removeSubscription = () => {
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && getCurrentScope()) {
        onScopeDispose(removeSubscription);
    }
    return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback) => {
        callback(...args);
    });
}

const fallbackRunWithContext = (fn) => fn();
function mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) {
        patchToApply.forEach((value, key) => target.set(key, value));
    }
    // Handle Set instances
    if (target instanceof Set && patchToApply instanceof Set) {
        patchToApply.forEach(target.add, target);
    }
    // no need to go through symbols because they cannot be serialized anyway
    for (const key in patchToApply) {
        if (!patchToApply.hasOwnProperty(key))
            continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if (isPlainObject(targetValue) &&
            isPlainObject(subPatch) &&
            target.hasOwnProperty(key) &&
            !isRef(subPatch) &&
            !isReactive(subPatch)) {
            // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
            // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
            // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
            target[key] = mergeReactiveObjects(targetValue, subPatch);
        }
        else {
            // @ts-expect-error: subPatch is a valid value
            target[key] = subPatch;
        }
    }
    return target;
}
const skipHydrateSymbol = ( false)
    ? 0
    : /* istanbul ignore next */ Symbol();
const skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */
function skipHydrate(obj) {
    return isVue2
        ? // in @vue/composition-api, the refs are sealed so defineProperty doesn't work...
            /* istanbul ignore next */ skipHydrateMap.set(obj, 1) && obj
        : Object.defineProperty(obj, skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */
function shouldHydrate(obj) {
    return isVue2
        ? /* istanbul ignore next */ !skipHydrateMap.has(obj)
        : !isPlainObject(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
const { assign: pinia_assign } = Object;
function isComputed(o) {
    return !!(isRef(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
    const { state, actions, getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && ( true || 0)) {
            /* istanbul ignore if */
            if (isVue2) {
                set(pinia.state.value, id, state ? state() : {});
            }
            else {
                pinia.state.value[id] = state ? state() : {};
            }
        }
        // avoid creating a state in pinia.state.value
        const localState =  false
            ? // use ref() to unwrap refs inside state TODO: check if this is still necessary
                0
            : toRefs(pinia.state.value[id]);
        return pinia_assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
            if (false) {}
            computedGetters[name] = markRaw(computed(() => {
                setActivePinia(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */
                if (isVue2 && !store._r)
                    return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = pinia_assign({ actions: {} }, options);
    /* istanbul ignore if */
    if (false) {}
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true,
        // flush: 'post',
    };
    /* istanbul ignore else */
    if (false) {}
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && ( true || 0)) {
        /* istanbul ignore if */
        if (isVue2) {
            set(pinia.state.value, $id, {});
        }
        else {
            pinia.state.value[$id] = {};
        }
    }
    const hotState = ref({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        // reset the debugger events since patches are sync
        /* istanbul ignore else */
        if ((false)) {}
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: MutationType.patchFunction,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        else {
            mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: MutationType.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents,
            };
        }
        const myListenerId = (activeListener = Symbol());
        nextTick().then(() => {
            if (activeListener === myListenerId) {
                isListening = true;
            }
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore
        ? function $reset() {
            const { state } = options;
            const newState = state ? state() : {};
            // we use a patch to group all changes into one single subscription
            this.$patch(($state) => {
                pinia_assign($state, newState);
            });
        }
        : /* istanbul ignore next */
            ( false)
                ? 0
                : noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */
    function wrapAction(name, action) {
        return function () {
            setActivePinia(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            triggerSubscriptions(actionSubscriptions, {
                args,
                name,
                store,
                after,
                onError,
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
                // handle sync errors
            }
            catch (error) {
                triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) {
                return ret
                    .then((value) => {
                    triggerSubscriptions(afterCallbackList, value);
                    return value;
                })
                    .catch((error) => {
                    triggerSubscriptions(onErrorCallbackList, error);
                    return Promise.reject(error);
                });
            }
            // trigger after callbacks
            triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ markRaw({
        actions: {},
        getters: {},
        state: [],
        hotState,
    });
    const partialStore = {
        _p: pinia,
        // _s: scope,
        $id,
        $onAction: addSubscription.bind(null, actionSubscriptions),
        $patch,
        $reset,
        $subscribe(callback, options = {}) {
            const removeSubscription = addSubscription(subscriptions, callback, options.detached, () => stopWatcher());
            const stopWatcher = scope.run(() => watch(() => pinia.state.value[$id], (state) => {
                if (options.flush === 'sync' ? isSyncListening : isListening) {
                    callback({
                        storeId: $id,
                        type: MutationType.direct,
                        events: debuggerEvents,
                    }, state);
                }
            }, pinia_assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose,
    };
    /* istanbul ignore if */
    if (isVue2) {
        // start as non ready
        partialStore._r = false;
    }
    const store = reactive(( false) || USE_DEVTOOLS
        ? pinia_assign({
            _hmrPayload,
            _customProperties: markRaw(new Set()), // devtools custom properties
        }, partialStore
        // must be added later
        // setupStore
        )
        : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = (pinia._a && pinia._a.runWithContext) || fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(() => pinia._e.run(() => (scope = effectScope()).run(setup)));
    // overwrite existing actions to support $onAction
    for (const key in setupStore) {
        const prop = setupStore[key];
        if ((isRef(prop) && !isComputed(prop)) || isReactive(prop)) {
            // mark it as a piece of state to be serialized
            if (false) {}
            else if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && shouldHydrate(prop)) {
                    if (isRef(prop)) {
                        prop.value = initialState[key];
                    }
                    else {
                        // probably a reactive object, lets recursively assign
                        // @ts-expect-error: prop is unknown
                        mergeReactiveObjects(prop, initialState[key]);
                    }
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */
                if (isVue2) {
                    set(pinia.state.value[$id], key, prop);
                }
                else {
                    pinia.state.value[$id][key] = prop;
                }
            }
            /* istanbul ignore else */
            if ((false)) {}
            // action
        }
        else if (typeof prop === 'function') {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue =  false ? 0 : wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */
            if (isVue2) {
                set(setupStore, key, actionValue);
            }
            else {
                // @ts-expect-error
                setupStore[key] = actionValue;
            }
            /* istanbul ignore else */
            if ((false)) {}
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
        else if ((false)) {}
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */
    if (isVue2) {
        Object.keys(setupStore).forEach((key) => {
            set(store, key, setupStore[key]);
        });
    }
    else {
        pinia_assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        pinia_assign(toRaw(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: () => ( false ? 0 : pinia.state.value[$id]),
        set: (state) => {
            /* istanbul ignore if */
            if (false) {}
            $patch(($state) => {
                pinia_assign($state, state);
            });
        },
    });
    // add the hotUpdate before plugins to allow them to override it
    /* istanbul ignore else */
    if ((false)) {}
    if (USE_DEVTOOLS) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false,
        };
        ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((p) => {
            Object.defineProperty(store, p, pinia_assign({ value: store[p] }, nonEnumerable));
        });
    }
    /* istanbul ignore if */
    if (isVue2) {
        // mark the store as ready before plugins
        store._r = true;
    }
    // apply all plugins
    pinia._p.forEach((extender) => {
        /* istanbul ignore else */
        if (USE_DEVTOOLS) {
            const extensions = scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            }));
            Object.keys(extensions || {}).forEach((key) => store._customProperties.add(key));
            pinia_assign(store, extensions);
        }
        else {
            pinia_assign(store, scope.run(() => extender({
                store,
                app: pinia._a,
                pinia,
                options: optionsForPlugin,
            })));
        }
    });
    if (false) {}
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState &&
        isOptionsStore &&
        options.hydrate) {
        options.hydrate(store.$state, initialState);
    }
    isListening = true;
    isSyncListening = true;
    return store;
}
function defineStore(
// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === 'function';
    if (typeof idOrOptions === 'string') {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    }
    else {
        options = idOrOptions;
        id = idOrOptions.id;
        if (false) {}
    }
    function useStore(pinia, hot) {
        const hasContext = hasInjectionContext();
        pinia =
            // in test mode, ignore the argument provided as we can always retrieve a
            // pinia instance with getActivePinia()
            ( false ? 0 : pinia) ||
                (hasContext ? inject(piniaSymbol, null) : null);
        if (pinia)
            setActivePinia(pinia);
        if (false) {}
        pinia = activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) {
                createSetupStore(id, setup, options, pinia);
            }
            else {
                createOptionsStore(id, options, pinia);
            }
            /* istanbul ignore else */
            if ((false)) {}
        }
        const store = pinia._s.get(id);
        if (false) {}
        if (false) {}
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}

let mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */
function setMapStoreSuffix(suffix // could be 'Store' but that would be annoying for JS
) {
    mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */
function mapStores(...stores) {
    if (false) {}
    return stores.reduce((reduced, useStore) => {
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + mapStoreSuffix] = function () {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            reduced[key] = function () {
                return useStore(this.$pinia)[key];
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function () {
                const store = useStore(this.$pinia);
                const storeKey = keysOrMapper[key];
                // for some reason TS is unable to infer the type of storeKey to be a
                // function
                return typeof storeKey === 'function'
                    ? storeKey.call(this, store)
                    : store[storeKey];
            };
            return reduced;
        }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */
const mapGetters = (/* unused pure expression or super */ null && (mapState));
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapActions(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[key](...args);
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-expect-error
            reduced[key] = function (...args) {
                return useStore(this.$pinia)[keysOrMapper[key]](...args);
            };
            return reduced;
        }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */
function mapWritableState(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper)
        ? keysOrMapper.reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[key];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[key] = value);
                },
            };
            return reduced;
        }, {})
        : Object.keys(keysOrMapper).reduce((reduced, key) => {
            // @ts-ignore
            reduced[key] = {
                get() {
                    return useStore(this.$pinia)[keysOrMapper[key]];
                },
                set(value) {
                    // it's easier to type it here as any
                    return (useStore(this.$pinia)[keysOrMapper[key]] = value);
                },
            };
            return reduced;
        }, {});
}

/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */
function storeToRefs(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (isVue2) {
        // @ts-expect-error: toRefs include methods and others
        return toRefs(store);
    }
    else {
        store = toRaw(store);
        const refs = {};
        for (const key in store) {
            const value = store[key];
            if (isRef(value) || isReactive(value)) {
                // @ts-expect-error: the key is state or getter
                refs[key] =
                    // ---
                    toRef(store, key);
            }
        }
        return refs;
    }
}

/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */
const PiniaVuePlugin = function (_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate() {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */
                if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, '_provided', {
                        get: () => provideCache,
                        set: (v) => Object.assign(provideCache, v),
                    });
                }
                this._provided[piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */
                if (!this.$pinia) {
                    this.$pinia = pinia;
                }
                pinia._a = this;
                if (IS_CLIENT) {
                    // this allows calling useStore() outside of a component setup after
                    // installing pinia's plugin
                    setActivePinia(pinia);
                }
                if (USE_DEVTOOLS) {
                    registerPiniaDevtools(pinia._a, pinia);
                }
            }
            else if (!this.$pinia && options.parent && options.parent.$pinia) {
                this.$pinia = options.parent.$pinia;
            }
        },
        destroyed() {
            delete this._pStores;
        },
    });
};



// EXTERNAL MODULE: ../astro/dist/src/index.js
var dist_src = __webpack_require__(594);
// EXTERNAL MODULE: external {"amd":"@wwtelescope/engine","commonjs2":"@wwtelescope/engine","commonjs":"@wwtelescope/engine","root":"wwtlib"}
var engine_root_wwtlib_ = __webpack_require__(380);
// EXTERNAL MODULE: ../engine-pinia/dist/index.umd.js
var index_umd = __webpack_require__(197);
// EXTERNAL MODULE: ../engine-types/dist/src/index.js
var engine_types_dist_src = __webpack_require__(771);
;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/FinderScope.vue?vue&type=script&lang=ts







/* harmony default export */ const FinderScopevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    props: {
        modelValue: { type: Boolean, required: true },
        searchProvider: { type: Object, required: true },
        position: { type: Object, required: true },
    },
    data: function () {
        var canvasSize = 150;
        var width = 400;
        var alpha = Math.PI / 18;
        return {
            place: null,
            circle: null,
            crosshairsDrawn: false,
            crosshairsColor: "rgba(216, 216, 216, 0.5)",
            backgroundColor: "rgba(25, 30, 43, 0.7)",
            alpha: alpha,
            width: width,
            canvasSize: canvasSize,
            D2R: dist_src/* D2R */.zq,
            H2R: dist_src/* H2R */.dt,
        };
    },
    emits: {
        "update:modelValue": function (_value) { return true; },
        "place": function (_place) { return true; },
    },
    unmounted: function () {
        this.clearCircle();
    },
    methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, mapActions(index_umd.engineStore, [
        "addAnnotation",
        "addImagesetToRepository",
        "removeAnnotation",
        "gotoTarget",
        "setBackgroundImageByName",
        "setForegroundImageByName",
        "setForegroundOpacity",
    ])), { close: function () {
            this.$emit("update:modelValue", false);
        }, formatHms: function (angleRad) {
            return (0,dist_src/* fmtHours */.hL)(angleRad, "h", "m", 1, "s");
        }, formatDegLat: function (lat) {
            return (0,dist_src/* fmtDegLat */.NC)(lat);
        }, formatDegAz: function (az) {
            return (0,dist_src/* formatSexagesimal */.p8)({
                value: az * dist_src/* R2D */.dX,
                showPlus: false,
                padWhole: 2,
                firstSeparator: ":",
                secondSeparator: ":",
                precision: 0,
            });
        }, formatDecimal: function (hours) {
            return (0,dist_src/* formatDecimalHours */.y0)(hours);
        }, showObject: function () {
            if (this.place !== null) {
                this.gotoTarget({
                    place: this.place,
                    noZoom: false,
                    instant: false,
                    trackObject: true,
                });
            }
        }, setAsForeground: function () {
            if (this.imageset != null) {
                this.addImagesetToRepository(this.imageset);
                this.setForegroundImageByName(this.imageset.get_name());
                this.setForegroundOpacity(100);
            }
        }, setAsBackground: function () {
            if (this.imageset != null) {
                this.addImagesetToRepository(this.imageset);
                this.setBackgroundImageByName(this.imageset.get_name());
            }
        }, updateClosest: function () {
            var _this = this;
            var position = this.findRADecForScreenPoint({ x: this.position[0], y: this.position[1] });
            this.searchProvider.placeForLocation({ raDeg: position.ra, decDeg: position.dec }).then(function (place) {
                _this.place = place;
            });
        }, clearCircle: function () {
            if (this.circle !== null) {
                this.circle.set_opacity(0);
            }
        }, updateCircleForPlace: function (place) {
            if (place === null) {
                this.clearCircle();
                return;
            }
            var circle = this.circle !== null ? this.circle : new engine_root_wwtlib_.Circle();
            circle.set_id("finder-scope");
            circle.setCenter(place.get_RA() * 15, place.get_dec());
            circle.set_radius(0.22);
            circle.set_skyRelative(false);
            circle.set_lineWidth(3);
            circle.set_opacity(this.modelValue ? 1 : 0);
            if (this.circle === null) {
                this.circle = circle;
                this.addAnnotation(circle);
            }
        }, drawCrosshairs: function () {
            var canvas = this.$el.querySelector(".fs-crosshairs");
            canvas.height = this.canvasSize;
            canvas.width = this.canvasSize;
            var context = canvas.getContext("2d");
            if (context === null) {
                return;
            }
            var centerX = canvas.width / 2;
            var centerY = canvas.height / 2;
            var radius = this.circleRadius;
            var gap = this.canvasSize - 2 * this.circleRadius;
            context.strokeStyle = this.crosshairsColor;
            context.lineWidth = 1;
            context.beginPath();
            context.moveTo(gap, centerY + gap);
            context.lineTo(canvas.width - gap, centerY + gap);
            context.stroke();
            context.beginPath();
            context.moveTo(centerX + gap, gap);
            context.lineTo(centerX + gap, canvas.height - gap);
            context.stroke();
            context.strokeStyle = this.backgroundColor;
            context.fillStyle = "transparent";
            context.lineWidth = 4;
            context.beginPath();
            context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
            context.stroke();
            context.fillStyle = this.backgroundColor;
            context.strokeStyle = "transparent";
            context.lineWidth = 0;
            context.beginPath();
            context.arc(centerX, centerY, radius, 0.5 * Math.PI, Math.PI);
            context.lineTo(0, canvas.height);
            context.lineTo(centerX, canvas.height);
            context.fill();
            this.crosshairsDrawn = true;
        }, clearCrosshairs: function () {
            var canvas = this.$el.querySelector(".fs-crosshairs");
            if (canvas !== null) {
                var context_1 = canvas.getContext("2d");
                context_1 === null || context_1 === void 0 ? void 0 : context_1.clearRect(0, 0, canvas.width, canvas.height);
            }
            this.crosshairsDrawn = false;
        } }),
    computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, mapState(index_umd.engineStore, [
        "currentTime",
        "raRad",
        "decRad",
        "findRADecForScreenPoint",
        "zoomDeg",
    ])), { altAz: function () {
            if (!this.modelValue || this.place === null) {
                return null;
            }
            return engine_root_wwtlib_.Coordinates.equitorialToHorizon(engine_root_wwtlib_.Coordinates.fromRaDec(this.place.get_RA(), this.place.get_dec()), engine_root_wwtlib_.Coordinates.fromLatLng(this.wwtSettings.get_locationLat(), this.wwtSettings.get_locationLng()), this.currentTime);
        }, constellation: function () {
            var _a, _b;
            return engine_root_wwtlib_.Constellations.fullNames[(_b = (_a = this.place) === null || _a === void 0 ? void 0 : _a.get_constellation()) !== null && _b !== void 0 ? _b : ""];
        }, classification: function () {
            var _a, _b;
            var type = engine_types_dist_src/* Classification */.Jq[(_b = (_a = this.place) === null || _a === void 0 ? void 0 : _a.get_classification()) !== null && _b !== void 0 ? _b : engine_types_dist_src/* Classification */.Jq.unidentified];
            // I would prefer to do something like the following, but lookbehind isn't supported
            // for Safari <= 16.3. But all of our classification names are all letters, so this should be fine
            // const addSpaces = /(?<!^)([A-Z])/g;
            var addSpaces = /[a-zA-Z]([A-Z])/g;
            var cls = type.replace(addSpaces, " $1");
            return cls.charAt(0).toUpperCase() + cls.slice(1);
        }, credits: function () {
            var _a;
            return (_a = this.imageset) === null || _a === void 0 ? void 0 : _a.get_creditsText();
        }, imageset: function () {
            var _a, _b, _c;
            return (_b = (_a = this.place) === null || _a === void 0 ? void 0 : _a.get_backgroundImageset()) !== null && _b !== void 0 ? _b : (_c = this.place) === null || _c === void 0 ? void 0 : _c.get_studyImageset();
        }, thumbnail: function () {
            var _a, _b, _c;
            return (_b = (_a = this.place) === null || _a === void 0 ? void 0 : _a.get_thumbnailUrl()) !== null && _b !== void 0 ? _b : (_c = this.imageset) === null || _c === void 0 ? void 0 : _c.get_thumbnailUrl();
        }, isSurvey: function () {
            var _a;
            return ((_a = this.place) === null || _a === void 0 ? void 0 : _a.get_type()) == engine_types_dist_src/* ImageSetType */.sI.sky;
        }, names: function () {
            if (!this.place) {
                return "";
            }
            var names = this.place.get_names();
            return names.length > 0 ? names.join(", ") : this.place.get_name();
        }, queryStringName: function () {
            if (!this.place) {
                return "";
            }
            var nameSegments = this.place.get_name().split(";");
            var index = nameSegments.length > 1 ? 1 : 0;
            var name = encodeURIComponent(nameSegments[index]);
            return name.replace(/%20/g, "+");
        }, cssVars: function () {
            var left = this.position[0] - this.width + 0.5 * this.canvasSize;
            var top = this.position[1] - 0.5 * this.canvasSize;
            return {
                "--left": "".concat(left, "px"),
                "--top": "".concat(top, "px"),
                "--canvas-size": "".concat(this.canvasSize, "px"),
                "--header-height": "".concat(this.headerHeight, "px"),
                "--info-width": "".concat(this.infoWidth, "px"),
                "--width": "".concat(this.width, "px"),
                "--fs-background-color": this.backgroundColor,
                "--fs-crosshairs-color": this.crosshairsColor,
            };
        }, circleRadius: function () {
            return 0.5 * this.canvasSize - 2;
        }, infoWidth: function () {
            var deltaX = 0.5 * this.canvasSize * (1 - Math.cos(Math.PI / 2 + this.alpha));
            return this.width - deltaX;
        }, headerHeight: function () {
            return 0.5 * this.canvasSize * Math.abs(Math.sin(Math.PI - this.alpha) - Math.sin(Math.PI / 2 + this.alpha));
        }, riseSet: function () {
            if (this.place === null) {
                return null;
            }
            var type = 0;
            var offset = this.place.get_classification() == engine_types_dist_src/* Classification */.Jq.solarSystem ? 0 : 0.5;
            switch (this.place.get_name().toLowerCase()) {
                case "sun":
                    type = 1;
                    break;
                case "moon":
                    type = 2;
                    break;
                default:
                    type = 0;
                    break;
            }
            return engine_root_wwtlib_.AstroCalc.getRiseTransitSet(engine_root_wwtlib_.SpaceTimeController.get_jNow() + offset, this.wwtSettings.get_locationLat(), -this.wwtSettings.get_locationLng(), this.place.get_RA(), this.place.get_dec(), this.place.get_RA(), this.place.get_dec(), this.place.get_RA(), this.place.get_dec(), type);
        }, wwtSettings: function () {
            return engine_root_wwtlib_.Settings.get_active();
        }, infoURLData: function () {
            var _a, _b, _c, _d;
            return [
                {
                    name: "wikipedia",
                    img: "https://upload.wikimedia.org/wikipedia/en/8/80/Wikipedia-logo-v2.svg",
                    url: "https://wikipedia.org/wiki/Special:Search?search=".concat(this.queryStringName),
                    alt: "Look up on Wikipedia",
                },
                {
                    name: "ads",
                    img: "https://ui.adsabs.harvard.edu/help/img/bbb_assets/ads_partial_logo_dark_background.svg",
                    url: "https://ui.adsabs.harvard.edu/search/q=object:%22".concat(this.queryStringName, "%22"),
                    alt: "Look up on SAO/NASA ADS",
                },
                {
                    name: "simbad",
                    img: "https://cds.unistra.fr/img/cds/simbad.svg",
                    url: "https://simbad.u-strasbg.fr/simbad/sim-id?Ident=".concat(this.queryStringName),
                    alt: "Look up on SIMBAD",
                },
                {
                    name: "ned",
                    img: "https://www.ipac.caltech.edu/system/activities/logos/61/small/NED-small_copy.png",
                    url: "https://ned.ipac.caltech.edu/cgi-bin/nph-imgdata?objname=".concat(this.queryStringName),
                    alt: "Look up on NED",
                },
                {
                    name: "esasky",
                    img: "https://sky.esa.int/esasky/esasky_cl_7_3_9_2025_07_03T09_50_05Z/E36D5EC1618ABCDE1D2EAF66AE09752C.cache.png",
                    url: "http://sky.esa.int/?action=goto&target=".concat(((_b = (_a = this.place) === null || _a === void 0 ? void 0 : _a.get_RA()) !== null && _b !== void 0 ? _b : 0) * 15, "%20").concat((_d = (_c = this.place) === null || _c === void 0 ? void 0 : _c.get_dec()) !== null && _d !== void 0 ? _d : 0, "&hips=DSS2%20color&fov=").concat(this.zoomDeg / 6, "&cooframe=J2000&sci=true"),
                    alt: "View in ESASky",
                }
            ];
        } }),
    watch: {
        raRad: function (_ra) {
            if (this.modelValue) {
                this.updateClosest();
            }
        },
        decRad: function (_dec) {
            if (this.modelValue) {
                this.updateClosest();
            }
        },
        position: function (_location) {
            if (this.modelValue) {
                this.updateClosest();
            }
        },
        modelValue: function (value) {
            var _this = this;
            if (!value) {
                this.place = null;
            }
            this.$nextTick(function () {
                if (value && !_this.crosshairsDrawn) {
                    _this.drawCrosshairs();
                }
            });
        },
        place: function (newPlace) {
            this.updateCircleForPlace(newPlace);
            this.$emit("place", newPlace);
        }
    }
}));

;// CONCATENATED MODULE: ./src/FinderScope.vue?vue&type=script&lang=ts
 
// EXTERNAL MODULE: ../node_modules/vue-style-loader/index.js??clonedRuleSet-75.use[0]!../node_modules/css-loader/dist/cjs.js??clonedRuleSet-75.use[1]!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-75.use[2]!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-75.use[3]!../node_modules/less-loader/dist/cjs.js??clonedRuleSet-75.use[4]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/FinderScope.vue?vue&type=style&index=0&id=41e4c249&lang=less
var FinderScopevue_type_style_index_0_id_41e4c249_lang_less = __webpack_require__(408);
;// CONCATENATED MODULE: ./src/FinderScope.vue?vue&type=style&index=0&id=41e4c249&lang=less

// EXTERNAL MODULE: ../node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(890);
;// CONCATENATED MODULE: ./src/FinderScope.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(FinderScopevue_type_script_lang_ts, [['render',render]])

/* harmony default export */ const FinderScope = (__exports__);
;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Skyball.vue?vue&type=template&id=5ecae40c&ts=true

var Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_1 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", { class: "v-ellipse" }, null, -1);
var Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_2 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", { class: "h-ellipse" }, null, -1);
var Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_3 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", { class: "x-axis" }, null, -1);
var Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_4 = /*#__PURE__*/ (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", { class: "y-axis" }, null, -1);
var Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_5 = ["width", "height"];
function Skyballvue_type_template_id_5ecae40c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        class: "skyball",
        style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.cssVars)
    }, [
        Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_1,
        Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_2,
        Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_3,
        Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_4,
        (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("canvas", {
            ref: "canvas",
            class: "canvas",
            width: _ctx.size,
            height: _ctx.size
        }, null, 8, Skyballvue_type_template_id_5ecae40c_ts_true_hoisted_5)
    ], 4));
}

;// CONCATENATED MODULE: ./src/Skyball.vue?vue&type=template&id=5ecae40c&ts=true

;// CONCATENATED MODULE: ../node_modules/ts-loader/index.js??clonedRuleSet-83.use[0]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Skyball.vue?vue&type=script&lang=ts




/* harmony default export */ const Skyballvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    extends: index_umd.WWTAwareComponent,
    props: {
        size: { type: Number, default: 300 },
        boxColor: { type: String, default: "yellow" },
        axisColor: { type: String, default: "rgba(255, 255, 255, 0.4)", },
        backgroundColor: { type: String, default: "rgba(133, 133, 133, 0.7)", },
        ellipseColor: { type: String, default: "rgba(255, 255, 255, 0.6)", },
    },
    data: function () {
        return {
            context: null,
        };
    },
    mounted: function () {
        var _this = this;
        var canvas = this.$refs.canvas;
        this.context = this.context || canvas.getContext("2d");
        canvas.height = this.size;
        canvas.width = this.size;
        canvas.style.height = "".concat(this.size, "px");
        canvas.style.width = "".concat(this.size, "px");
        this.$watch(function (vm) { return [vm.wwtRARad, vm.wwtDecRad, vm.wwtZoomDeg, vm.wwtRollRad]; }, function (_value) { return _this.update(); });
    },
    methods: {
        update: function () {
            var _this = this;
            if (!this.context) {
                return;
            }
            var canvas = this.$refs.canvas;
            this.context.clearRect(0, 0, canvas.width, canvas.height);
            var sphereSize = canvas.height;
            var radius = sphereSize / 2;
            var factor = 0.5;
            var pointSize = factor * sphereSize;
            var centerF = { x: pointSize, y: pointSize };
            var center = { x: pointSize, y: pointSize };
            var points = [];
            var z = 0;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var wwtCanvas = engine_root_wwtlib_.WWTControl.singleton.canvas;
            var coordinates = [
                this.findRADecForScreenPoint({ x: 0, y: 0 }),
                this.findRADecForScreenPoint({ x: wwtCanvas.width, y: 0 }),
                this.findRADecForScreenPoint({ x: wwtCanvas.width, y: wwtCanvas.height }),
                this.findRADecForScreenPoint({ x: 0, y: wwtCanvas.height }),
            ];
            coordinates.forEach(function (coord) {
                if (!_this.context) {
                    return;
                }
                var corner = new engine_root_wwtlib_.Coordinates((coord.ra - 180) * dist_src/* D2R */.zq, coord.dec * dist_src/* D2R */.zq);
                var ptX = centerF.x - (Math.cos((corner.get_RA() + 6) / 12 * Math.PI) * Math.cos(corner.get_lat() * dist_src/* D2R */.zq) * radius);
                var ptY = centerF.y - (Math.sin(corner.get_lat() * dist_src/* D2R */.zq) * radius);
                var point = { x: ptX, y: ptY };
                points.push(point);
                z += (Math.sin((corner.get_RA() + 6) / 12 * Math.PI) * Math.cos(corner.get_lat() * dist_src/* D2R */.zq) * radius);
                _this.context.beginPath();
                _this.context.lineWidth = 1;
                _this.context.strokeStyle = _this.boxColor;
                _this.context.moveTo(center.x, center.y);
                _this.context.lineTo(point.x, point.y);
                _this.context.closePath();
                _this.context.stroke();
            });
            this.context.beginPath();
            this.context.lineWidth = 1;
            this.context.strokeStyle = this.boxColor;
            this.context.moveTo(points[0].x, points[0].y);
            points.slice(1).forEach(function (point) {
                var _a;
                (_a = _this.context) === null || _a === void 0 ? void 0 : _a.lineTo(point.x, point.y);
            });
            this.context.closePath();
            var opacity = z > 0 ? 0.9 : 0.5;
            this.context.fillStyle = "rgba(from ".concat(this.boxColor, " r g b / ").concat(opacity, ")");
            this.context.fill();
            this.context.stroke();
        }
    },
    computed: {
        cssVars: function () {
            return {
                "--width": "".concat(this.size, "px"),
                "--height": "".concat(this.size, "px"),
                "--axis-color": this.axisColor,
                "--background-color": this.backgroundColor,
                "--ellipse-color": this.ellipseColor,
            };
        }
    },
}));

;// CONCATENATED MODULE: ./src/Skyball.vue?vue&type=script&lang=ts
 
// EXTERNAL MODULE: ../node_modules/vue-style-loader/index.js??clonedRuleSet-75.use[0]!../node_modules/css-loader/dist/cjs.js??clonedRuleSet-75.use[1]!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-75.use[2]!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-75.use[3]!../node_modules/less-loader/dist/cjs.js??clonedRuleSet-75.use[4]!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Skyball.vue?vue&type=style&index=0&id=5ecae40c&lang=less
var Skyballvue_type_style_index_0_id_5ecae40c_lang_less = __webpack_require__(358);
;// CONCATENATED MODULE: ./src/Skyball.vue?vue&type=style&index=0&id=5ecae40c&lang=less

;// CONCATENATED MODULE: ./src/Skyball.vue




;


const Skyball_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(Skyballvue_type_script_lang_ts, [['render',Skyballvue_type_template_id_5ecae40c_ts_true_render]])

/* harmony default export */ const Skyball = (Skyball_exports_);
;// CONCATENATED MODULE: ./src/index.ts




;// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.umd.js.map